import jquery from 'jquery';
import 'jquery-validation';
// import 'jquery-ui/ui/widgets/tooltip';
import KsBtn, {ButtonGroup} from 'kpc/components/button';
import Dialog from 'kpc/components/dialog';

import {Component, Vue, Prop, Watch} from 'vue-property-decorator'

import {debounce, once} from "helpful-decorators";

import Tooltip from 'kpc/components/tooltip';
import Slider from 'kpc/components/slider';
import Spinner from 'kpc/components/spinner';
import pSelect, {OptionGroup, Option} from 'kpc/components/select';
import DateUtil from '../../services/common/DateUtil';
import pInput from 'kpc/components/input';

import commonAlert from '../../services/common/alert';
import cloudmarketDia from './cloudmarketDia/index.vue';
import snapCreateDia from './snapCreateDia/index.vue';
import Checkbox from 'kpc/components/checkbox';
import Message from 'kpc/components/message';
import HandleData from './handleData';
import Table, {TableColumn} from 'kpc/components/table';
import Pagination from 'kpc/components/pagination';
import * as commonConst from '../../store/common/constants';
import Radio from 'kpc/components/radio';
import moment from 'moment';
import azSearchDia from './azSearchDia/index.vue';
import * as _ from 'lodash';
import Card from 'kpc/components/card';

let debounceTimer = 10;
let calcPriceDebounceTimer = 200;

const $: any = jquery;

// rework components
import BillTypeConfig from '../rework/BillTypeConfig/index.vue'
import RegionConfig from '../rework/RegionConfig/index.vue'
import AzConfig from '../rework/AzConfig/index.vue'

import * as kecAPIs from '../../services/kec/apis/kec'
import * as iamAPIs from '../../services/kec/apis/iam'
import * as productService from '../../services/kec/product'
import * as regionService from '../../services/kec/region'


function getQueryString(name: string) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    let result = window.location.hash.split('?')[1] || '';
    let valid = result.match(reg);
    if (valid != null) {
        return decodeURIComponent(valid[2]);
    } else {
        return null;
    }
}


@Component({
    name: 'CreateView',
    components: {
        KsBtn,
        ButtonGroup,
        Dialog,
        Tooltip,
        pInput,
        pSelect,
        Option,
        Slider,
        cloudmarketDia,
        snapCreateDia,
        Checkbox,
        Spinner,
        Table,
        TableColumn,
        Pagination,
        OptionGroup,
        Radio,
        azSearchDia,


        // rework
        BillTypeConfig,
        RegionConfig,
        AzConfig,
        // ImageConfig
        Card,
    },
})
export default class NewStepCreateKec extends Vue {


    // 标记价格请求时间点，避免异步次序错乱导致页面价格异常
    calcuKecListPriceTimestamp: any = null

    userCurrency: string = '' //用户使用货币的方式
    SKIP: string = ''

    orderBills: readonly any[] = []
    newOrderBills: any[] = []

    bossRegionList: any[] = []
    newBossRegionList: any[] = []
    orderBill = 0
    azListForReworkComponent: any[] = []

    azList: any[] = []
    azCode = ''

    hasAz: boolean = false // rework: 这个字段没啥用了, 由于传递参数时还会出现，暂时保留；后续一起去掉

    kecTypeList: any[] = []

    // rework：所选机型的productTypeId，后续应该和选中的其他数据放在一个结构体里
    kecType: number = 0

    // rework 当前过滤条件下的机型数据集合，和上面的kecTypeObj区分
    kecObj: any = {}

    // rework: 所选机型的数据，后续改造为有明确字段的interface或class
    kecTypeObj: any = {}
    // rework 这个和上面的kectypeobj有什么区别？？？
    // 只用于传递给cloudmarketDia？？？
    kecinfo: any = {}

    cpuList: any[] = []
    memList: any[] = []

    // rework: 选中机型的cpu和mem，后续不再单独存字段，都放在所选机型的结构体里
    cpu: any = ''
    mem: any = ''
    hdd: any = ''

    // rework: 镜像也应该放到一个service去处理，通过函数判断输出哪些类型选型
    imageTypeList: any[] = [{
        name: this.$trans(`标准镜像`), //'标准镜像',
        imageType: 0
    }, {
        name: this.$trans(`自定义镜像`), //'自定义镜像',
        imageType: 1
    }, {
        name: this.$trans(`共享镜像`), //'共享镜像',
        imageType: 3
    }, {
        name: this.$trans(`镜像市场`), //'镜像市场',
        imageType: 4
    }]

    // rework 这些字段应该合并
    imageType = 0
    imageObj: any = {}
    isWindows = false
    isWin2008 = false
    isUbuntu = false

    osImageList: any[] = []
    diyImgList: any[] = []
    shareImgList: any[] = []
    GameImageList: any[] = [] //游戏镜像可以去掉了？

    osImageId: string = ''
    osRegionKey: string = ''
    SupportProductTypes: any[] = []
    SupportProductType: any = {}


    // service控制反转
    DateUtil = DateUtil
    regionService = regionService
    productService = productService


    systemDiskTypes: any[] = []
    systemDiskTypesCopy: any[] = []
    systemPerformances: any[] = []
    sysDiskObj: any = {}
    systemDisk: any = {} //系统盘
    systemDiskMax = 500
    systemDiskMin = 0
    systemDiskStep = 1
    systemDiskSize = 0
    systemDiskUnit = 'G'
    systemDiskObj: any = {}
    systemDiskType = ''
    systemDiskMap: any = {
        "Local_SSD": "ssd_systemDisks",
        "SSD2.0": "ebs_ssd2.0_systemDisks",
        "SSD3.0": "ebs_ssd3.0_systemDisks",
        "SATA2.0": "ebs_sata2.0_systemDisks",
        "ssd_disk": "ssd_systemDisks",
        "ssd_ebs": "ebs_ssd2.0_systemDisks",
        "EHDD": "ebs_ehdd_systemDisks",
        "ESSD": "ebs_essd_systemDisks",
    }
    sysPerformanceLevel:string = ''

    diskTypes: any[] = []


    generationList: any[] = []
    generation: any = ''
    oldEbsSnapList: any = {}
    diskObj: any = {}
    diskSize = 0
    cloneDiskSize = 50
    canSnapCreateDisk = true //是否展示快照开机功能
    regionKeyCheck = ''
    snapListLoading = false
    snapSearch = ''
    snapPage: any = {
        current: 1,
        totalRows: 0,
        rowsPerPage: 10
    }

    snapEbsPage: any = {
        current: 1,
        totalRows: 0,
        rowsPerPage: 10
    }
    snapInfo: any = {
        snapChoose: false,
        snapId: '',
        snapName: '',
        snapCpacity: ''
    }
    snapInfoClick: any = {
        snapId: '',
        snapName: '',
        snapCpacity: ''
    }

    snapBtnStatus = true
    isSnapCreateDisk = false //快照开机，控制弹框

    ebsDiskSizeList: any[] = []
    maxEbsNum = -1
    hadEbsDisk = 0
    ebsDiskObj: any = {}
    ebsDiskObjs: any[] = []
    ebsDiskTypes: any[] = [{
        title: this.$trans(`没有配置任何数据盘`),
        value: ''
    }]
    allDiskNameMap: any = {
        'Local_SSD': this.$trans(`本地SSD`),
        'SSD': this.$trans(`云硬盘2.0（SSD）`),
        'SATA': this.$trans(`云硬盘2.0（SATA）`),
        'SSD3.0': this.$trans(`云硬盘3.0（SSD）`),
        'EHDD': this.$trans(`高效云盘`), // 高效云盘
        'ESSD': this.$trans(`ESSD云硬盘`), // ESSD云盘
    }
    ebsNameMap: any = {
        'SSD': this.$trans(`云硬盘2.0（SSD）`),
        'SATA': this.$trans(`云硬盘2.0（SATA）`),
        'SSD3.0': this.$trans(`云硬盘3.0（SSD）`),
        'EHDD': this.$trans(`高效云盘`), // 高效云盘
        'ESSD': this.$trans(`ESSD云硬盘`), // ESSD云盘
    }
    isSoldOutEBS = false
    ebsSupportAll: any[] = []

    hasSpecialDiscount = false

    tryOrderMethod: any = {
        billTypeName: this.$trans(`试用`),
        billTypeId: 2017
    }
    memCollect: any = {}
    kecPrice = 0
    isShow = false
    gpuCollect: any = {}
    gpuList: any[] = []
    gpu: any = ''
    soldOutTypeList: any[] = []
    kecName: any = ''
    subnet: any = {}
    subnetId: any = ''
    // secgroup: any = {}
    secgroupId: any = ''
    ebsSupport: any[] = []
    // MaxReignSnap: any = ''
    snapNameMap: any = {
        'active': this.$trans(`完成`), //完成
        'restoring': this.$trans(`回滚中`), //回滚中
        'saving': this.$trans(`创建中`), //  创建中
        'unknown': this.$trans(`未知错误`), //未知状态
        'error': this.$trans(`错误`), //错误
        'queued': this.$trans(`排队中`), //排队中
        'deleted': this.$trans(`主机已删除`) //主机已删除
    }
    ebsSnaps: any[] = []
    ebsSnapList: any[] = []
    ebsSnapListClone: any[] = []
    isSnapCreateEbs = false
    isSnapCreateSysEbs = false
    snapEbsIdx = 0


    bindCloudServerDel: any[] = []
    isShowSlider = false //是否支持调整系统盘大小

    sourcePage = getQueryString('sourcePage') || ""
    diyImageId = ''
    diyRegionKey = ''
    diySupportUniversalHost = false
    diyIsEbsDiskImage = false
    diyDiskSizeOverflow = false
    diyAzList: any[] = []
    diyAvailabilityZone = ''


    theSameRegion = true //判断是否有对应的数据中心，即是否有权限
    baseKvmList: any[] = []
    loadDataNum = 0
    baseAllSelect: any[] = []
    shareimageSet: any[] = []
    isLocalImage = false
    startTempData: any = {} //实例启动模板信息
    showBuyVolume = true
    commonDiscountList: any[] = []
    hasCommonDiscount = false
    generationSoldOutArr: any[] = [] //系列下全部机型都售罄
    generationNotSoldOutArr: any[] = [] //系列下未全部机型都售罄

    delWithInsList: any[] = []
    isSupportHotUpgrade = false //当前镜像是否支持热升级
    hasPackageDiscount = false //是否套餐折扣
    architecture = 'x86'
    architectureList: any[] = []
    newArchitectureList: any[] = []

    // rework  默认值不是all，是'默认' ，还能传数字。。。。改成对象比较好
    searchCPU: string | number = 'all'
    searchMEM: string | number = 'all'
    searchIPV6 = 'all'


    supportipv6List: any[] = []
    sort = 'COMVM'
    sortList: any[] = []
    newSortList: any[] = []
    kecList: any[] = []
    isEnhance = false
    kecKey = ""
    isGpu = false
    soldoutArr: any[] = []
    isMoreOptions = true

    sortsSoldOutArr: any[] = []
    archSoldoutArr: any[] = []
    memSoldoutArr: any[] = []
    cpuSoldoutArr: any[] = []
    azSoldOutArr: any[] = [] //可用区下全部机型都售罄
    azNotSoldOutArr: any[] = [] //可用区下未全部机型都售罄
    ipv6SoldoutArr: any[] = []

    bidTypeList: any[] = [{
        title: this.$trans(`使用自动出价`), //'使用自动出价',
        value: 'auto',
        disabled: false
    }, {
        title: this.$trans(`设定您的最高出价（每实例/每小时）`), //'设定您的最高出价(每实例/每小时)',
        value: 'userset',
        disabled: false
    }]

    bidType = 'auto'
    ipv6TypeCodes: any = {}
    pageKecList: any[] = []
    iscloudMarket = false
    pageLanguage = 'zh'
    quotaMaxDisk = 0
    chartLoading = true
    userPrice: number = 0
    checkHistoryPrice = false
    SpotPrices: any[] = []

    series: any[] = [{
        name: `${this.$trans(`套餐规格市场价`)}`,
        data: []
    }, {
        name: `${this.$trans(`套餐规格原价`)}`,
        data: []
    }]

    option: any = {
        navigator: {
            enabled: false
        },
        scrollbar: {
            enabled: false
        },
        chart: {
            borderWidth: 0,
            type: 'line',
            spacingLeft: 40
        },
        xAxis: {
            labels: {
                align: 'center'
            },
            type: 'datetime',
            dateTimeLabelFormats: {
                day: '%Y-%m-%d %H:%M:%S'
            }
        },
        yAxis: {
            floor: 0,
            title: {
                // text: `${this.$trans(`实例规格价格`)}(${userCurrency}/${this.$trans(`小时`)})`,
                align: 'high',
                offset: 0,
                rotation: 270,
                y: 20,
                x: -55,
                style: {
                    color: '#ddd',
                    fontSize: '14px'
                }
            },
            opposite: false
        },
        plotOptions: {
            line: {
                marker: {
                    fillColor: '#FFFFFF',
                    lineWidth: 2,
                    lineColor: null,
                    enabled: true
                },
                dataGrouping: {
                    approximation: 'high',
                },
                tooltip: {
                    valueDecimals: 5,
                    xDateFormat: '%Y-%m-%d %H:%M:%S',
                    dateTimeLabelFormats: {
                        day: '%m-%d',
                        month: '%Y-%m'
                    },
                    headerFormat: '<span style="font-size: 12px;">{point.key}</span><br/><span style="visibility:hidden;font-size:2px">&nbsp</span><br/>',
                    pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}:{point.y}<br/><span style="visibility:hidden;font-size:2px">&nbsp</span><br/>',
                }
            }
        }
    }
    options: any = {}
    changeUserPrice = false
    showPriceColumns = true
    theSameConfigData: any = {} //相同配置信息
    specialDiscountList: any = [] //专属折扣列表
    isSnapShotPermission = true //用户是否开通快照服务
    snapShotPermission = false //是否勾选了快照服务的选项
    openSnapShotStatus = false //开通快照服务的弹窗显示状态
    ischooseImage = false
    assembledImageMetaNum = 0
    performanceLevels: any[] = []
    notSoldOutPerformanceLevels: any[] = []

    imageId = ''
    snapshotServiceStatusCode = -1
    snapShotTips = ''
    noAuth = false
    closeAzSearchData: any | null = null
    showBuyAreaSearch = false
    allSoldoutPackageMap = new Map()

    // rework 原本放在state里的字段
    tryMoney = 0 //state => state.__pbc__.step1.kecTryOrder,
    disCountObj: any = {} // disCountObj: state => state.__pbc__.step1.disCountObj,
    kecData: any = {} // kecData: state => state.__pbc__.step1.kecData,
    RootSizeQuota: any = {} // RootSizeQuota: state => state.__pbc__.step1.RootSizeQuota,
    soldoutList: any[] = [] // soldoutList: state => state.__pbc__.step1.soldoutList,
    regionInfos: any = {} // regionInfos: state => state.__pbc__.step1.regionInfos,
    osImages: any = {} // osImages: state => state.__pbc__.step1.osImages,
    pTypeConfig: any[] = [] // pTypeConfig: state => state.__pbc__.step1.pTypeConfig,
    ProjectIds: string = '' // 赋值的时候ids的数据已经join过了

    snapList: any[] = [] // snapList: state => state.__pbc__.step1.snapList,
    snapTotal = 0 // snapTotal: state => state.__pbc__.step1.snapTotal,

    tipLock = true

    describeEbsPerfQuotasObj = {}
    canAddEbsNum = 0

    performanceList: any[] = [
        {
            label: `${this.$trans(`标准型`)}`,
            value: 'standard'
        },
        {
            label: `${this.$trans(`增强型`)}`,
            value: 'enhance'
        }
    ]
    performanceModel: string = 'standard'
    supportPerformanceLevelsList: any[] = []
    isSupportESSD = false
    isExistSupportESSD = false;
    deviceDiskNum: number = 1
    imageSysDisk:number = 0 // 镜像中带的系统盘大小值
    showBillTips = true

    @Prop({
        type: String,
    })
    regionKey = ''


    // 是否容器
    @Prop({
        type: Boolean,
        default: false,
    })
    isCluster = false

    // 是否弹性伸缩
    @Prop({
        default: false,
        required: false,
    })
    isAs = false

    // 容器配置
    @Prop({
        type: Object,
        default: () => {
            return {}
        },
        required: false
    })
    cluNet: any = {}


    // 容器配置
    @Prop({
        type: Array,
        default: () => {
            return []
        },
        required: false

    })
    secNet: any[] = []

    // 容器配置
    @Prop({
        type: Array,
        default: () => {
            return []
        },
        required: false
    })
    secGroup: any[] = []

    // 全局变量
    @Prop({
        type: Object,
        default: () => {
            return {}
        },
        required: false
    })
    locals: any = {}

    // 只展示通用配置(所有需要指定用户查询的配置都不展示，主要用户价格计算器等项目)
    @Prop({
        type: Boolean,
        default: false,
        required: false
    })
    onlyCommonConfig = false

    @Prop({
        type: Number,
        default: 1,
        required: false
    })
    kecCount = 1


    @Prop({
        type: String,
        default: '1',
        required: false
    })
    duration = '1'

    @Prop({
        type: Number,
        default: 1,
        required: true
    })
    tryOrderDay = 1

    @Prop({
        type: Object,
        default: () => {
            return {}
        },
        required: false
    })
    computedPrice: any = {}


    mounted() {
        let me = this;
        me.$nextTick(() => {
            $.extend($.validator.messages, {
                required: function () {
                    return me.$trans(`必须填写`);
                },
                remote: function () {
                    return me.$trans(`验证不通过`);
                },
                range: function () {
                    return me.$trans(`此数据盘范围仅支持{0}-{1}`, arguments[0][0], arguments[0][1]);
                }, //请输入 {0} 至 {1} 之间的数
                step: function () {
                    return me.$trans(`请输入{0}的倍数`, arguments[0]);
                }, //请输入{0} 的倍数数
                digits: function () {
                    return me.$trans(`只可输入整数`);
                }, //只可输入整数
                number: function () {
                    return me.$trans(`请输入正确的数字`);
                },
            })
        });
    }

    created() {
        //获取用户使用货币的方式
        if (window.__ksStorage__) {
            __ksStorage__.getBaseInfo('userInfo', (info: any) => {
                this.userCurrency = _.get(info, 'user.currency.symbol', '￥');
            });
        }
        this.SKIP = _.get(window, 'KSC_SECNET_CONSOLE.BASE_HOST', 'console.ksyun.com');
        this.soldOutTypeList = [111]; //售罄,强类型比较

        //只有实例列表页展示 可购买地区查询按钮
        this.showBuyAreaSearch = this.$route.name === 'CreateView'

        // 获取页面当前语言
        this.pageLanguage = _.get(window, 'KSC_SECNET_CONSOLE.LANG', 'zh');

        this.changeBuyData()
    }


    _getProList() {
        return iamAPIs.GetAccountProjectList({
            params: {
                Region: 'cn-qingyangtest-1',
                type: 'DescribeInstances'
            }
        }).then((res: any) => {
            let projList = _.get(res, 'ListProjectResult.ProjectList', [])
            this.ProjectIds = _.map(projList, item => {
                return item.ProjectId
            }).join(',')
        })
    }

    openAzSearchDia() {
        (this.$refs.azSearchDia as any).start()
    }

    closeAzSearchDia(val: any) {
        if (val) {
            this.orderBill = val.billTypeId
            this.regionKeyCheck = val.regionCode
            this.azCode = val.azCode
            if (val.isSameAzCode) {
                this.searchCPU = val.cpu
            }
            if (val.isSameAzCode && val.isSameCpu) {
                this.searchMEM = val.mem
            }
            this.architecture = this._getArchitecture(val.productTypeId)
        }
        this.closeAzSearchData = val
    }

    tryDoChunk(val: any, newVal: any) {
        let num = this.pageLanguage === 'zh' ? 9 : 6; //UI设计：中文版和英文版展示region数量有差异
        this[val].length && (this[newVal] = _.chunk(this[val], num));
    }

    changeBuyData(params: any = {}) {
        let param = {
            isAs: this.isAs,
            showBuyVolume: this.showBuyVolume,
            isKs3Region: this.isKs3Region,
            kecCount: params.kecCount,
            duration: params.duration,
            discountList: this.hasSpecialDiscount ? this.specialDiscountList : this.discountList,
            orderBill: this.orderBill
        }
        this.$emit('resetBuyData', param);
    }

    getDurationUnit(billType: number) {
        if (billType == 1) {
            return this.$trans(`月`)
        }
        if (billType == 5 || billType == 2017) {
            return this.$trans(`天`);
        }
        if (billType == 84 || billType == 87 || billType == 810) {
            return this.$trans(`小时`)
        }
        return ''
    }

    //计费方式为 竞价实例时  用户手动设定单台实例价格校验
    blurF() {
        let userPrice = String(this.userPrice).replace(/^(.*\..{4}).*$/, "$1");
        this.userPrice = Number(userPrice);
        const kvmSpotCpuMemMarketPrice = this.computedPrice.kvmSpotCpuMemMarketPrice
        const kvmSpotCpuMemOriginPrice = this.computedPrice.kvmSpotCpuMemOriginPrice
        let price = Number(this.userPrice) || kvmSpotCpuMemMarketPrice
        if (price < kvmSpotCpuMemMarketPrice) {
            price = kvmSpotCpuMemMarketPrice
        }
        if (price > kvmSpotCpuMemOriginPrice) {
            price = kvmSpotCpuMemOriginPrice
        }
        this.userPrice = price
    }

    //补零
    toDoPatch(num: number) {
        let numStr = `${num}`;
        if (num < 10) {
            numStr = `0${num}`
        }
        return numStr
    }

    //格式化时间
    formatDate(date: Date) {
        return `${date.getFullYear()}-${(this.toDoPatch(date.getMonth() + 1))}-${this.toDoPatch(date.getDate())} ${this.toDoPatch(date.getHours())}:${this.toDoPatch(date.getMinutes())}:${this.toDoPatch(date.getSeconds())}`
    }

    // 计费方式为 竞价实例时  用户手动设定单台实例价格 查看历史价格
    checkHistoryPriceFun() {
        const endDate = new Date()
        const startDate = new Date(endDate.getTime() - 3 * 24 * 60 * 60 * 1000)
        return kecAPIs.DescribeSpotPriceHistory({
            params: {
                Region: this.regionKeyCheck, //后端对镜像市场接口未做修改Region，regionCode都必须传，否则控制台无法校验
                InstanceType: _.get(this.checkedRows, "[0].packageCode", ""),
                AvailabilityZone: this.azCode,
                StartTime: this.formatDate(startDate),
                EndTime: this.formatDate(endDate)
            }
        }).then((res: any) => {
            this.SpotPrices = res.SpotPrices
            this.series[0].data = []
            this.series[1].data = []
            this.SpotPrices.forEach((item) => {
                let time = moment(item.Timestamp).valueOf()
                // 市场价
                this.series[0].data.push([time, item.SpotPrice])
                // 原价
                this.series[1].data.push([time, item.OriginPrice])
            })
            const productName = productService.getProductTypeLocaleTitleById(this.checkedRows[0].productTypeId)  //this.pcommon.productTypeMap[this.checkedRows[0].productTypeId]
            this.option.yAxis.title.text = `${this.$trans(`实例规格价格`)}(${this.userCurrency}/${this.$trans(`小时`)})`;
            this.options = Object.assign({
                title: {
                    widthAdjust: 10,
                    userHTML: true,
                    align: 'left',
                    x: 0,
                    y: 15,
                    style: {
                        fontSize: '14px'
                    },
                    margin: 20,
                    text: `
                    <i style="font-weight:bold">${this.$trans(`实例类型`)}:</i><span>${productName || this.checkedRows[0].productTypeName}</span><span style="visibility:hidden;">&nbsp</span>
                    <i style="font-weight:bold;">${this.$trans(`套餐规格`)}:</i><span>${this.cpu} vCPU ${this.mem}GB</span><span style="visibility:hidden;">&nbsp</span>
                    <i style="font-weight:bold">${this.$trans(`套餐规格原价`)}:</i><span>${this.userCurrency}${this.computedPrice.kvmSpotCpuMemOriginPrice}/${this.$trans(`小时`)}</span>
                    `
                }
            }, this.option)
            this.$nextTick(() => {
                this.checkHistoryPrice = true
            })
        }).catch((e: any) => {
            commonAlert.send(e.Error.Message, 'kecDanger');
        });
    }

    clickRegionOnPage() {
        if (this.sourcePage == 'imageView' || this.sourcePage == 'osImageView') {
            // if (this.sourcePage === 'imageView') {
            this.sourcePage = '';
            this.diyImageId = '';
            this.diyRegionKey = '';
            this.diySupportUniversalHost = false;
            this.diyIsEbsDiskImage = false;
            this.diyDiskSizeOverflow = false;
            this.diyAzList = [];
            this.osImageId = '';
            this.osRegionKey = '';
        }
    }

    isDpu(){
        return this.kecType === 713 || this.kecType === 714;
    }

    isCommonModelType() {
        return commonConst.isCommonModelType(this.kecType);
    }

    is2dataDiskType() {
        return commonConst.is2dataDiskType(this.kecType);
    }

    _includes(array: any[], val: any) {
        return _.includes(array, val);
    }

    setInitData(params: any) {
        _.map(_.keys(params), (key) => {
            if (key !== 'isShow') {
                this[key] = params[key];
            }
        });

        if (this.sourcePage === 'imageView') {
            this.getImageViewData(params.isShow);
        } else if (this.sourcePage == 'osImageView') {
            this.getOsImageViewData(params.isShow);
        } else if (this.sourcePage === 'modifyTemplate' || this.sourcePage === 'buyTemplate') {
            this.getStartTemplateData(params.isShow);
        } else if (this.sourcePage === 'createTheSameConfig') {
            this.getTheSameConfigData(params.isShow);
        } else {
            return this._fetch(params.isShow);
        }

    }

    getImageViewData(isShow?: boolean) {
        try {
            let imageViewData = JSON.parse(localStorage.getItem('imageViewData') || '');
            this.diyImageId = imageViewData.diyImageId || "";
            this.diyRegionKey = imageViewData.diyRegionKey || "";
            this.diySupportUniversalHost = imageViewData.diySupportUniversalHost || false;
            this.diyIsEbsDiskImage = imageViewData.diyIsEbsDiskImage || false;
            this.diyDiskSizeOverflow = imageViewData.diyDiskSizeOverflow || false;
            this.diyAzList = imageViewData.diyAzList || [];
            this.diyAvailabilityZone = imageViewData.diyAvailabilityZone || "";
            localStorage.removeItem('imageViewData');
        } catch (e) {
            this.sourcePage = '';
        }

        // 初始化数据
        if (isShow) {
            return this._fetch(isShow);
        }
    }

    getOsImageViewData(isShow?: boolean) {
        try {
            let imageViewData = JSON.parse(localStorage.getItem('osImageViewData') || '');
            this.osImageId = imageViewData.osImageId || "";
            this.osRegionKey = imageViewData.osRegionKey || "";
            this.SupportProductTypes = imageViewData.SupportProductTypes || []
            console.log('this.osImageId::', this.osImageId, this.osRegionKey)
            localStorage.removeItem('osImageViewData');
        } catch (e) {
            this.sourcePage = '';
        }

        // 初始化数据
        if (isShow) {
            return this._fetch(isShow);
        }
    }

    getcloudMarket() {
        let me = this,
            marketCategory = getQueryString('marketCategory');

        return kecAPIs.DescribeMarketImages({
            params: {
                Region: me.regionKeyCheck, //后端对镜像市场接口未做修改Region，regionCode都必须传，否则控制台无法校验
                regionCode: me.regionKeyCheck,
                marketCategory: marketCategory,
                pageNo: 0,
                pageSize: 100,
            }
        }).then((res: any) => {
            if (res.code !== 200) {
                return;
            }
            let products = res.data.items;
            let imageobj = _.find(products, item => {
                return item.productId == getQueryString('productId')
            })
            if (imageobj) {
                this._setimagesname(imageobj);
            }
        }).catch((e: any) => {
            commonAlert.send(e.Error.Message, 'kecDanger');
        });
    }

    setValue(key: any, value: any) {
        return this.__setValue(key, value);
    }

    __setValue(key: any, value: any) { //模板内使用方法
        if (this.sourcePage == 'imageView') {
            if (key === 'imageType') {
                this.sourcePage = '';
            }
            if (value == 1 || value == 0) { //处理自定义镜像/标准镜像
                this.sourcePage == 'imageView' ? this.getImageViewData() : this.getOsImageViewData();
                this.loadDataNum = 0;
            } else {
                this.loadDataNum++;
                if (this.loadDataNum == 1) {
                    this.diyImageId = '';
                    this.diyRegionKey = '';
                    this.diySupportUniversalHost = false;
                    this.diyIsEbsDiskImage = false;
                    this.diyDiskSizeOverflow = false;
                    this.diyAzList = [];
                    this.diyAvailabilityZone = '';
                    this.osImageId = '';
                    this.osRegionKey = '';
                }
            }
        }
        if (this.sourcePage == 'cloudMarket') {
            if (key === 'imageType') {
                this.sourcePage = '';
            }

            if (value == 4) { //单独处理云市场镜像
                // 弹性伸缩、试用、 N1、AC1、AC2、(还有英文版控制台) 不支持云市场镜像
                if (this.isAs || this.orderBill == 2017 || this.kecType == 40 || this.kecType == 305 || this.kecType == 388) {
                    // console.log('不支持云市场');
                } else {
                    this.imageType = 4;
                }
                this.getcloudMarket();
            }
        }
        if (key === 'imageType' && value === 1) {
            this.checkSnapShotService()
        }
        this.$set(this, key, value);
    }

    //***************初始化部分start
    @debounce(debounceTimer)
    _fetch(isShow?: any) {
        let promise: Promise<any>;

        //容器不支持试用
        if (this.isCluster || this.isAs) {
            promise = Promise.all([this._getProList(), this._fetchKecData(), this._fetchAllRegionList()]);
        } else {
            promise = Promise.all([
                this._getProList(),
                // this._fetchTryOrder(true),
                this._fetchTryOrder(),
                this._fetchOSImage(),
                this._fetchDiyImg(),
                this._fetchShareImg(),
                this._fetchAllRegionList(),
                // this._getIpv6SupportProductType(),
                this.ValidateIpv6Support()
            ]);
        }
        return promise.then(() => {
            this.isShow = isShow;
        });
    }

    ValidateIpv6Support() {


        return kecAPIs.ValidateIpv6Support({
            params: {
                Region: this.regionKey,
            }
        }).then((res: any) => {


            // if (res && res.data) {
            //     let ipv6TypeCodes: number[] = [];
            //     _.forEach(res.data, item => {
            //         if (!item.regions) {
            //             ipv6TypeCodes.push(item.productTypeId * 1);
            //         } else if (item.regions.indexOf(this.regionKey) !== -1) {
            //             ipv6TypeCodes.push(item.productTypeId * 1);
            //         }
            //     });
            //     this.ipv6TypeCodes = ipv6TypeCodes;
            // }

            if (res && res.data) {
                let ipv6TypeCodes: any = {};
                let allId: number[] = []
                _.forEach(res.data, item => {
                    const porductId = item.productTypeId
                    if (!item.regions) {
                        allId.push(porductId)
                        ipv6TypeCodes['all'] = allId
                    } else if (item.regions) {
                        _.forEach(item.regions, region => {
                            let theId = [porductId]
                            if (Object.keys(ipv6TypeCodes).includes(region)) {
                                theId = ipv6TypeCodes[region]
                                theId.push(item.productTypeId * 1)
                            }
                            ipv6TypeCodes[region] = theId
                        })
                    }
                });
                this.ipv6TypeCodes = ipv6TypeCodes;
                // this.ipv6TypeCodes = res.data;
            }

        }).catch((e: any) => {
            commonAlert.send(e, 'kecDanger')
        })
    }

    //开发时间是2020-12-16，上线时间不确定，但是上线14天之后要注释代码，等产品通知吧！！！！
    describeSnapshotServiceStatus() {
        //检查用户是否开通快照服务

        return kecAPIs.DescribeSnapshotServiceStatus({
            params: {
                Region: this.regionKey,
            }
        }).then((res: any) => {
            this.snapshotServiceStatusCode = res.status
            if (this.snapshotServiceStatusCode === 4 || this.snapshotServiceStatusCode === 10) {
                this.snapShotTips = this.$trans(`您的快照服务已关停，如需开通请联系金山云客服`)
                this.noAuth = true
            } else if (this.snapshotServiceStatusCode === 8) {
                this.snapShotTips = this.$trans(`您的账号已欠费，请先充值`)
                this.noAuth = true
            } else if (res.status === 9) {
                this.snapShotTips = this.$trans(`客户快照服务已经被欠费回收`)
                this.noAuth = true
            }
        }).catch((e: any) => {
            Message.error(e || e.msg);
        });
    }

    checkSnapShotService(name?: string, key?: any) {
        if (this.snapshotServiceStatusCode !== 0) {
            this.isSnapShotPermission = true;
            this.openSnapShotStatus = false;
            if (name == '_snapCreateEbs') {
                this._snapCreateEbs(key);
            } else if (name == '_snapCreate') {
                this._snapCreate();
            }
        } else {
            this.isSnapShotPermission = false;
            this.openSnapShotStatus = true;
            if (name == 'diyImgList') {
                this.imageId = '';
                this.imageObj = {};
            }
        }
    }

    openSnapShotService() {
        //开通快照服务（开通订单）

        return kecAPIs.OpenSnapShotService({
            params: {
                Region: this.regionKey,
            }
        }).then((res: any) => {
            if (res.code == 200) {
                this.isSnapShotPermission = true;
                Message.success(Vue.$trans(`开通快照服务成功！`));
            } else {
                this.isSnapShotPermission = false;
            }
        }).catch((e: any) => {
            Message.error(e);
            // console.log(e);
        });
    }

    //--以上是快照逻辑，虽然上线时间不确定，但是上线14天后要手动注释代码，等产品通知吧！！！--

    getTheSameConfigData(isShow?: boolean) {
        let instanceId = getQueryString('InstanceId') || "";

        return kecAPIs.GetInstanceByIds({
            params: {
                Region: this.regionKey
            },
            data: {
                InstanceId: instanceId,
                InstancesIdList: [instanceId]
            }
        }).then((res: any) => {
            if (res.code == 200) {
                this.theSameConfigData = _.get(res, 'FormedInstanceDataArray[0]');
                // 初始化数据
                return this._fetch(isShow);
            } else {
                Message.error(res.msg);
            }
        }).catch((e: any) => {
            Message.error(e);
        })
    }

    getStartTemplateData(isShow?: boolean) {
        let startTemplateId = getQueryString('launchTemplateId') || "";

        return kecAPIs.DescribeModels({
            params: {
                Region: this.regionKey
            },
            data: {
                ModelIds: [startTemplateId],
            }
        }).then((res: any) => {
            if (res.code == 200) {
                this.startTempData = _.get(res, 'ModelSet[0]', {});
                // 初始化数据
                return this._fetch(isShow);
            } else {
                commonAlert.send(res.msg, 'kecDanger');
            }
        }).catch((e: any) => {
            commonAlert.send(e.Error.Message, 'kecDanger');
        })
    }

    _fetchTryOrder() {
        return kecAPIs.QueryFreeTrialWallet({
            params: {
                Region: this.regionKey
            }
        }).then((res: any) => {
            this.tryMoney = _.get(res, 'data.available_credit', 0);
            // console.log(this.tryMoney, res.data.available_credit, 'data.available_credit')
            this._fetchKecData();
        })

    }

    _fetchAllRegionList() {
        return kecAPIs.RegionInfos({
            params: {
                Region: this.regionKey
            }
        }).then((res: any) => {
            this.regionInfos = res
        })
    }

    describeEbsPerfQuotas() {
        //查询云盘类型的全部性能配额配置 选择ESSD云盘时性能配置查询
        return kecAPIs.DescribeEbsPerfQuotas({
            params: {
                Region: this.regionKey
            },
            data: {
                VolumeTypes: ["ESSD_PL0", "ESSD_PL1", "ESSD_PL2", "ESSD_PL3", "ESSD_SYSTEM_PL0", "ESSD_SYSTEM_PL1", "ESSD_SYSTEM_PL2"]
            }
        }).then((res: any) => {
            if (res) {
                this.describeEbsPerfQuotasObj = res;
            }
        }).catch((e: any) => {
            // console.log(e)
        })
    }

    _fetchDescribeInstanceGroupCount() {
        //获取可用区已经创建的实例数量
        return kecAPIs.DescribeInstanceGroupCount({
            params: {
                Region: this.regionKey
            },
            data: {
                ProjectIds: '' //查询全部项目制改为传空；
            }
        }).then((res: any) => {
            return res
        }).catch((e: any) => {
            // console.log(e)
        })
    }

    @debounce(debounceTimer)
    _fetchOSImage(region?: any) {

        return kecAPIs.ImageConfig({
            params: {
                Region: region ? this.regionKeyCheck : this.regionKey
            }
        }).then((res: any) => {
            this.osImages = _.get(res, 'images', {});
            this.pTypeConfig = _.get(res, 'p_type_config', []);
            return this.formateOsImage();
        }).catch((e: any) => {
        })

    }

    @debounce(debounceTimer)
    _fetchDiyImg(region?: any) {
        let me = this;

        kecAPIs.DescribeImages({
            params: {
                Region: region ? this.regionKeyCheck : this.regionKey
            }
        }).then((res: any) => {

            let imageSet = _.get(res, 'ImagesSet', []);

            _.map(imageSet, (item) => {
                item.title = item.Name;
                item.value = item.ImageId;
                return item;
            });

            this.diyImgList = _.filter(imageSet, (item) => {
                return item.ImageState === 'active' || item.ImageState === 'warming';
            });

            this.diyImageListCopy = _.clone(this.diyImgList);
            if (this.imageType == 1) {
                this._setImageId();
            }
        });
    }


    @debounce(debounceTimer)
    _fetchShareImg(region?: any) {
        let me = this;
        return kecAPIs.DescribeImages({
            params: {
                Region: region ? this.regionKeyCheck : this.regionKey,
                ImageType: 'share'
            }
        }).then((res: any) => {

            var shareimageSet = _.get(res, 'ImagesSet', []);
            _.map(shareimageSet, (item) => {
                item.title = item.Name;
                item.value = item.ImageId;
                return item;
            });
            this.shareimageSet = shareimageSet;
            this.shareImgList = _.filter(shareimageSet, (item) => {
                return item.ImageState === 'active' || item.ImageState === 'warming';
            });
            this.shareImageListCopy = _.clone(this.shareImgList);
            if (this.imageType == 3) {
                this._setImageId();
            }
        });
    }

    _handleData(products: any) {
        return HandleData._handleData(products, this.isCluster, this, this.ipv6TypeCodes, false, true);
    }

    _fetchKecData() {

        let api = this.isAs ? kecAPIs.QueryPriceSystem : kecAPIs.QueryKvmList;

        return api({
            params: {
                Region: this.regionKey,
                needVmSellOut: true,
            }
        }).then((res: any) => {
            this.kecData = res.data;
            this.soldoutList = res.sellOutData;
            this.RootSizeQuota = res.RootSizeQuota || {};

            let dataCenter = {},
                me = this;
            if (_.get(this.kecData, 'productGroupId') == 100) {
                dataCenter = this.kecData;
            }
            let products = _.get(dataCenter, 'productTypeList', []);
            if (_.isEmpty(dataCenter) || _.isEmpty(products)) {
                // return;
                return commonAlert.send(this.$trans(`您没有配置任何机房的购买权限，请联系客服400-028-9900`), 'kecDanger');
                //您没有配置任何机房的购买权限，请联系客服
            }
            this.baseKvmList = products;
            if (this.tryMoney && this.tryMoney > 0) {
                _.each(products, item => {
                    item.billTypeList.push(me.tryOrderMethod)
                })
            }
            let allData = this._handleData(products);
            this.soldoutArr = this.soldoutList ? HandleData._handleSoldoutData(this.soldoutList) : [];
            let sortedArr = _.sortBy(allData, item => {
                return item.billTypeId == 2017;
            })
            this.orderBills = Object.freeze(sortedArr);
            // 默认选中上次选择的计费方式
            try {

                let c = _.find(allData, ['billTypeId', 5]);
                if (c) {
                    this.orderBill = _.get(c, 'billTypeId');
                } else {
                    this.orderBill = _.get(allData[0], 'billTypeId');
                }
            } catch (e) {
                this.orderBill = _.get(allData[0], 'billTypeId');
            }

            if (this.sourcePage == 'createTemplate' || this.sourcePage == 'modifyTemplate') {
                // 创建模板、修改模板 不支持按日计费（试用）的计费方式
                this.orderBills = _.filter(allData, item => {
                    return item.billTypeId != 2017;
                })
            }
            if (this.sourcePage == 'modifyTemplate' || this.sourcePage == 'buyTemplate') {
                this.orderBill = _.get(this.startTempData, 'OrderInfo.BillType');
                if (this.orderBill == 1) {
                    //包年包月的时候才取值

                    const duration = _.get(this.startTempData, 'PurchaseTime', '1').toString();
                    this.changeBuyData({duration})
                }
            }
            if (this.sourcePage == 'createTheSameConfig') {
                this.orderBill = _.get(this.theSameConfigData, 'OrderInfo.BillType');
                let SpotStrategy = _.get(this.theSameConfigData, 'SpotStrategy');
                if (this.orderBill == 1) {
                    const duration = _.get(this.theSameConfigData, 'PurchaseTime', '1').toString();
                    this.changeBuyData({duration});
                }
                if (this.orderBill === 810 && SpotStrategy === "SpotWithPriceLimit") {
                    this.bidType = 'userset'
                    this.userPrice = _.get(this.theSameConfigData, 'SpotPriceLimit');
                }
            }

            // newOrderBills里的元素，只需要计费方式的两个字段，这里简化一下，避免传递不必要的字段导致不容易追溯，也便于后续调整数据结构进行优化
            let billTypeList = _.map(this.orderBills, item => {
                return {
                    billTypeId: item.billTypeId,
                    billTypeNAme: item.billTypeName
                }
            })
            this.newOrderBills = this.tryDoChunkRework(billTypeList);
            this._orderBillChange();
        })
    }

    //***********初始化调取接口end

    //机型是否支持本地快照制作的镜像
    ifDisableLocalSnapShotImage(imageItem: any): boolean {
        //获取价格体系中当前机型支持的ebs盘类型
        const supportEbsType = _.get(_.find(this.kecTypeObj.propertyList, ['propCode', 'ebs-type']), 'propValue', [])

        //只要该机型支持ESSD，本地快照制作的整机镜像就禁用
        // 修正：ESSD使用整机镜像，只有数据盘包含本地盘的快照才禁用, by ydx 2023-06-06）
        // 修正： 如果不支持ESSD，但是支持其它类型，依然要放开
        if (this.performanceModel === 'enhance' || _.every(supportEbsType, typeItem => {
            return typeItem.name.split('_')[0] === 'ESSD'
        })) {
            if (imageItem.SnapshotSet && imageItem.SnapshotSet.length) {
                if (_.some(imageItem.SnapshotSet, (subItem) => {
                    return subItem.DiskType == "local_snapshot" && subItem.Type == "data";
                })) {
                    return true
                }
            }
        }
        return false
    }

    //机型是否支持整机镜像
    ifSupportSystemImage(imageItem: any): boolean {
        //OnlySystemImage 价格体系中有这个字段表示只支持挂系统盘镜像，不支持挂数据盘的镜像，就是不支持整机镜像
        const OnlySystemImage = _.find(this.kecTypeObj.propertyList, ['propCode', 'OnlySystemImage'])
        let OnlySystemImageValue = _.get(OnlySystemImage, 'propValue[0].value')
        if (OnlySystemImageValue === "false") {
            OnlySystemImageValue = false
        }
        if (OnlySystemImageValue) {
            // xxxx: 测试环境还没改价格体系配置，先用这个值调试
            // if (OnlySystemImage && this.kecTypeObj.productTypeId != 687) {
            if (imageItem.SnapshotSet && imageItem.SnapshotSet.length) {
                let localSnapshot = _.filter(imageItem.SnapshotSet, (subItem) => {
                    return subItem.Type == "data";
                });
                if (localSnapshot.length) {
                    return true
                }
            }
        }
        return false
    }

    // @Watch("ebsSupport")
    // ebsSupportWatcher(val:any) {
    //     debugger
    //     console.log(val);
    // }

    //**********镜像部分start
    _setImageId() {
        // debugger;
        var osList = [];
        if (this.imageType == 1) {
            var list = this.diyImageListCopy;
            let i4ebsOrOther = this.kecType == 357 ? this.sysDiskObj.value != 'Local_SSD' : true;

            //试用不支持云市场镜像
            if (this.orderBill == 2017) {
                list = _.filter(list, item => {
                    return !item.IsCloudMarket
                })
            }

            //联网增强机型
            if (this.isEnhance) {
                list = _.filter(list, (item) => {
                    return item.IsNpe;
                });
            }

            osList = _.filter(list, (item) => {
                // console.log(item.Name, item, 123)
                let platform = _.get(item, 'Platform', '');
                let isWindows = /win.*/i.test(platform.toLowerCase());
                let isWin2008 = /win.*2008/i.test(platform.toLowerCase());
                let isAndroidImage = /android.*/i.test(platform.toLowerCase());
                let maxSize = isWindows ? (isWin2008 ? 40 : 50) : 20; //isWindows ? (isWin2008 ? 40 : 50) : 20;
                let isSA1Host = false;
                item.disabled = false; //默认当前选项是可以选择
                item.tipInfo = ''; //默认提示内容

                if(item.ImageState === 'switching'){
                    item.disabled = true; //禁止当前选项
                    item.tipInfo = '1100';
                }

                //ARM机型 只支持带 aarch64 标记的自定义镜像
                if (this.generation.toLowerCase() == 'arm') {
                    if (item.Architecture && item.Architecture == "aarch64" && !isAndroidImage) {
                        console.log('支持AC2的自定义镜像');
                    } else {
                        item.disabled = true; //禁止当前选项
                        item.tipInfo = '600';
                    }
                } else {
                    if (item.Architecture && item.Architecture == "aarch64") {
                        item.disabled = true; //禁止当前选项
                        item.tipInfo = '600';
                    }
                }
              
                let systemDisk = _.find(this.kecTypeObj.propertyList, { propCode: "systemDisks" });
                if (systemDisk !== undefined && _.find(systemDisk.propValue, { value: "Local_SSD" })) {
                    if (item.SnapshotSet && _.find(item.SnapshotSet, s => s.VolumeType && s.Type && s.Type === "system" && s.VolumeType.indexOf("ESSD") !== -1) !== undefined) {
                        item.disabled = true;
                        item.tipInfo = '1000';
                    }
                }
                const dataSnapList = _.filter(item.SnapshotSet, item => item.Type !=='system') || []
                if(dataSnapList.length > this.maxEbsNum) {
                    item.disabled = true;
                    item.tipInfo = '1200';
                }

                const bootMode = _.find(this.kecTypeObj.propertyList, ['propCode', 'BOOT_MODE'])?.propValue[0]?.value || 'BIOS(Legacy)'
      
                if(bootMode !== 'both'){
                    if(bootMode.toLowerCase() !== item.BootMode.toLowerCase()){
                        item.disabled = true;
                        item.tipInfo = '1300';
                    }
                    
                }

                if (commonConst.isCommonModelType(this.kecType) && i4ebsOrOther && this.kecType != 40) {

                    //本地盘镜像需要同可用区才能支持
                    let isLocalImage = true;
                    if (item.Type == 'LocalImage') {
                        // 兼容 随机可用区
                        if (this.azCode === 'all') {
                            // 随机可用区屏蔽本地整机镜像 by ydx 2023-06-12
                            // if (!this.checkedRows[0].azCodeList.includes(item.AvailabilityZone)) {
                            //     isLocalImage = false;
                            // }
                            item.disabled = true
                            item.tipInfo = '200'
                        } else if (item.AvailabilityZone != this.azCode) {
                            isLocalImage = false;
                        }
                    }

                    // xxx极速可用整机镜像仅支持ssd3.0，没有ssd3.0配置的机型就不能用这个镜像开机 by ydx 2023.05.31
                    // wiki: https://wiki.op.ksyun.com/pages/viewpage.action?pageId=200144262
                    // * 极速可用整机镜像只支持开SSD3.0也仅SSD3.0制作
                    // 需求又变了：极速可开镜像（不管是否有数据盘快照），都只能SSD3创建和使用（2023.06.01）
                    if (item.Type == 'LocalImage') {
                        // 是否整机镜像
                        // let hasDataSnapshot = _.some(item.SnapshotSet, s => s.Type === "data")
                        // if (hasDataSnapshot) {
                        let ebsTypeProp = _.find(this.kecTypeObj.propertyList, ['propCode', 'ebs-type'])
                        let propValues = _.get(ebsTypeProp, 'propValue')
                        let hasSSD3 = _.some(propValues, propValueItem => propValueItem.value == 132)
                        // 不支持ssd3的机型做禁用处理
                        if (!hasSSD3) {
                            item.disabled = true;
                            item.tipInfo = '400';
                        }
                        // 如果propertylist里支持多种ebs，但当前只支持essd（例如x6e的增强型），也需要过滤掉本地整机镜像
                        let supportEbsHasSSD = _.some(this.ebsSupport, item => item.productType == 132)
                        if (!supportEbsHasSSD) {
                            item.disabled = true;
                            item.tipInfo = '400';
                        }
                        // }

                    }

                    if (item.SysDisk > this.systemDiskMax) { // systemDiskMax是可变容量的最大值
                        item.disabled = true;
                        item.tipInfo = '500';
                    }

                    if (this.ifDisableLocalSnapShotImage(item)) {
                        item.disabled = true; //禁止当前选项
                        item.tipInfo = '300'; //该机型暂不支持用本地盘创建的镜像开机
                    }
                    ;


                    if (this.ifSupportSystemImage(item)) {
                        item.disabled = true; //禁止当前选项
                        item.tipInfo = '900'; //该机型暂不支持使用含数据盘快照的自定义镜像开机
                    }


                    if (this.kecType == 198) { //标准型SA1 需要支持：标准镜像、自定义镜像、共享镜像、镜像市场（重装不支持镜像市场）
                        if (/centos/.test(platform.toLowerCase())) {
                            //只支持Centos 7.2以上
                            isSA1Host = platform.split('-')[1] >= 7.2;
                        } else if (/win.*/.test(platform.toLowerCase())) {
                            //只支持Windows 2016/2012/2019
                            isSA1Host = /win.*2012/.test(platform.toLowerCase()) || /win.*2016/.test(platform.toLowerCase()) || /win.*2019/.test(platform.toLowerCase());
                        } else if (/ubuntu/.test(platform.toLowerCase())) {
                            //只支持Ubuntu 16.04/18.04
                            isSA1Host = platform.split('-')[1] == 16.04 || platform.split('-')[1] == 18.04;
                        }
                        return (item.ImageState == 'active' || item.ImageState === 'warming') && isSA1Host && isLocalImage;
                    } else {
                        return (item.ImageState == 'active' || item.ImageState === 'warming') && isLocalImage; //底层已经支持本地盘镜像，并放开了系统盘500G以上镜像
                    }
                } else {
                    //镜像系统盘大于默认系统盘（20、50）就走这个逻辑, 可变系统盘需要单独处理逻辑
                    if (item.SysDisk > maxSize) {
                        if (commonConst.isAdjustSysDiskType(this.kecType) && i4ebsOrOther) { // 可变系统盘机型
                            if (item.SysDisk > this.systemDiskMax) { // systemDiskMax是可变容量的最大值
                                item.disabled = true;
                                item.tipInfo = '500';
                            }
                        } else {
                            if (item.SysDisk > this.quotaMaxDisk) { //不可变系统盘由quota决定
                                item.disabled = true; //禁止当前选项
                                item.tipInfo = '500';
                            }
                            if (this.kecType == 357) { //IO优化型I4
                                if (item.SysDisk > 50) {
                                    item.disabled = true;
                                    item.tipInfo = '100';
                                }
                            }
                        }
                    }

                    //本地盘机型不能选择镜像本地数据盘快照超过1块
                    if (item.SnapshotSet && item.SnapshotSet.length) {
                        let localSnapshot = _.filter(item.SnapshotSet, (subItem) => {
                            return subItem.DiskType == "local_snapshot" && subItem.Type == "data";
                        });
                        if (localSnapshot.length > 1) {
                            item.disabled = true; //禁止当前选项
                            item.tipInfo = '700'; //关联本地数据盘快照超过1块，请选择系统盘为云硬盘的机型。
                        }

                        //不支持云盘数据盘的机型 如：I1、C1
                        let supportAddEbsDisk = false;
                        if (commonConst.is2dataDiskType(this.kecType) && this.ebsSupport.length) {
                            supportAddEbsDisk = true;
                        }

                        //不支持云盘数据盘的机型，不能选择带有云盘的快照
                        //新加坡可用区A没有EBS集群，不能选择镜像本地数据盘快照超过1块
                        if ((this.regionKey == 'ap-singapore-1' && this.azCode == 'ap-singapore-1a') || !supportAddEbsDisk) {
                            let nolocalSnapshot = _.filter(item.SnapshotSet, (subItem) => {
                                return subItem.DiskType != "local_snapshot" && subItem.Type == "data";
                            });
                            if (nolocalSnapshot.length >= 1) {
                                item.disabled = true; //禁止当前选项
                                item.tipInfo = '800'; //该镜像关联云盘快照，请选择支持创建云盘数据盘的机型
                            }
                        }
                    }

                    // return item.ImageState == 'active' || item.ImageState === 'warming';
                    return (item.ImageState == 'active' || item.ImageState === 'warming') && item.Type != 'LocalImage'; //本地盘机型不支持本地镜像
                }
            });

            this.diyImgList = osList;
        } else if (this.imageType == 3) {
            let list = this.shareimageSet;
            let i4ebsOrOther = this.kecType == 357 ? this.sysDiskObj.value != 'Local_SSD' : true;
            //试用不支持云市场镜像
            if (this.orderBill == 2017) {
                list = _.filter(list, item => {
                    return !item.IsCloudMarket
                })
            }

            //联网增强机型
            if (this.isEnhance) {
                list = _.filter(list, (item) => {
                    return item.IsNpe;
                });
            }

            osList = _.filter(list, (item) => {
                let platform = _.get(item, 'Platform', '');
                let isWindows = /win.*/i.test(platform.toLowerCase());
                let isWin2008 = /win.*2008/i.test(platform.toLowerCase());
                let maxSize = isWindows ? (isWin2008 ? 40 : 50) : 20; //isWindows ? (isWin2008 ? 40 : 50) : 20;
                let isSA1Host = false;
                item.disabled = false; //默认当前选项是可以选择
                item.tipInfo = ''; //默认提示内容
                // 共享镜像更改限制
                // 详见: http://jira.op.ksyun.com/browse/CSKEC-68

                const dataSnapList = _.filter(item.SnapshotSet, item => item.Type !=='system') || []
                if(dataSnapList.length > this.maxEbsNum) {
                    item.disabled = true;
                    item.tipInfo = '1200';
                }

                const bootMode = _.find(this.kecTypeObj.propertyList, ['propCode', 'BOOT_MODE'])?.propValue[0]?.value || 'BIOS(Legacy)'
                if(bootMode !== 'both'){
                    if(bootMode.toLowerCase() !== item.BootMode.toLowerCase()){
                        item.disabled = true;
                        item.tipInfo = '1300';
                    }
                    
                }


                if ((commonConst.isCommonModelType(this.kecType) && i4ebsOrOther && this.kecType != 40)) {

                    //本地盘镜像需要同可用区才能支持
                    let isLocalImage = true;
                    if (item.Type == 'LocalImage') {
                        // if (item.AvailabilityZone != this.azCode) {
                        //     isLocalImage = false;
                        // }
                        // 兼容 随机可用区
                        if (this.azCode === 'all') {
                            if (!this.checkedRows[0].azCodeList.includes(item.AvailabilityZone)) {
                                isLocalImage = false;
                            }
                        } else if (item.AvailabilityZone != this.azCode) {
                            isLocalImage = false;
                        }
                        
                        let ebsTypeProp = _.find(this.kecTypeObj.propertyList, ['propCode', 'ebs-type'])
                        let propValues = _.get(ebsTypeProp, 'propValue')
                        let hasSSD3 = _.some(propValues, propValueItem => propValueItem.value == 132)
                        // 不支持ssd3的机型做禁用处理
                        if (!hasSSD3) {
                            item.disabled = true;
                            item.tipInfo = '400';
                        }
                        // 如果propertylist里支持多种ebs，但当前只支持essd（例如x6e的增强型），也需要过滤掉本地整机镜像
                        let supportEbsHasSSD = _.some(this.ebsSupport, item => item.productType == 132)
                        if (!supportEbsHasSSD) {
                            item.disabled = true;
                            item.tipInfo = '400';
                        }
                    }

                    if (item.SysDisk > this.systemDiskMax) {
                        item.disabled = true; //禁止当前选项
                        item.tipInfo = '500';
                    }

                    //机型是否支持本地快照制作的镜像
                    if (this.ifDisableLocalSnapShotImage(item)) {
                        item.disabled = true; //禁止当前选项
                        item.tipInfo = '300'; //该机型暂不支持用本地盘创建的镜像开机
                    }
                    ;

                    //机型是否支持整机镜像
                    if (this.ifSupportSystemImage(item)) {
                        item.disabled = true; //禁止当前选项
                        item.tipInfo = '900'; //该机型暂不支持使用含数据盘快照的自定义镜像开机
                    }

                    if (this.kecType == 198) { //标准型SA1 需要支持：标准镜像、自定义镜像、共享镜像、镜像市场（重装不支持镜像市场）
                        if (/centos/.test(platform.toLowerCase())) {
                            //只支持Centos 7.2以上
                            isSA1Host = platform.split('-')[1] >= 7.2;
                        } else if (/win.*/.test(platform.toLowerCase())) {
                            //只支持Windows 2016/2012/2019
                            isSA1Host = /win.*2012/.test(platform.toLowerCase()) || /win.*2016/.test(platform.toLowerCase()) || /win.*2019/.test(platform.toLowerCase());
                        } else if (/ubuntu/.test(platform.toLowerCase())) {
                            //只支持Ubuntu 16.04/18.04
                            isSA1Host = platform.split('-')[1] == 16.04 || platform.split('-')[1] == 18.04;
                        }
                        return (item.ImageState == 'active' || item.ImageState === 'warming') && isSA1Host && isLocalImage;
                    } else {
                        return (item.ImageState == 'active' || item.ImageState === 'warming') && isLocalImage; //底层已经支持本地盘镜像，并放开了系统盘500G以上镜像
                    }
                } else {
                    if (item.SysDisk > maxSize) {
                        if (commonConst.isAdjustSysDiskType(this.kecType) && i4ebsOrOther) { // 可变系统盘机型
                            if (item.SysDisk > this.systemDiskMax) {
                                item.disabled = true; //禁止当前选项
                                item.tipInfo = '500';
                            }
                        } else {
                            if (item.SysDisk > this.quotaMaxDisk) { //不可变系统盘由quota决定
                                item.disabled = true; //禁止当前选项
                                item.tipInfo = '500';
                            }

                            if (this.kecType == 357) { //IO优化型I4
                                if (item.SysDisk > 50) {
                                    item.disabled = true;
                                    item.tipInfo = '100';
                                }
                            }
                        }
                    }

                    //本地盘机型不能选择镜像本地数据盘快照超过1块
                    if (item.SnapshotSet && item.SnapshotSet.length) {
                        let localSnapshot = _.filter(item.SnapshotSet, (subItem) => {
                            return subItem.DiskType == "local_snapshot" && subItem.Type == "data";
                        });
                        if (localSnapshot.length > 1) {
                            item.disabled = true; //禁止当前选项
                            item.tipInfo = '700'; //关联本地数据盘快照超过1块，请选择系统盘为云硬盘的机型。
                        }

                        //不支持云盘数据盘的机型 如：I1、C1
                        let supportAddEbsDisk = false;
                        if (commonConst.is2dataDiskType(this.kecType) && this.ebsSupport.length) {
                            supportAddEbsDisk = true;
                        }

                        //不支持云盘数据盘的机型，不能选择带有云盘的快照
                        //新加坡可用区A没有EBS集群，不能选择镜像本地数据盘快照超过1块
                        if ((this.regionKey == 'ap-singapore-1' && this.azCode == 'ap-singapore-1a') || !supportAddEbsDisk) {
                            let nolocalSnapshot = _.filter(item.SnapshotSet, (subItem) => {
                                return subItem.DiskType != "local_snapshot" && subItem.Type == "data";
                            });
                            if (nolocalSnapshot.length >= 1) {
                                item.disabled = true; //禁止当前选项
                                item.tipInfo = '800'; //该镜像关联云盘快照，请选择支持创建云盘数据盘的机型
                            }
                        }
                    }

                    let systemDisk = _.find(this.kecTypeObj.propertyList, { propCode: "systemDisks" });
                    if (systemDisk !== undefined && _.find(systemDisk.propValue, { value: "Local_SSD" })) {
                        if (item.SnapshotSet && _.find(item.SnapshotSet, s => s.VolumeType && s.Type && s.Type === "system" && s.VolumeType.indexOf("ESSD") !== -1) !== undefined) {
                            item.disabled = true;
                            item.tipInfo = '1000';
                        }
                    }
                    // return item.ImageState === 'active' || item.ImageState === 'warming'
                    return (item.ImageState == 'active' || item.ImageState === 'warming') && item.Type != 'LocalImage'; //本地盘机型不支持本地镜像
                }
            });
            this.shareImgList = osList;
        } else if (this.imageType == 4) {
            if (this.sourcePage == 'modifyTemplate' || this.sourcePage == 'buyTemplate') {
                if (_.isEmpty(this.imageObj)) {
                    this.imageObj = {
                        name: _.get(this.startTempData, 'Extra'), //镜像市场名称
                        imageId: _.get(this.startTempData, 'ImageId'),
                        title: _.get(this.startTempData, 'imageInfo.Name'),
                        value: _.get(this.startTempData, 'imageInfo.ImageId'),
                        Platform: _.get(this.startTempData, 'imageInfo.Platform'),
                        IsModifyType: _.get(this.startTempData, 'imageInfo.IsModifyType'),
                        CloudInitSupport: _.get(this.startTempData, 'imageInfo.CloudInitSupport'),
                    };
                    this.imageId = _.get(this.startTempData, 'ImageId');
                }
            }
            let isSA1Host = false

            // 判断上次记录镜像是否支持当前机型
            let platform = _.get(this.imageObj, 'Platform', '');
            let i4ebsOrOther = this.kecType == 357 ? this.sysDiskObj.value != 'Local_SSD' : true;
            if (platform) {
                let isWindows = /win.*/i.test(platform.toLowerCase());
                let isWin2008 = /win.*2008/i.test(platform.toLowerCase());
                let maxSize = isWindows ? (isWin2008 ? 40 : 50) : 20; //isWindows ? (isWin2008 ? 40 : 50) : 20;
                let minDisk = _.get(this.imageObj, 'imageDetail.minDisk', 0);

                if ((commonConst.isCommonModelType(this.kecType) && this.kecType != 40 && i4ebsOrOther)) {
                    if (minDisk > this.systemDiskMax) {
                        this.imageObj.disabled = true; //禁止当前选项
                    }
                    if (this.kecType == 198) { //标准型SA1 需要支持：标准镜像、自定义镜像、共享镜像、镜像市场（重装不支持镜像市场）
                        if (/centos/.test(platform.toLowerCase())) {
                            //只支持Centos 7.2以上
                            isSA1Host = platform.split('-')[1] >= 7.2;
                        } else if (/win.*/.test(platform.toLowerCase())) {
                            //只支持Windows 2016/2012/2019
                            isSA1Host = /win.*2012/.test(platform.toLowerCase()) || /win.*2016/.test(platform.toLowerCase()) || /win.*2019/.test(platform.toLowerCase());
                        } else if (/ubuntu/.test(platform.toLowerCase())) {
                            //只支持Ubuntu 16.04/18.04
                            isSA1Host = platform.split('-')[1] == 16.04 || platform.split('-')[1] == 18.04;
                        }
                        if (isSA1Host) {
                            this.imageObj.disabled = false;
                        } else {
                            this.imageObj.disabled = true;
                        }
                    }
                } else {
                    //镜像系统盘大于默认系统盘（20、40、50）就走这个逻辑, 可变系统盘需要单独处理逻辑
                    if (minDisk > maxSize) {
                        if (commonConst.isAdjustSysDiskType(this.kecType) && i4ebsOrOther) { // 可变系统盘机型
                            if (minDisk > this.systemDiskMax) {
                                this.imageObj.disabled = true;
                            }
                        } else {
                            if (minDisk > this.quotaMaxDisk) { //不可变系统盘由quota决定
                                this.imageObj.disabled = true; //禁止当前选项
                            }
                            if (this.kecType == 357) { //IO优化型I4
                                if (minDisk > 50) {
                                    this.imageObj.disabled = true;
                                }
                            }
                        }
                    }
                }
            }
            osList = this.imageObj.disabled ? [] : [this.imageObj];
        } else if (this.imageType == 0) {
            osList = _.flatten(_.map(this.osImageList, 'images'));
        } else {
            osList = _.flatten(_.map(this.GameImageList, 'images'));
        }
        var imageId = this.imageId || {};

        var isChange = _.find(osList, (item) => {
            return imageId == item.value && !item.disabled; //判断上次记录镜像是否支持当前机型
        });

        var imageObj = this.imageObj || {};

        var customImageIndex = 0;
        if (this.diyImageId && this.theSameRegion && this.sourcePage == 'imageView') {
            customImageIndex = _.findIndex(osList, (item) => {
                return this.diyImageId == item.value;
            });

        } else if (this.osImageId && this.theSameRegion && this.sourcePage == 'osImageView') {
            customImageIndex = _.findIndex(osList, (item) => {
                return this.osImageId == item.value;
            });

        } else if (this.sourcePage == 'modifyTemplate' || this.sourcePage == 'buyTemplate') {
            customImageIndex = _.findIndex(osList, (item) => {
                return item.value == _.get(this.startTempData, 'ImageId');
            });
        } else if (this.sourcePage == 'createTheSameConfig') {
            customImageIndex = _.findIndex(osList, (item) => {
                return item.value == _.get(this.theSameConfigData, 'ImageId');
            });
        }
        // customImageIndex = customImageIndex > -1 ? customImageIndex : 0;
        if (osList.length > 0) {

            if (!isChange) {
                var _imgObj = _.find(osList, (item) => {
                    return imageObj.value == item.value && !item.disabled;
                });
                var activeOsList = _.filter(osList, (item) => {
                    return !item.disabled;
                });
                if (_imgObj) {
                    this.imageId = _imgObj.value;
                } else {
                    if (activeOsList.length) {
                        // if ((this.diyImageId && this.theSameRegion && this.sourcePage == 'imageView') || (this.sourcePage == 'modifyTemplate') || (this.sourcePage == 'buyTemplate')) {
                        if ((this.diyImageId && this.theSameRegion && this.sourcePage == 'imageView') || (this.osImageId && this.theSameRegion && this.sourcePage == 'osImageView') || (this.sourcePage == 'modifyTemplate') || (this.sourcePage == 'buyTemplate')) {

                            // 如果当前镜像是不支持的，那么需要置空，所以此处需要使用 osList，而不是activeOsList
                            if (this.imageType != 4 && customImageIndex > -1 && !_.get(osList, '[' + customImageIndex + '].disabled')) { // 不是镜像市场 并且 支持当前镜像
                                this.imageObj = _.get(osList, '[' + customImageIndex + ']', {});
                                this.imageId = _.get(osList, '[' + customImageIndex + '].value', '');
                            } else {
                                this.imageObj = {};
                                this.imageId = '';
                            }
                        } else if (this.sourcePage == 'createTheSameConfig') {
                            if (this.imageType != 4 && !_.get(osList, '[' + customImageIndex + '].disabled') && customImageIndex > -1) {
                                this.imageObj = _.get(osList, '[' + customImageIndex + ']', {});
                                this.imageId = _.get(osList, '[' + customImageIndex + '].value', '');
                            } else {
                                this.imageObj = {};
                                this.imageId = '';
                            }
                        } else {
                            this.imageObj = _.get(activeOsList, '[0]', {});
                            this.imageId = _.get(activeOsList, '[0].value', '');
                        }
                    } else {
                        this.imageObj = {};
                        this.imageId = '';
                    }
                }

            } else {
                if (this.sourcePage == 'imageView' || this.sourcePage == 'osImageView') {
                    const imageId = this.sourcePage == 'imageView' ? this.diyImageId : this.osImageId
                    let imageObj = _.find(osList, (item) => {
                        return imageId == item.value;
                    });
                    if (imageObj.disabled) {
                        this.imageObj = {};
                        this.imageId = '';
                    } else {
                        this.imageObj = imageObj;
                        if (this.sourcePage == 'imageView') {
                            this.imageId = this.diyImageId;
                        } else {
                            this.imageId = this.osImageId;
                        }

                    }
                } else {
                    this.imageId = imageObj.value;
                }
            }
        } else {
            this.imageObj = {};
            this.imageId = '';
        }

        this._onImageChange();
    }

    isDisableDataDiskType(type: string, key: number) {
        // 本地盘制作的整机镜像不支持开ESSD数据盘
        if (type === 'ESSD') {
            if (!this.imageObj) return false;
            const snapshot = _.find(this.imageObj.SnapshotSet, item => {
                return item.SnapshotId === this.ebsSnapList[key].snapId;
            });
            if (snapshot && snapshot.Type === 'data' && snapshot.DiskType === 'local_snapshot') {
                return '本地盘制作的整机镜像不支持开ESSD数据盘';
            }
        }

        return false;
    }

    formateOsImage() {
        var regionKey = this.regionKeyCheck;
        var os = _.cloneDeep(this.osImages);
        var osImageList: any[] = [];
        let me = this;

        if (this.pageLanguage == 'en') {
            _.forEach(os, (item) => {
                _.forEach(item, (subItem) => {
                    if (subItem.imageEnName) {
                        subItem.imageName = subItem.imageEnName;
                    }
                });
            });
        }

        _.mapKeys(os, (value, key) => {
            var obj = {
                osType: key,
                images: _.filter(value, (t) => {
                    return t.imageId;
                })
            }
            osImageList.push(obj);
        })
        var GameImage = _.filter(osImageList, (item) => {
            return item.osType == "GameImage";
        });

        this.GameImageList = _.map(GameImage, (item) => {
            _.map(item.images, (img) => {
                img.title = img.imageName;
                img.value = img.imageId;
                img.templateClass = 'icon icon-game-server-16 c-v-middle';
                return img && img.imageId;
            });
            item.templateClass = 'icon icon-game-server-16 c-v-middle';
            return item;
        });
        osImageList = _.filter(osImageList, (item) => {
            return item.osType != "GameImage";
        });

        // 标准镜像排序
        let osTypeOrder = ['centos', 'windows', 'ubuntu', 'fedora', 'debian', 'openeuler', 'rockylinux'];
        osImageList = _.filter(osImageList, (item) => {
            return _.includes(osTypeOrder, item.osType.toLowerCase());
        });
        let images = _.sortBy(osImageList, function (item) {
            return _.indexOf(osTypeOrder, item.osType.toLowerCase());
        });
        // 镜像版本从高到低
        _.each(images, function (item) {
            item.images = _.sortBy(item.images, function (image) {
                let version = image.imageVersion && image.imageVersion.match(/(\d+\.?)+/);
                // 字符排序
                return version;
            }).reverse();
        });
        images = this._filterOsImage(images);
        if (me.isCluster) {
            //容器只支持一种镜像
            let cluImage: any[] = [];
            _.each(images, item => {
                let obj = _.filter(item.images, img => {
                    img.title = img.imageName;
                    img.value = img.imageId;
                    img.templateClass = (item.osType || "").toLowerCase();
                    return (img.imageId == 'b2e78146-58f1-4298-9397-ebf942246a2b' || img.imageId == 'd3410864-1cf1-418f-9afe-c70aa3fa9cd4')
                })
                if (obj.length > 0) {
                    cluImage.push({
                        osType: item.osType,
                        images: obj
                    })
                }
            })
            this.osImageList = cluImage;
        } else {
            this.$set(this, 'osImageList', _.map(images, (item) => {
                _.map(item.images, (img) => {
                    img.title = img.imageName;
                    img.value = img.imageId;
                    img.templateClass = (item.osType || "").toLowerCase();
                    return img;
                });
                item.templateClass = (item.osType || "").toLowerCase();
                return item;
            }));
        }
        this._setImageId();
    }

    _fetchGpuCollect(kecType: number) {
        let azObj = _.find(this.azList, ['azCode', this.azCode]);
        let proObj = _.find(azObj.data, ['productTypeId', kecType]);
        let packageList = _.get(proObj, 'product.packageList', []);
        let sets: any = {};
        // let vGpuNum = 0;
        _.each(packageList, item => {
            let hasIt = _.find(item.refRegionList, r => {
                let hasIt = ''
                if (this.azCode === 'all') {
                    hasIt = _.find(r.azList, ['azCode', this.checkedRows[0].azCode]);
                } else {
                    hasIt = _.find(r.azList, ['azCode', this.azCode]);
                }
                return hasIt;
            });
            if (!hasIt) {
                return;
            }
            hasIt = _.find(item.refBillTypeList, ['billTypeId', this.orderBill]);
            //
            if (!hasIt && this.orderBill != 2017) {
                return;
            }
            let gpu = _.get(_.find(item.packageInfo, ["propCode", "gpu"]) || {}, 'propValue[0].min') || 1;
            let cpu = _.get(_.find(item.packageInfo, ["propCode", "cpu"]) || {}, 'propValue[0].min');
            let mem = _.get(_.find(item.packageInfo, ["propCode", "mem"]) || {}, 'propValue[0].min');
            let spec = _.get(_.find(item.packageInfo, ["propCode", "spec"]) || {}, 'propValue[0].value');

            if (!sets[gpu]) {
                sets[gpu] = {};
            }
            //G1机型、vGN5机型、vGN6机型 增加spec属性
            if (spec) {
                sets[gpu]["spec"] = spec
            }

            let set = sets[gpu];
            if (!set[cpu]) {
                set[cpu] = {};
            }
            let setm = set[cpu];
            setm[mem] = {};
            setm[mem].id = item.packageCode;
            setm[mem].packageInfo = item.packageInfo;
        });
        var sortSets: any = {};
        _.each(_.sortBy(_.keys(sets), function (item) {
            return item;
        }), function (item) {
            var sortCpuSets: any = {};
            _.each(_.sortBy(_.keys(sets[item]), function (item) {
                return item;
            }), function (cpu) {
                var sortMemSets: any = {};
                _.each(_.sortBy(_.keys(sets[item][cpu]), function (item) {
                    return item;
                }), function (mem) {
                    sortMemSets[mem] = sets[item][cpu][mem];
                })
                sortCpuSets[cpu] = sets[item][cpu];
            });
            sortSets[item] = sortCpuSets;
        });
        this.gpuCollect = sortSets;
        this.gpuList = _.keys(sortSets);
        if (!this.gpu || !_.includes(this.gpuList, this.gpu.toString())) {
            this.gpu = this.gpuList[0];
        }
    }

    _filterOsImage(osList: any[]) {
        var res = osList;
        var pTypeConfig = this.pTypeConfig;
        var kecType = this.kecType;
        var isConfig;
        isConfig = _.find(pTypeConfig, (item) => {
            return item.p_type == kecType;
        });
        var imageLimitList = [];
        if (!isConfig) {
            imageLimitList = [this.$trans(`没有配置该主机类型的标准镜像`)];
        } else {
            imageLimitList = isConfig.imageList || [];
        }
        if (this.isGpu && kecType) {
            this._fetchGpuCollect(kecType);
        }

        if (kecType == 321 || kecType == 377) { //GPU虚拟型(vGN5) 、GPU虚拟型(vGN6) 镜像列表需要获取supportImages, 根据套餐匹配
            var supportImages = isConfig.supportImages || [];
            var setMealId = this.gpuCollect[this.gpu][this.cpu][this.mem].id;
            imageLimitList = supportImages[setMealId];
        }

        if (kecType !== 0 && imageLimitList.length > 0) {
            let regexpStr = _.map(imageLimitList, function (item) {
                return '(^' + item + '$)'
            }).join('|');
            let regexp = new RegExp(regexpStr, 'i');
            res = _.filter(osList, (item) => {
                item.images = _.filter(item.images, (img) => {
                    return regexp.test(img.imageVersion);
                });
                return !_.isEmpty(item.images);
            });
            return res;
            // } else {
            //     return res;
        }
        return res;
    }

    _fetchImageTypeList() {
        let imageTypeList = [];
        let osImage = {
            name: this.$trans(`标准镜像`), //'标准镜像',
            imageType: 0
        };
        let diyImage = {
            name: this.$trans(`自定义镜像`), //'自定义镜像',
            imageType: 1
        };
        let shareImage = {
            name: this.$trans(`共享镜像`), //'共享镜像',
            imageType: 3
        };
        let marketImage = {
            name: this.$trans(`镜像市场`), //'镜像市场',
            imageType: 4
        };

        if (this.isAs) {
            // 弹性伸缩只支持自定义镜像
            imageTypeList.push(diyImage);
            this.imageTypeList = imageTypeList;
            this.imageType = 1;
        } else if (this.kecType == 388 || this.kecType == 401) { //AC2、FC1机型只支持标准镜像 和 自定义镜像
            imageTypeList.push(osImage);
            imageTypeList.push(diyImage);
            this.imageTypeList = imageTypeList;
            this.imageType = 0;
        } else if (this.kecType == 40 || this.kecType == 305 || this.onlyCommonConfig) { // N1、AC1、机型只支持标准镜像
            imageTypeList.push(osImage);
            this.imageTypeList = imageTypeList;
            this.imageType = 0;
        } else if (this.isDpu()) { // DPU机型只支持标准镜像
            imageTypeList.push(osImage);
            this.imageTypeList = imageTypeList;
            this.imageType = 0;
        } else if (this.orderBill == 2017) { // 试用不支持云市场镜像
            imageTypeList.push(osImage);
            imageTypeList.push(diyImage);
            imageTypeList.push(shareImage);
            this.imageTypeList = imageTypeList;
            this.imageType = 0;
        } else {
            imageTypeList.push(osImage);
            imageTypeList.push(diyImage);
            imageTypeList.push(shareImage);

            // 英文版控制台不支持镜像市场
            if (this.pageLanguage == 'zh') {
                imageTypeList.push(marketImage);
            }
            this.imageTypeList = imageTypeList;
            // (this.diyImageId && this.theSameRegion) ? this.imageType = 1: this.imageType = 0; //默认镜像类型
            if (this.diyImageId && this.theSameRegion && this.sourcePage == 'imageView') {
                this.imageType = 1;
            }
            if (this.osImageId && this.theSameRegion && this.sourcePage == 'osImageView') {
                this.imageType = 0;
            }
            if (this.sourcePage == 'cloudMarket') {
                this.imageType = 4;
            }
        }

        //海外机房屏蔽镜像市场
        let isOverSeas = _.get(this.regionInfos, '[' + this.regionKeyCheck + '].is_foreign', false)

        if (isOverSeas) {
            let overseasindex = _.findIndex(imageTypeList, item => {
                return item.imageType == 4;
            });
            if (overseasindex > -1) {
                imageTypeList.splice(overseasindex, 1);
                this.imageTypeList = imageTypeList;
                // this.imageType = 0;
                (this.diyImageId && this.theSameRegion) ? this.imageType = 1 : this.imageType = 0; //默认镜像类型
            }

        }

        // 不存在游戏客户了 去掉
        // if (_.get(this, 'locals.userInfo.isGameUser', false)) {
        //     imageTypeList.push({
        //         name: this.$trans(`游戏云专属`),
        //         imageType: 2
        //     }); //游戏云专属
        // }

        if (this.sourcePage == 'modifyTemplate' || this.sourcePage == 'buyTemplate') {
            let isPublic = _.get(this.startTempData, 'imageInfo.IsPublic');
            let imageSource = _.get(this.startTempData, 'imageInfo.ImageSource');
            let platform = _.get(this.startTempData, 'imageInfo.Platform');
            let IsCloudMarket = _.get(this.startTempData, 'imageInfo.IsCloudMarket');
            let UserCategory = _.get(this.startTempData, 'imageInfo.UserCategory');
            if (isPublic) { // 标准镜像
                this.imageType = 0;
            } else if (IsCloudMarket || UserCategory == "cloudMarket") { // 镜像市场
                this.imageType = 4;
            } else if (imageSource == 'import' || imageSource == 'copy' || imageSource == 'extend') { // 自定义镜像（导入、复制、自定义）
                this.imageType = 1;
            } else if (imageSource == 'share') { // 共享镜像
                this.imageType = 3;
            } else { // 游戏云专属
                this.imageType = 2;
            }
        }
        if (this.sourcePage == 'createTheSameConfig') {
            let isPublic = _.get(this.theSameConfigData, 'imageInfo.IsPublic');
            let imageSource = _.get(this.theSameConfigData, 'imageInfo.ImageSource');
            let UserCategory = _.get(this.theSameConfigData, 'imageInfo.UserCategory');
            if (isPublic) { // 标准镜像
                this.imageType = 0;
            } else if (UserCategory === "cloudMarket" && imageSource === "system") { // 镜像市场 2021-03-11跟桑老板对的值
                this.imageType = 4;
            } else if (imageSource == 'import' || imageSource == 'copy' || imageSource == 'extend') { // 自定义镜像（导入、复制、自定义）
                this.imageType = 1;
            } else if (imageSource == 'share') { // 共享镜像
                this.imageType = 3;
            } else { // 游戏云专属
                this.imageType = 2;
            }
            // this.imageId = _.get(this.theSameConfigData, 'ImageId')
            if (_.isEmpty(this.imageObj)) {
                if (this.imageType === 4) {
                    this.imageObj = {
                        name: _.get(this.theSameConfigData, 'imageInfo.Name'), //镜像市场名称
                        imageId: _.get(this.theSameConfigData, 'ImageId'),
                        title: _.get(this.theSameConfigData, 'imageInfo.Name'),
                        value: _.get(this.theSameConfigData, 'imageInfo.ImageId'),
                        Platform: _.get(this.theSameConfigData, 'imageInfo.Platform'),
                        IsModifyType: _.get(this.theSameConfigData, 'imageInfo.IsModifyType'),
                        CloudInitSupport: false,
                    };
                }
                this.imageId = _.get(this.theSameConfigData, 'ImageId');
            }
        }
    }

    _onImageChange() { //镜像改变会改变系统盘
        // debugger;
        var imageObj = this.imageObj;
        // 没有镜像
        if (!imageObj || _.isEmpty(imageObj)) {
            return;
        }
        let me = this,
            cloudOsType,
            isWindows = false,
            isWin2008 = false,
            isUbuntu = false,
            sysDisk = 0;
        if (me.imageType === 0) {
            // 标准镜像和
            cloudOsType = imageObj.imageVersion;
            isWindows = /win.*/i.test(cloudOsType.toLowerCase());
            isWin2008 = /win.*2008/i.test(imageObj && imageObj.imageVersion);
            isUbuntu = /ubuntu/i.test(imageObj && imageObj.imageVersion);
        } else if (me.imageType === 1 || me.imageType === 3 || me.imageType === 4) {
            // 自定义镜像
            cloudOsType = imageObj.Platform || imageObj.osVersion;
            isWindows = /windows/.test(cloudOsType);
            isWin2008 = /win.*2008/i.test(cloudOsType);
            isUbuntu = /ubuntu/i.test(cloudOsType);
            sysDisk = imageObj.SysDisk || _.get(imageObj, 'imageDetail.minDisk');
        } else if (me.imageType === 2) {
            //游戏云镜像
            cloudOsType = imageObj.imageVersion;
            isWindows = /win.*/i.test(cloudOsType.toLowerCase());
            isUbuntu = /ubuntu/i.test(cloudOsType.toLowerCase());
        }
        // 是否是windows系统的标识
        this.isWindows = isWindows;
        this.isWin2008 = isWin2008;
        this.isUbuntu = isUbuntu;

        var sysDiskType = commonConst.isCommonModelType(this.kecType) ? 'ebs_ssd' : 'ssd';

        this.systemDisk = {
            type: sysDiskType,
            value: isWindows ? (isWin2008 ? 40 : 50) : 20 //isWindows ? (isWin2008 ? 40 : 50) : 20
        };

        if (this.sourcePage == 'imageView') {
            let dataDisks = _.get(this.imageObj, 'SnapshotSet', []);
            if (dataDisks.length) {
                let sysDataDisks = _.filter(dataDisks, (item) => {
                    return item.index == 0;
                });
                if (sysDataDisks.length) {
                    sysDisk = sysDataDisks[0].DiskSize;
                }
            }
        }

        // 系统盘是ESSD类型时，不根据镜像重置盘大小，只根据价格体系配置展示盘的大小
        const sysType =  _.get(this.sysDiskObj, 'value', '')
        this.imageSysDisk = sysDisk // 镜像中带的系统盘大小值
        if(sysType !== 'ESSD'){
            // 当自定义镜像硬盘大于赠送硬盘大小时，获取较大值
            let sysDistValue = sysDisk > this.systemDisk.value ? sysDisk : this.systemDisk.value;
            let rem = sysDistValue % this.systemDiskStep;
            rem ? this.systemDiskMin = sysDistValue - rem + 10 : this.systemDiskMin = sysDistValue;
        }
        this.systemDiskObj = {
            minValue: this.systemDiskMin,
            maxValue: this.systemDiskMax
        }
        // 处理自定义镜像对云服务器类型的支持
        if (this.sourcePage == 'imageView') {
            let userCategory = _.get(imageObj, 'UserCategory', '');
            // let azCodeArr = [];
            let baseAllSelect: any[] = [];
            // if (userCategory == 'ebs' && sysDisk >= this.systemDisk.value && this.imageType == 1) {
            if (userCategory == 'ebs' && this.imageType == 1) {
                let kvmList = this.baseKvmList;
                this.diyImageId = _.get(imageObj, 'ImageId', '');
                if (kvmList.length == 0) {
                    return Message.error(Vue.$trans(`抱歉，您当前没有此商品购买权限，请联系客服进行相关处理400-028-9900。`));
                } else {
                    _.forEach(kvmList, (item) => {
                        // 判断是否支持通用型主机，N2 或 N3
                        let productTypeId = _.get(item, 'productTypeId', '');
                        if (commonConst.isAdjustSysDiskType(productTypeId)) {
                            var regionList = _.get(item, 'regionList', '');
                            var regionCode = _.map(regionList, (item) => {
                                return item.regionCode
                            })
                            // 判断是否有相同可用区权限
                            if (_.indexOf(regionCode, this.regionKey) > -1) {
                                this.diySupportUniversalHost = true;
                            }
                        }
                    });


                    _.forEach(this.azList, (item, index) => {
                        let azCode = _.get(item, 'azCode', []);
                        let setData = _.get(item, 'data', []);
                        _.forEach(setData, (subItem) => {
                            if (commonConst.isAdjustSysDiskType(subItem.productTypeId)) {
                                baseAllSelect.push({
                                    'azCode': azCode,
                                    'productTypeId': subItem.productTypeId
                                })
                            }
                        });
                    });

                    // debugger;
                    let isExit = _.find(this.kecTypeList, item => {
                        return item.productTypeId == this.kecType && !this.isSoldOutCheck(item.productTypeId);
                    });

                    let azCodeArr = _.map(baseAllSelect, 'azCode');

                    if (sysDisk > this.systemDisk.value) {
                        this.diyDiskSizeOverflow = true;
                        if (!commonConst.isAdjustSysDiskType(this.kecType)) {
                            if (this.diySupportUniversalHost && _.indexOf(azCodeArr, this.azCode) == -1) {
                                this.azCode = azCodeArr[0];
                            }
                        }
                    } else {
                        this.diyDiskSizeOverflow = false;
                    }

                    if (!isExit) {
                        if (_.indexOf(azCodeArr, this.azCode) == -1) {
                            this.azCode = azCodeArr[0];
                        }
                    }
                }
                this.isLocalImage = false;
            } else {
                this.diyDiskSizeOverflow = false;
                this.isLocalImage = true;
            }
            this.baseAllSelect = baseAllSelect;
        }

        // 判断镜像是否支持热升级，只识别通用型N2，其他支持需要通过PM确认
        if (this.kecType == 137) {
            this.isSupportHotUpgrade = _.get(this.imageObj, 'IsModifyType', false);
        }

        this.$emit('change:image', this);
    }

    //**************镜像部分end
    //**************快照开机部分
    _setCanSnapCreate() {
        //是否支持快照开机功能
        var kecType = this.kecType;
        // var regionKey = this.regionKeyCheck;
        //容器不支持快照开机
        // 弹性伸缩不支持快照开机
        // if (!~_.indexOf(["40", "137"], kecType) && !this.isGpu && !this.isCluster && !this.isAs) {
        // 137支持快照开机
        // if (!~_.indexOf(["40", 40], kecType) && !this.isGpu && !this.isCluster && !this.isAs) {
        if (!~_.indexOf(["40", 40], kecType) && !this.isCluster && !this.isAs) {
            if (this.snapInfo.snapChoose) {
                this.canSnapCreateDisk = false;
            } else {
                this.canSnapCreateDisk = true;
            }
        } else {
            this.canSnapCreateDisk = false;
        }
    }

    _snapCreate() {
        this.cloneDiskSize = this.diskSize;
        let params = {
            'type': 'snapCreateLocalDisk',
            'regionKey': this.regionKey,
            'diskObj': this.diskObj,
        };
        (this.$refs.snapCreateDia as any).handle(params);
    }

    checkSnap() {
        let me = this;
        return _.map(this.snapList, (item) => {
            if (item.MinDisk < me.diskObj.minValue || item.MinDisk > me.diskObj.maxValue) {
                // item.trTitle = "提示：快照大小超出数据盘容量范围，请选择" + this.diskObj.minValue + "~" + this.diskObj.maxValue + "GB的快照或更改CPU内存";
                item.trTitle = this.$trans(`提示：快照大小超出数据盘容量范围，请选择{0}~{1}GB的快照或更改CPU内存`, this.diskObj.minValue, this.diskObj.maxValue);
                item.disable = true;
            } else if (item.State.toUpperCase() != 'ACTIVE' && item.State.toUpperCase() != 'RESTORING') {
                // item.trTitle = "提示：当前不支持处于" + this.common.nameMap(data.row.State) + "的快照";
                item.trTitle = this.$trans(`提示：当前不支持处于{0}的快照`, this.snapNameMap[item.State.toLowerCase()]);
                item.disable = true;
            } else {
                item.trTitle = ''
            }
            return (item.MinDisk < me.diskObj.minValue || item.MinDisk > me.diskObj.maxValue || (item.State != 'ACTIVE' && item.State != 'RESTORING'))
        });
    }

    // checkEbsSnap() {
    //     let me = this;
    //     return _.map(this.ebsSnaps, (item, idx) => {
    //         if (item.Size < me.ebsDiskObjs[this.snapEbsIdx].minValue || item.Size > me.ebsDiskObjs[this.snapEbsIdx].maxValue) {
    //             // item.trTitle = "提示：快照大小超出数据盘容量范围，请选择" + this.diskObj.minValue + "~" + this.diskObj.maxValue + "GB的快照或更改CPU内存";
    //             item.trTitle = this.$trans(`提示：快照大小超出数据盘容量范围，请选择{0}~{1}GB的快照或更改CPU内存`, this.ebsDiskObjs[this.snapEbsIdx].minValue, this.ebsDiskObjs[this.snapEbsIdx].maxValue);
    //             item.disable = true;
    //         } else if (item.SnapshotStatus.toLowerCase() != 'available') {
    //             // item.trTitle = "提示：当前不支持处于" + this.common.nameMap(data.row.State) + "的快照";
    //             // item.trTitle = this.$trans(`提示：当前不支持处于{0}的快照`, this.snapNameMap[item.State.toLowerCase()]);
    //             item.trTitle = this.$trans(`当前仅支持状态处于可用的快照`);
    //             item.disable = true;
    //         } else {
    //             item.trTitle = ''
    //         }
    //         return (item.Size < me.ebsDiskObjs[this.snapEbsIdx].minValue || item.Size > me.ebsDiskObjs[this.snapEbsIdx].maxValue || (item.SnapshotStatus != 'available'))
    //     });
    // }

    snapClick(val: any) {
        if (!val.row.disable) {
            this.snapInfoClick.snapId = val.row.LocalVolumeSnapshotId;
            this.snapInfoClick.snapName = val.row.LocalVolumeSnapshotName;
            this.snapInfoClick.snapCpacity = val.row.MinDisk;
            this.snapBtnStatus = false;
        }
    }

    _snapCancel() {
        this.snapPage.current = 1;
        this.snapSearch = '';
        if (this.snapInfo.snapChoose) {
            this.canSnapCreateDisk = true;
            // this.snapInfo.snapChoose = false;
            this.snapInfo = {
                snapChoose: false,
                snapId: '',
                snapName: '',
                snapCpacity: ''
            };

            this.diskSize = this.cloneDiskSize;
            this.snapBtnStatus = true;
            this.diskObj.minValue = this.cloneDiskSize
        }
    }

    // trMouseover(data: any) {
    //     let dom = '<div class="ui-tooltip">' + data.row.trTitle + '</div>';
    //     if (data.row.trTitle) {
    //         $('body').append(dom);
    //         this.$nextTick(() => {
    //             $(".ui-tooltip").css({
    //                 top: $(document).scrollTop() + data.e.clientY,
    //                 left: data.e.clientX
    //             })
    //         })
    //     }
    //
    // }
    //
    // trMouseout(data: any) {
    //     $('.ui-tooltip').remove()
    // }

    //************快照开机部分 end
    // bill region az cpu mem arch sort 改变 start
    // bill change
    _orderBillChange() {
        let me = this;
        this.kecObj = _.find(this.orderBills, item => {
            return item.billTypeId == me.orderBill;
        }) || {};
        try {
            if (!_.isEmpty(this.kecObj)) {
                localStorage.kec_buy_order_bill = this.orderBill;
            }
        } catch (e) {
        }
        // console.log('_orderBillChange timestamp', new Date() - opTimeNow);
        this._fetchRegion();
        if (!this.isCluster) this._fetchImageTypeList();
        this._setCanSnapCreate();
    }

    //改变Region
    @debounce(debounceTimer)
    _fetchRegion() {
        let me = this;
        let kecObj = this.kecObj;
        this.bossRegionList = _.get(kecObj, 'regions', []);
        let isExit = _.find(this.bossRegionList, item => {
            return item.regionCode == me.regionKey;
        });
        if (!isExit) {
            this.regionKeyCheck = _.get(this.bossRegionList[0], 'regionCode');
        } else {
            this.regionKeyCheck = this.regionKey;
        }


        // 传给组件的参数只保留必需字段
        let newBossRegionList = _.map(this.bossRegionList, item => {
            return {
                areaCode: item.areaCode,
                regionCode: item.regionCode,
                regionName: item.regionName,
            }
        })
        this.newBossRegionList = this.tryDoChunkRework(newBossRegionList);

        // this.tryDoChunk('bossRegionList','newBossRegionList')
        this._fetchAz();
        this.describeSnapshotServiceStatus()
    }

    _regioChange() {
        this._fetchAz();
        this.describeEbsPerfQuotas();
        this.getcloudMarket();
    }
    getAZCode(azList: any[]){
        
        let count = 0
        let index = azList.length - 1 //保持原来的逻辑，如果都没有创建过实例，那么选中最后一个
        _.forEach(azList, (az,i:number) => {
            if(az.instanceCount > count){
                count = az.instanceCount
                index = i
            }
        })
        return azList[index].azCode
    }
    //改变region end
    //改变az
    @debounce(debounceTimer)
    _fetchAz() {
        let me = this;
        let regionObj = _.find(me.bossRegionList, item => {
            return me.regionKeyCheck == item.regionCode;
        });
        let az = _.get(regionObj, 'azs', []);


        this._fetchDescribeInstanceGroupCount().then((res: any) => {


            if (_.isEmpty(az)) {
                this.azList = [];
                this.hasAz = false;
                this.azCode = ''
            } else {

                // 下面的逻辑处理完毕之前，不直接给this上的字段赋值
                let azList = []
                let azCode = this.azCode
                let hasAz = false;
                if (res.Count > 0) {
                    _.forEach(res.Data, item => {
                        let obj = _.find(az, o => o.azCode === item.Value)
                        obj && (obj.instanceCount = item.Count)
                    })
                }
                if (this.sourcePage == 'imageView' && this.diyImageId && this.diySupportUniversalHost && this.diyRegionKey == this.regionKeyCheck) {
                    let azCodeArr = _.filter(this.diyAzList, (item) => {
                        return item.azCode.indexOf(this.diyRegionKey) != -1;
                    });

                    if (azCodeArr.length) {
                        azCode = this.diyAvailabilityZone ? this.diyAvailabilityZone : azCodeArr[0].azCode;
                    }

                    this.imageType = 1;
                }

                if (this.sourcePage == 'modifyTemplate' || this.sourcePage == 'buyTemplate') {
                    let _az = _.get(this.startTempData, 'AvailabilityZone');
                    if (_az.indexOf(this.regionKeyCheck) != -1) {
                        azCode = _az;
                    }
                }

                if (this.sourcePage == 'createTheSameConfig') {
                    let _az2 = _.get(this.theSameConfigData, 'AvailabilityZone');
                    if (_az2.indexOf(this.regionKeyCheck) != -1) {
                        azCode = _az2;
                    }
                }
                azList = az;
                // let isExit = _.find(azList, item => {
                //     return item.azCode == azCode;
                // });
                // if (!isExit) {
                //     // 俄罗斯1区可用区A优先，其他B优先
                //     if (this.regionKeyCheck === 'eu-east-1') {
                //         // this.azCode = _.get(_.first(this.azList), 'azCode');
                //         azCode = _.get(azList[1] || {}, 'azCode');
                //     } else {
                //         azCode = _.get(_.last(azList), 'azCode');
                //     }
                // }

                // 售罄不能放在isExists里面（不同计费方式下，同样的az可能售罄状态不一样）
                // 判断可用区是否有售罄情况
                let azSoldOutArr: any[] = [];
                let azNotSoldOutArr: any[] = [];

                _.forEach(azList, (azItem) => {
                    if (azItem.azCode === 'all') {
                        return;
                    }
                    let num = 0;
                    if (this.soldoutArr.length) {
                        let soldoutKecSet = _.get(_.find(this.soldoutArr, item => item.az == azItem.azCode) || {}, "kec", new Set());
                        if (soldoutKecSet.size) {
                            _.forEach(azItem.data, kecitem => {
                                if (soldoutKecSet.has(kecitem.productTypeId)) {
                                    num++;
                                }
                            })
                        }
                    } else {
                        console.log('没有售罄资源');
                    }
                    if (azItem.data.length == num) {
                        azSoldOutArr.push(azItem)
                    } else {
                        azNotSoldOutArr.push(azItem)
                    }
                });
                if (!azNotSoldOutArr.length) {
                    console.log('当前没有可用区可以选择！');
                    hasAz = false;
                    //仅仅是为了兼容随机可用区 全部可用区都禁用的时候，CPU和内存的数据
                    if (azCode === 'all') {
                        azCode = azList[0].azCode;
                    }
                    // return;
                } else {
                    if (_.findIndex(azNotSoldOutArr, (item) => {
                        return item.azCode == azCode;
                    }) == -1) {
                        azCode = this.getAZCode(azNotSoldOutArr)
                    }
                    hasAz = true;
                }

                this.azSoldOutArr = azSoldOutArr;
                this.azNotSoldOutArr = azNotSoldOutArr;

                

                

                // 净减字段
                this.azList = azList;
                this.azListForReworkComponent = _.map(azList, item => {
                    return {
                        azCode: item.azCode,
                        azName: item.azName,
                        instanceCount: item.instanceCount,
                        isSoldOut: !!_.find(azSoldOutArr, ['azCode', item.azCode])
                    }
                })
                this.hasAz = hasAz
                this.azCode = azCode
                this.quotaMaxDisk = this.RootSizeQuota[this.regionKey]; // 不可变系统盘机型 region维度接入Quota限制最大值
                this._fetchCpuList();
            }
        })
    }

    //改变az end
    // 改变CPU


    @debounce(debounceTimer)
    _fetchCpuList() {
        if (this.azList.length == 0) {
            return;
        }
        let cpuSoldoutArr: any[] = [];
        let azObj = _.find(this.azList, ['azCode', this.azCode]);
        let cpuList = _.get(azObj, 'cpuList', []);

        if (_.isEmpty(cpuList)) {
            return;
        }
        let soldoutKecSet = _.get(_.find(this.soldoutArr, item => item.az == this.azCode) || {}, "kec", new Set())
        if (soldoutKecSet.size) {
            _.forEach(cpuList, item => {
                let num = 0;
                _.forEach(item.data, kecitem => {
                    if (soldoutKecSet.has(kecitem.productTypeId)) {
                        num++;
                    }
                })
                if (item.data.length == num) {
                    cpuSoldoutArr.push(item)
                }
            })
        }

        if (this.closeAzSearchData) {
            const cpu = `${this.closeAzSearchData.cpu}`
            this.searchCPU = Number(cpu)
        }

        let isExit = _.find(cpuList, item => {
            return item.cpu_num == this.searchCPU && !this.isSoldOut(cpuSoldoutArr, item.cpu_num, 'cpu_num')
        })
        if (!isExit) {
            this.searchCPU = cpuList[0].cpu_num;
        }
        if (this.sourcePage == 'modifyTemplate' || this.sourcePage == 'buyTemplate') {
            let packageCode = _.get(this.startTempData, 'InstanceType', "");
            let packageData = _.find(azObj.data, item => {
                return item.packageCode == packageCode
            }) || {};
            let cpu = _.get(packageData, "cpu", "");
            this.searchCPU = cpu
            if (_.isEmpty(packageData)) {
                console.log('没有找到模板中的套餐')
            }
        }
        if (this.sourcePage == 'createTheSameConfig') {
            let packageCode = _.get(this.theSameConfigData, 'InstanceType', "");
            let packageData = _.find(azObj.data, item => {
                return item.packageCode == packageCode
            }) || {};
            let cpu = _.get(packageData, "cpu", "");
            this.searchCPU = cpu
            if (_.isEmpty(packageData)) {
                console.log('没有找到对应的套餐')
            }
        }
        this.getQueryCpu()  //从云市场详情页跳转逻辑
        // console.log(cpuList, 11111)
        this.cpuList = cpuList;
        this.cpuSoldoutArr = cpuSoldoutArr;
        this._fetchMemList();
    }

    @once
    getQueryCpu() {
        let queryCpu = getQueryString('cpu')
        if (this.sourcePage == 'cloudMarket' && queryCpu) {
            this.searchCPU = queryCpu === '全部' ? queryCpu : Number(queryCpu)
            // this.cloudMarketCount++
        }
    }


    @debounce(debounceTimer)
    _fetchMemList() {
        if (this.cpuList.length == 0) {
            return;
        }
        let memObj = _.find(this.cpuList, ['cpu_num', this.searchCPU]);
        let memList = _.get(memObj, 'memList', []);
        if (_.isEmpty(memList)) {
            return;
        }

        let memSoldoutArr: any[] = [];
        let soldoutKecSet = _.get(_.find(this.soldoutArr, item => item.az == this.azCode) || {}, "kec", new Set())
        if (soldoutKecSet.size) {
            _.forEach(memList, item => {
                let num = 0;
                _.forEach(item.data, kecitem => {
                    if (soldoutKecSet.has(kecitem.productTypeId)) {
                        num++;
                    }
                })
                if (item.data.length == num) {
                    memSoldoutArr.push(item)
                }
            })
        }
        if (this.closeAzSearchData) {
            this.searchMEM = this.closeAzSearchData.mem
        }

        let isExit = _.find(memList, item => {
            return item.mem == this.searchMEM && !this.isSoldOut(memSoldoutArr, item.mem, 'mem')
        })

        if (!isExit) {
            this.searchMEM = memList[0].mem;
        }
        if (this.sourcePage == 'modifyTemplate' || this.sourcePage == 'buyTemplate') {
            let packageCode = _.get(this.startTempData, 'InstanceType', "");
            let mem = _.get(_.find(memObj.data, item => {
                return item.packageCode == packageCode
            }) || {}, "mem", "")
            this.searchMEM = mem
        }
        if (this.sourcePage == 'createTheSameConfig') {
            let packageCode = _.get(this.theSameConfigData, 'InstanceType', "");
            let mem = _.get(_.find(memObj.data, item => {
                return item.packageCode == packageCode
            }) || {}, "mem", "")
            this.searchMEM = mem
        }
        //从云市场详情页跳转逻辑
        this.getQueryMem()

        this.memSoldoutArr = memSoldoutArr;
        this.memList = memList;
        this._fetchIpv6List();

    }

    @once
    getQueryMem() {
        let queryMem = getQueryString('mem')
        if (this.sourcePage == 'cloudMarket' && queryMem) {
            this.searchMEM = queryMem === '全部' ? queryMem : Number(queryMem)
            // this.cloudMarketCount++
        }
    }

    @debounce(debounceTimer)
    _fetchIpv6List() {
        let me = this;
        if (this.memList.length == 0) {
            return;
        }

        let ipv6Obj = _.find(this.memList, ['mem', this.searchMEM]);
        let supportipv6List = _.get(ipv6Obj, 'ipv6List', []);

        if (_.isEmpty(supportipv6List)) {
            return;
        }
        let ipv6SoldoutArr: any[] = [];
        let soldoutKecSet = _.get(_.find(this.soldoutArr, item => item.az == this.azCode) || {}, "kec", new Set())
        if (soldoutKecSet.size) {
            _.forEach(supportipv6List, item => {
                let num = 0;
                _.forEach(item.data, kecitem => {
                    if (soldoutKecSet.has(kecitem.productTypeId)) {
                        num++;
                    }
                })
                if (item.data.length == num) {
                    ipv6SoldoutArr.push(item)
                }
            })
        }

        let isExit = _.find(supportipv6List, item => {
            return item.ipv6Code == this.searchIPV6 && !this.isSoldOut(ipv6SoldoutArr, item.ipv6Code, 'ipv6Code');
        });
        if (!isExit) {
            this.searchIPV6 = supportipv6List[0].ipv6Code;
        }
        this.supportipv6List = supportipv6List;
        this.ipv6SoldoutArr = ipv6SoldoutArr;
        this._fetchArchList();
    }

    @debounce(debounceTimer)
    _fetchArchList() {
        let me = this;
        if (this.supportipv6List.length == 0) {
            return;
        }
        let archObj = _.find(this.supportipv6List, ['ipv6Code', this.searchIPV6]);
        let architectureList = _.get(archObj, 'archList', []);
        if (_.isEmpty(architectureList)) {
            return;
        }
        // 架构顺序
        architectureList = _.orderBy(architectureList, ['sortKey'], ['asc']);
        let archSoldoutArr: any[] = [];
        let soldoutKecSet = _.get(_.find(this.soldoutArr, item => item.az == this.azCode) || {}, "kec", new Set())
        if (soldoutKecSet.size) {
            _.forEach(architectureList, item => {
                let num = 0;
                _.forEach(item.data, kecitem => {
                    if (soldoutKecSet.has(kecitem.productTypeId)) {
                        num++;
                    }
                })
                if (item.data.length == num) {
                    archSoldoutArr.push(item)
                }
            })
        }
        let isExit = _.find(architectureList, item => {
            return item.archCode == this.architecture && !this.isSoldOut(archSoldoutArr, item.archCode, 'archCode');
        });
        if (!isExit) {
            this.architecture = architectureList[0].archCode;
        }
        if (this.sourcePage == 'modifyTemplate' || this.sourcePage == 'buyTemplate') {
            let productId = _.get(this.startTempData, 'OrderInfo.ProductType', "");
            this.architecture = this._getArchitecture(productId)
        }
        if (this.sourcePage == 'createTheSameConfig') {
            let productId = _.get(this.theSameConfigData, 'OrderInfo.ProductType', "");
            this.architecture = this._getArchitecture(productId)
        }
        if (this.sourcePage == 'osImageView') {
            for (let i = 0; i < this.SupportProductTypes.length; i++) {
                let productId = this.SupportProductTypes[i].productTypeId
                this.architecture = this._getArchitecture(productId)
                if (!archSoldoutArr.length || !archSoldoutArr.includes(this.architecture)) {
                    this.SupportProductType = this.SupportProductTypes[i]
                    break
                }
            }
        }
        ////从云市场详情页跳转逻辑
        this.getQueryProductId()
        this.architectureList = architectureList;
        this.tryDoChunk('architectureList', 'newArchitectureList')
        this.archSoldoutArr = archSoldoutArr;
        this._fetchSortsType();
    }

    @once
    getQueryProductId() {
        let queryProductId = getQueryString('productId')
        if (this.sourcePage == 'cloudMarket' && queryProductId) {
            this.architecture = this._getArchitecture(Number(queryProductId))
            // this.cloudMarketCount++
        }
    }

    //获取architecture(架构值)
    _getArchitecture(productId: number) {
        productId = typeof productId === 'number' ? productId : Number(productId)
        return productService.getArchById(productId);
        // // gpu计算型--GPU通用计算型(P3)、GPU推理计算型(P3I)、GPU通用计算型(P4V)  、GPU推理计算型(P3IN) 、推理Ⅱ型(GN6I)、GPU通用计算型(P3L)、GPU推理I型(GN5I)
        // let gpu = [353, 101, 326, 77, 125, 126, 142, 597]
        // // GPU虚拟化型--GPU虚拟型(vGN5)/GPU虚拟型（vGN6）
        // let vgpu = [321, 377];
        // let gpuIds = gpu.concat(vgpu);
        // let architecture = ''
        // if (productId == 198) {
        //     architecture = "amd"
        // } else if (productId == 305 || productId == 388 || productId == 401) { //AC1、AC2、FC1
        //     architecture = "arm"
        // } else if (_.includes(gpuIds, productId)) {
        //     architecture = "gpu"
        // } else {
        //     architecture = "x86"
        // }
        // return architecture
    }

    //改变产品类型
    @debounce(debounceTimer)
    _fetchSortsType() {
        let me = this;
        let geneObj = _.find(this.architectureList, ['archCode', this.architecture]);
        let sortList = _.get(geneObj, 'sortlist', []);
        sortList = _.orderBy(sortList, ['sortKey'], ['asc']);

        let sortsSoldOutArr: any[] = [];
        let soldoutKecSet = new Set();
        if (this.azCode === 'all') {
            let azArr: any[] = []
            _.forEach(this.azList, az => {
                let soldOutCodeObj = _.get(_.find(me.soldoutArr, item => item.az == az.azCode) || {}, "kec", new Set())
                azArr.push(...soldOutCodeObj)
            })
            if (this.azList.length > 2) {
                if (new Set(azArr).size !== azArr.length) {
                    let result = []
                    let res = azArr.reduce(function (res, c, index, arr) {
                        res[c] ? res[c]++ : res[c] = 1
                        return res
                    }, {})
                    for (let key in res) {
                        if (res[key] === this.azList.length) {
                            result.push(key)
                        }
                    }
                    soldoutKecSet = new Set(result)
                }
            } else {
                soldoutKecSet = new Set(azArr)
            }
        } else {
            soldoutKecSet = _.get(_.find(me.soldoutArr, item => item.az == this.azCode) || {}, "kec", new Set())
        }

        if (soldoutKecSet.size) {
            _.forEach(sortList, sitem => {
                let num = 0;
                _.forEach(sitem.data, kecitem => {
                    if (soldoutKecSet.has(kecitem.productTypeId)) {
                        num++;
                    }
                })
                if (sitem.data.length == num) {
                    sortsSoldOutArr.push(sitem)
                }
            })
        }
        if (this.closeAzSearchData) {
            this.sort = _.find(commonConst.AllKecType, o => _.includes(o.value, this.closeAzSearchData.productTypeId))?.title || ''
        }
        // console.log(sortList, 'sortList')
        let isExit = _.find(sortList, item => {
            return item.sortCode == me.sort && !this.isSoldOut(sortsSoldOutArr, item.sortCode, 'sortCode');
        });
        if (!isExit) {
            me.sort = _.get(sortList, "[0].sortCode", "");
        }
        if (this.sourcePage == 'modifyTemplate' || this.sourcePage == 'buyTemplate') {
            let idx = 0;
            for (let i = 1; i < sortList.length; i++) {
                if (sortList[i])
                    _.forEach(sortList[i].data, item => {
                        if (item.productTypeId === _.get(this.startTempData, 'OrderInfo.ProductType')) {
                            idx = i;
                        }
                    })
            }
            me.sort = sortList[idx].sortCode;
        }
        if (this.sourcePage == 'createTheSameConfig') {
            let idx = 0;
            for (let i = 1; i < sortList.length; i++) {
                if (sortList[i])
                    _.forEach(sortList[i].data, item => {
                        if (item.productTypeId === _.get(this.theSameConfigData, 'OrderInfo.ProductType')) {
                            idx = i;
                        }
                    })
            }
            me.sort = sortList[idx].sortCode;
        }
        this.sortList = sortList;
        this.tryDoChunk('sortList', 'newSortList')
        this.sortsSoldOutArr = sortsSoldOutArr;
        this._fetchKecTypeList();

        // console.log('_fetchKecType timestamp', new Date() - opTimeNow);
    }


    @debounce(debounceTimer)
    _fetchKecTypeList() {
        let me = this;
        let kecObj = _.find(this.sortList, ['sortCode', this.sort]);
        let kecList = _.get(kecObj, 'data', []);
        let pageKecList = [];

        let map = new Map();
        map.set('4', 4);
        map.set('3', 3);
        map.set('2', 2);
        map.set('1', 1);
        map.set("ARM", 0);
        map.set("gpu", -1);
        map.set("container instance", -2)
        kecList = kecList.sort((a: any, b: any) => {
            return map.get(b.generation) - map.get(a.generation)
        })

        // 按照系列从大到小排列，GPU机型排在最后面
        let kecDataList = _.filter(kecList, (item) => {
            return _.toNumber(item.generation);
        });
        let gpuDataList = _.filter(kecList, (item) => {
            return !_.toNumber(item.generation);
        });
        kecDataList = _.orderBy(kecDataList, ['generation', 'cpu', 'mem'], ['desc', 'asc', 'asc']); //非GPU机型排序 优先级：系列 > CPU > 内存
        gpuDataList = _.orderBy(gpuDataList, ['generation', 'cpu', 'mem'], ['desc', 'asc', 'asc']); //GPU机型排序 优先级：系列 > CPU > 内存
        kecList = kecDataList.concat(gpuDataList);

        // 相同机型数据按照固定顺序集合在一起;
        let _kecList: any[] = [];
        let otherKecType = _.filter(kecList, (item) => {
            return !commonConst.allKecTypeDefaultSort(item.productTypeId)
        });
        _.forEach(commonConst.allKecTypeDefaultSortCodes, (item) => {
            let tempKecList: any[] = [];
            _.forEach(kecList, (subItem) => {
                if (item == subItem.productTypeId) {
                    tempKecList.push(subItem);
                }
            });
            _kecList = _kecList.concat(tempKecList);
        });
        kecList = _kecList.concat(otherKecType);

        this.kecTypeList = kecList;
        // this.pages.totalRows = kecList.length;
        this.kecDisabled();
        // 把售罄数据放到最后
        let a = _.filter(this.kecTypeList, (item) => {
            return !item.disabled;
        });
        let b = _.filter(this.kecTypeList, (item) => {
            return item.disabled;
        });
        this.kecTypeList = a.concat(b);

        // console.log(this.kecTypeList, "当前所有kec.......");
        // pageKecList = this.kecTypeList.slice(0, this.pages.rowsPerPage)
        if (this.closeAzSearchData) {
            this.kecKey = this.closeAzSearchData.kecKey
        }
        let isExit = _.find(this.kecTypeList, item => {
            return item.kecKey == me.kecKey && !item.disabled;
        });
        if (!isExit) {
            let idx = _.findIndex(this.kecTypeList, item => {
                //从标准镜像跳转过来直接定位到镜像支持的套餐
                if (this.sourcePage == 'osImageView' && this.SupportProductType.instanceTypes) {
                    return !item.disabled && this.SupportProductType.instanceTypes.includes(item.packageCode)
                }
                return !item.disabled

            });
            if (this.sourcePage == 'modifyTemplate' || this.sourcePage == 'buyTemplate') {
                let templateProductType = _.get(this.startTempData, 'OrderInfo.ProductType')
                let typeIdx = _.findIndex(this.kecTypeList, ['productTypeId', templateProductType]);
                if (typeIdx !== -1) {
                    idx = typeIdx;
                }
            }
            if (this.sourcePage == 'createTheSameConfig') {
                let templateProductType = _.get(this.theSameConfigData, 'OrderInfo.ProductType')
                let typeIdx = _.findIndex(this.kecTypeList, ['productTypeId', templateProductType]);
                if (typeIdx !== -1) {
                    idx = typeIdx;
                }
            }
            this.kecKey = _.get(this.kecTypeList, [idx, 'kecKey'], "")
            this.kecType = _.get(this.kecTypeList, [idx, 'productTypeId'], 0)
            // this.pages.current = Math.floor(idx / 10) + 1;
            // pageKecList = this.kecTypeList.slice(Math.floor(idx / 10) * this.pages.rowsPerPage, (Math.floor(idx / 10) + 1) * this.pages.rowsPerPage)
        }
        pageKecList = this.kecTypeList
        this.pageKecList = pageKecList;
        //套餐中有支持ESSD的就展示云盘IOPS 和 云盘带宽 否则不展示
        if (_.some(pageKecList, pageItem => {
            const propValues = _.get(_.find(pageItem.propertyList, ['propCode', 'ebs-type']), 'propValue')
            if (_.some(propValues, propValueItem => {
                if (propValueItem.name.includes('ESSD')) {
                    return true
                }
            })) {
                return true
            }
        })){
            this.isExistSupportESSD = true
        } else {
            this.isExistSupportESSD = false
        }
        // this.pageKecList = _.cloneDeep(this.kecTypeList);
        this.calcuKecListPrice(pageKecList);

    }

    _checkHandler(c: any) {
        this.checkedRows = c.getCheckedData();
        let kectype = _.get(this.checkedRows, "[0].productTypeId", "")
        this.isSupportESSD = false;
        if (kectype) {
            this.changeUserPrice = true
            this.kecType = kectype
            this.kecTypeObj = this.checkedRows[0];
            
            // 判断该机型是否支持ESSD
            // 随机可用区不支持
            if (this.azCode !== 'all') {
                const propValues = _.get(_.find(this.kecTypeObj.propertyList, ['propCode', 'ebs-type']), 'propValue');
                if (_.some(propValues, item => {
                    return item.name.includes('ESSD');
                })) {
                    // 还需要判断ebs-packages中是否配置了当前可用区支持ESSD
                    const ebsPackages = _.get(_.find(this.kecTypeObj.propertyList, ['propCode', 'ebs-package']), 'propValue');
                    _.find(ebsPackages, pkg => {
                        if (pkg.productTypeCode.includes('ESSD')) {
                            // 判断region存在吗
                            const region = _.find(pkg.regionList, region => {
                                return region.regionCode === this.regionKeyCheck;
                            });

                            if (!region) return true;

                            // 判断azCode存在吗
                            const az = _.find(region.azList, az => {
                                return az.azCode === this.azCode;
                            });

                            if (!az) return true;

                            this.isSupportESSD = true;
                            return true;
                        }
                        return false;
                    });
                }
            }

            this.cpu = _.get(this.kecTypeObj, "cpu", "");
            this.mem = _.get(this.kecTypeObj, "mem", "");
            this.hdd = _.get(this.kecTypeObj, "hdd", 0);
            this.kecName = _.get(this.kecTypeObj, "productTypeName", "");
            let generation = _.get(this.kecTypeObj, "generation", "");
            generation = generation ? generation.toLowerCase() : '';
            let packageInfo = _.get(this.kecTypeObj, "packageInfo", "");
            if (generation == "gpu") {
                this.isGpu = true;
                this._fetchGpu(this.kecTypeObj);

            } else {
                this.isGpu = false;
            }
            if (this.kecName.indexOf("联网增强") != -1) {
                this.isEnhance = true;
            } else {
                this.isEnhance = false;
            }
            _.forEach(packageInfo, item => {
                if (item.propCode === 'cpu' || item.propCode === 'mem') {
                    let {max, min} = item.propValue[0]
                    if (max !== min) {
                        console.log('请找产品将cpu或者mem的最大和最小值配成一致的！！！！')
                    }
                }
            })
            this.deviceDiskNum = _.get(_.find(packageInfo, ["propCode", "device_disk_num"]) || {}, 'propValue[0].value') || 1;
            this._fetchImageTypeList();
            this.formateOsImage();
            this._setDisk();
            this._setSysDisk();
            this._setCanSnapCreate();
            this.calcuPrice();
        }

    }

    _fetchGpu(kecObj: any) {
        let gpu = _.get(_.find(kecObj.packageInfo, ["propCode", "gpu"]) || {}, 'propValue[0].min') || 1;
        this.gpu = gpu;
        this.gpuList = [gpu];
    }

    isSupportAz(az: string) {
        if (this.diySupportUniversalHost && !this.isLocalImage && this.diyDiskSizeOverflow) {
            if (_.findIndex(_.map(this.baseAllSelect, 'azCode'), item => {
                return item == az
            }) != -1) {
                return false;
            }
            return true;
        } else {
            return false;
        }
    }

    //改变disk
    _setSysDisk() {
        let me = this;
        let systemDiskTypes: any[] = [];
        let systemPerformances: any[] = [];
        if (this.orderBill == 1) { //计费方式为预付费（包年包月）
            this._hasSpecialDiscount();
            this._hasCommonDiscount();
        }

        let propertyList = _.get(me.checkedRows, '[0].propertyList', []);
        let sys = _.get(_.filter(propertyList, ['propCode', 'systemDisks'])[0], 'propValue', []);

        let ebsPackages = _.find(propertyList, ['propCode', 'ebs-package']);
        let ebsCodes: any[] = [];
        let notSopportEbsCodes: any[] = []
        if (ebsPackages) {
            _.forEach(ebsPackages.propValue, item => {
                // if (item.region) {}
                let region = _.find(item.regionList, ['regionCode', this.regionKey]);
                if (!region) {
                    notSopportEbsCodes.push(item.productTypeCode)
                }
                if (!region) {
                    return;
                }
                let az
                if (this.azCode === 'all') {
                    if (this.checkedRows) {
                        az = this.checkedRows[0].azCode
                    } else {
                        az = this.pageKecList[0].azCode
                    }
                } else {
                    az = _.find(region.azList, ['azCode', this.azCode]);
                }

                if (!az) {
                    notSopportEbsCodes.push(item.productTypeCode)
                }
                if (!az) {
                    return;
                }
                let billType;
                if (this.orderBill == 810) {
                    // 竞价非标处理，对应按小时实时计费
                    billType = _.find(item.billTypeList, ['billTypeId', 87]);
                } else {
                    billType = _.find(item.billTypeList, ['billTypeId', this.orderBill]);
                }


                if (!billType && this.orderBill != 2017) {
                    return;
                }
                ebsCodes.push(item.productTypeCode);
            });
        }


        if (sys.length > 0) {
            _.forEach(sys, (item) => {
                let isLocalDisk = item.value.toLowerCase().indexOf('local') != -1;
                let availabelEbs = _.includes(ebsCodes, item.value.replace('2.0', ''));
                let notSupportEbs = _.includes(notSopportEbsCodes, item.value.replace('2.0', ''));
                const productTypeCode = item.value.split('_')
                const pTypeCode = productTypeCode[0];
                

                if (isLocalDisk || availabelEbs) {
                    if(pTypeCode === 'ESSD') {
                        let min: number | null = null;
                        let max: number | null = null;
                        let step: number | null = null;
                        const packageItem = _.find(ebsPackages.propValue, ['productTypeCode', item.value]);

                        let packageStep = _.get(packageItem, 'propertyList[0].propValue[0].step');
                        let packageMin = _.get(packageItem, 'propertyList[0].propValue[0].min');
                        let packageMax = _.get(packageItem, 'propertyList[0].propValue[0].max');
                        if (min === null || min > packageMin) {
                            min = packageMin;
                        }
                        if (max === null || max < packageMax) {
                            max = packageMax;
                        }
                        if ((step == null || step > packageStep) && packageStep !== 0) {
                            step = packageStep;
                        }
                        if (!step) {
                            step = 1;
                        }

                        const pTypeLevel = productTypeCode[2]
                        const iopsSec = this._getIops(item.value)
                        const bytesSec = this._getByte(item.value)
                        systemPerformances.push({
                            title: this.$trans(`{0}（单盘性能上限IOPS：{1}万 吞吐量：{2}MB/s）`, pTypeLevel, iopsSec.Max/10000, bytesSec.Max),
                            value: item.value,
                            typeId: packageItem.productTypeId.toString(),
                            minValue: min,
                            maxValue: max,
                            stepValue: step,
                            isSoldOut: false,
                        })
                    } else {
                        systemDiskTypes.push({
                            value: item.value,
                            // title: me.$trans(item.value.replace(/\./, '_')) || item.name
                            title: me.allDiskNameMap[item.value] || item.name
                        });
                    }
                    
                }
                if (notSupportEbs) {
                    if(pTypeCode === 'ESSD') {
                        let min: number | null = null;
                        let max: number | null = null;
                        let step: number | null = null;
                        const packageItem = _.find(ebsPackages.propValue, ['productTypeCode', item.value]);

                        let packageStep = _.get(packageItem, 'propertyList[0].propValue[0].step');
                        let packageMin = _.get(packageItem, 'propertyList[0].propValue[0].min');
                        let packageMax = _.get(packageItem, 'propertyList[0].propValue[0].max');
                        if (min === null || min > packageMin) {
                            min = packageMin;
                        }
                        if (max === null || max < packageMax) {
                            max = packageMax;
                        }
                        if ((step == null || step > packageStep) && packageStep !== 0) {
                            step = packageStep;
                        }
                        if (!step) {
                            step = 1;
                        }

                        const pTypeLevel = productTypeCode[2]
                        const iopsSec = this._getIops(item.value)
                        const bytesSec = this._getByte(item.value)
                        systemPerformances.push({
                            title: this.$trans(`{0}（单盘性能上限IOPS：{1}万 吞吐量：{2}GB/s）`, pTypeLevel, iopsSec.Max/10000, bytesSec.Max/1000),
                            value: item.value,
                            typeId: packageItem.productTypeId.toString(),
                            minValue: min,
                            maxValue: max,
                            stepValue: step,
                            isSoldOut: false,
                            isNotSupportEBS: true
                        })
                    } else {
                        systemDiskTypes.push({
                            value: item.value,
                            // title: me.$trans(item.value.replace(/\./, '_')) || item.name,
                            title: me.allDiskNameMap[item.value] || item.name,
                            isNotSupportEBS: true
                        });
                    }
                }
            });
        }
        //产品需求：SSD3.0排在最前面
        systemDiskTypes = _.sortBy(systemDiskTypes, (item) => {
            let ssdValue = _.last(item.value.split('.')[0].split(''));
            return Number(ssdValue) * -1; //倒序排列
        });

        if(systemPerformances.length) {
            systemDiskTypes.unshift({
                value: 'ESSD',
                title: me.$trans(`ESSD云硬盘`),
            });
        }

        if (systemDiskTypes.length === 0) {
            systemDiskTypes = [{
                value: '',
                title: me.$trans(`未配置系统盘`), //未配置系统盘
            }];
        }
        // //产品需求：系统盘也需要检查EBS列表是否有售罄，如果有售罄项目则过滤掉
        systemDiskTypes = _.filter(systemDiskTypes, item => {
            let hasIt = _.find(this.soldoutList, soldoutItem => {
                if(soldoutItem.AvailabilityZone === this.azCode && soldoutItem.VolumeTypeCode == item.value){
                    if(soldoutItem.SellOutStatus || _.find(soldoutItem.VmSellOuts, vmItem => vmItem.VmTypeId == this.kecType)){
                        return true
                    }
                }
                return false

            });
            // return !hasIt;
            if (hasIt && !item.isNotSupportEBS) {
                item.isSoldOut = true
            }
            return item
        });

        if(systemPerformances.length){
            //按照从大到小排序
            systemPerformances = _.sortBy(systemPerformances, (item) => {
                const type:string = _.last(item.value.split('_')) || ''
                let levelValue = _.last(type.split(''));
                return -Number(levelValue); //倒序排列
            });

            //查看当前系统盘的性能级别是否售罄
            systemPerformances = _.filter(systemPerformances, item => {
                let hasIt = _.find(this.soldoutList, soldoutItem => {
                    if(soldoutItem.AvailabilityZone === this.azCode && soldoutItem.VolumeTypeCode == item.value){
                        if(soldoutItem.SellOutStatus || _.find(soldoutItem.VmSellOuts, vmItem => vmItem.VmTypeId == this.kecType)){
                            return true
                        }
                    }
                    return false
                });
                // return !hasIt;
                if (hasIt && !item.isNotSupportEBS) {
                    item.isSoldOut = true
                }
                return item
            });

            //如果机型的当前可用区不支持PL0 - PL2，那么ESSD云硬盘也不支持
            if(_.every(systemPerformances,item => item.isSoldOut)){
                systemDiskTypes[0].isNotSupportEBS = true
            }

            //如果PL0 - PL2 都是售罄，那么ESSD云硬盘也售罄
            if(_.every(systemPerformances,item => item.isSoldOut)){
                systemDiskTypes[0].isSoldOut = true
            }
        }


        this.systemDiskTypes = systemDiskTypes;

        if(systemPerformances.length){
            this.systemPerformances = systemPerformances;
        }

        const sysDiskObj = _.filter(systemDiskTypes, item => {
            return !item.isSoldOut && !item.isNotSupportEBS
        })[0] || {}
        this.sysDiskObj = sysDiskObj
        this.systemDiskType = sysDiskObj.value
        this.systemDiskTypesCopy = systemDiskTypes;

        //当默认的系统盘类型是ESSD时，默认展示第一个未售罄并且当前可用区支持的性能级别
        if(this.systemDiskType === 'ESSD'){
            let systemPerformanceItem = _.find(systemPerformances,item => item.value === 'ESSD_SYSTEM_PL1' && !item.isSoldOut && !item.isNotSupportEBS)
            if(!systemPerformanceItem){
                systemPerformanceItem = _.filter(systemPerformances, item => {
                    return !item.isSoldOut && !item.isNotSupportEBS
                })[0] || {}
            }
            this.sysPerformanceLevel = systemPerformanceItem.value
        }

        if (this.sourcePage == 'modifyTemplate' || this.sourcePage == 'buyTemplate') {
            let _diskType = _.get(this.startTempData, 'SystemDisk.DiskType');
            if(_diskType.includes('ESSD')){
                this.sysPerformanceLevel = _diskType
                _diskType = 'ESSD'
            }
            
            let templateSysDiskObj =  _.find(systemDiskTypes, (item) => item.value == _diskType);

            if(_.isEmpty(templateSysDiskObj)){
                templateSysDiskObj = _.filter(systemDiskTypes, item => {
                    return !item.isSoldOut && !item.isNotSupportEBS
                })[0] || {}
                _diskType = templateSysDiskObj.value
            }
            
            if(templateSysDiskObj.isSoldOut || templateSysDiskObj.isNotSupportEBS){
                templateSysDiskObj = {}
                _diskType = ''
            }

            this.sysDiskObj = templateSysDiskObj
            this.systemDiskType = _diskType;
            this.systemDiskSize = _.get(this.startTempData, 'SystemDisk.DiskSize');
        }
        if (this.sourcePage == 'createTheSameConfig') {
            let _diskType = _.get(this.theSameConfigData, 'SystemDisk.DiskType');
            if(_diskType.includes('ESSD')){
                this.sysPerformanceLevel = _diskType
                _diskType = 'ESSD'
            }
            let templateSysDiskObj =  _.find(systemDiskTypes, (item) => {
                if (item.value == _diskType) {
                    return item.title;
                }
            });
            if(_.isEmpty(templateSysDiskObj)){
                templateSysDiskObj = _.filter(systemDiskTypes, item => {
                    return !item.isSoldOut && !item.isNotSupportEBS
                })[0] || {}
                _diskType = templateSysDiskObj.value
            }
            if(templateSysDiskObj.isSoldOut || templateSysDiskObj.isNotSupportEBS){
                templateSysDiskObj = {}
                _diskType = ''
            }
            this.sysDiskObj = templateSysDiskObj
            this.systemDiskSize = _.get(this.theSameConfigData, 'SystemDisk.DiskSize');
            this.systemDiskType = _diskType;
        }


        this.getQuerySsd()  //从云市场详情页跳转逻辑
        me._setIsShowSlider();
    }

    @once
    getQuerySsd() {
        let querySsd = getQueryString('ssd')
        if (this.sourcePage == 'cloudMarket' && querySsd) {
            this.systemDiskSize = Number(querySsd)
            // this.cloudMarketCount++
        }
    }

    _setIsShowSlider() {
        let me = this;
        if (commonConst.isAdjustSysDiskType(me.kecType)) {
            me.isShowSlider = true;
            me._setSyeDiskMax();
        } else {
            me.isShowSlider = false;
        }
    }

    snapCreateDiskList(dataDisks: any[], options?:{isFromWhere?: string, localSnapshot?:any[]}) {
        let snapFilterList: any[] = [];
        let snapshots: any[] = [];
        const isFromWhere = options?.isFromWhere;
        const localSnapshot = options?.localSnapshot;
        let _data = {
            Marker: 0,
            MaxResults: 9999, // 超过1000，查不到了
            LocalVolumeCategory: '',
        };

        let volumeMultiTypes: string[] = [];
        // if (this.isSuppportESSD) {
        //     volumeMultiTypes = ["ESSD_PL0", 'ESSD_PL1', 'ESSD_PL2', 'ESSD_PL3'];
        // }
        // else {
        //     volumeMultiTypes = ['SSD3.0', 'EHDD']
        // }

        // let _snapCreateLocalDisk = kecAPIs.DescribeLocalVolumeSnapshots({
            // params: {
                // Region: this.regionKey,
            // },
            // data: _data
        // });
        const localDiskRequests = localSnapshot?.map(item => {
            return kecAPIs.DescribeLocalVolumeSnapshots({
                params: {
                    Region: this.regionKey,
                },
                data: {
                    Marker: 0,
                    MaxResults: 10,
                    localVolumeSnapshotId: item.SnapshotId,
                }
            });
        }) || [];

        let _snapCreateEbsDisk = kecAPIs.DescribeSnapshots({
            params: {
                Region: this.regionKey,
            },
            data: {
                VolumeMultiTypes: volumeMultiTypes,
                // AvailabilityZone: this.azCode, //整机镜像是不区分可用区的
                VolumeCategory: '', //获取系统盘和数据盘快照
                SnapshotName: '',
                PageNumber: 1,
                PageSize: 9999 
            }
        })

        // 保存一个标识，如果这个变了，则舍弃下面接口返回的处理逻辑
        this.__dataDisks = dataDisks;
        const imageType = this.imageType;

        Promise.all([...localDiskRequests, _snapCreateEbsDisk]).then((datas) => {
            if (this.__dataDisks !== dataDisks || this.imageType !== imageType) return;

            const __data = datas.pop();
            this.snapList = [];
            this.snapTotal = 0;
            datas.forEach(data => {
                if (data) {
                    this.snapList.push(...data.LocalVolumeSnapshotSet);
                    this.snapTotal++;
                }
            });
            snapFilterList = _.cloneDeep(this.snapList);

            if (__data && __data.Snapshots.length) {
                snapshots = __data.Snapshots;
            }
            snapFilterList = snapFilterList.concat(snapshots);

            //过滤掉不合规的镜像
            // snapFilterList = _.filter(snapFilterList, (item) => {
                // return !item.disable
            // });

            //获取共享镜像里面整机镜像数据, 用于判断快照是否有效，因为共享镜像里面的快照在快照列表里面是查不到的。
            if (this.shareImgList && this.shareImgList.length) {
                _.forEach(this.shareImgList, (item) => {
                    if (item.SnapshotSet && item.SnapshotSet.length) {
                        snapFilterList = snapFilterList.concat(item.SnapshotSet);
                    }
                });
            }

            this.ebsDiskSizeList = [];
            this.delWithInsList = [];
            this.hadEbsDisk = 0;
            this.ebsDiskObjs = [];
            this.ebsSnapList = [];

            if (this.snapInfo.snapId) {
                // 查询本地盘快照名称
                let tempDataSnapshotName = _.find(snapFilterList, (subitem) => {
                    return subitem.LocalVolumeSnapshotId == this.snapInfo.snapId;
                }) || {};

                this.diskObj.minValue = _.get(this.snapInfo, 'snapCpacity', 0);
                this.snapInfo.snapName = (tempDataSnapshotName && tempDataSnapshotName.LocalVolumeSnapshotName) || '共享快照默认名称';
            }

            _.forEach(dataDisks, (item) => {
                // console.log(item, 1111)
                if (isFromWhere && isFromWhere === 'isAllImage') {
                    //整机镜像数据盘做一个标示，方便后期操作
                    item.isWholeMirror = true
                }
                // var idxx = _.findIndex(this.ebsSupport, ['value', 'SSD3.0']); // 默认SSD3.0
                // 如果当前选中的是整机镜像，应该过滤掉essd
                // 部分机型支持多种盘，其他地方不好过滤，所以放在这个地方统一处理
                var idxx = _.findIndex(this.ebsSupport, (subitem) => {
                    let baseList = ["SSD3.0", 'EHDD', "ESSD", "ESSD_PL0", 'ESSD_PL1', 'ESSD_PL2', 'ESSD_PL3']
                    if (this.imageObj?.Type === "LocalImage") {
                        baseList = ["SSD3.0", 'EHDD']
                    }
                    return _.includes(baseList, subitem.value);
                });


                if (idxx != -1) {
                    let tempData = _.find(snapFilterList, (subitem) => {
                        return subitem.LocalVolumeSnapshotId == item.SnapshotId || subitem.SnapshotId == item.SnapshotId;
                    }) || {};

                    if (((this.sourcePage == 'modifyTemplate' || this.sourcePage == 'buyTemplate') && _.get(this.startTempData, 'ImageId', '') == this.imageId)
                        || (this.sourcePage == 'createTheSameConfig') && _.get(this.theSameConfigData, 'ImageId', '') == this.imageId
                    ) {
                        // var idx = _.findIndex(this.ebsSupport, ['value', item.Type]);
                        var idx = -1;
                        const diskType = this.sourcePage == 'createTheSameConfig' ? item.DiskType : item.Type
                        const diskSize = this.sourcePage == 'createTheSameConfig' ? item.DiskSize : item.Size
                        // if (this.kecType == 628 || this.kecType == 687) { //极速云盘型X6E 和 性能保障型X7
                        if (diskType.includes('ESSD')) {
                            const notSoldOutLevel = this.updateEbsDiskObjByPerformanceLevel(diskType);
                            if (notSoldOutLevel) {
                                this._addEbsDisk('undefined', diskSize, item.DeleteWithInstance, item, notSoldOutLevel);
                            }
                        } else {
                            idx = _.findIndex(this.ebsDiskTypes, ['value', diskType]);
                            if (idx != -1) {
                                this.ebsDiskObj = this.ebsDiskTypes[idx];
                                this._addEbsDisk('undefined', diskSize, item.DeleteWithInstance, item);
                            }
                        }
                    } else {
                        if (item.Type == 'data') {
                            item.VolumeType = tempData.VolumeType;
                            item.name = tempData.LocalVolumeSnapshotName || tempData.SnapshotName || '共享快照默认名称'; //如果是共享的快照， 那么是找不到对应快照名称的
                            this.ebsDiskObj = this.ebsSupport[idxx];
                            if(this.performanceModel === 'enhance'){
                                //增强型机型只有ESSD_PL3,所以不支持本地盘快照制作的整机镜像
                                //ESSD和SSD3.0和EHDD支持快照混挂，如果是其SSD3.0 或者 EHDD类型的快照制作的景象，默认展示为ESSD云硬盘
                                item.VolumeType = 'ESSD'
                            }
                            this._addEbsDisk('undefined', item.DiskSize, true, item);
                        }
                    }

                }
            });

        })
    }

    updateEbsDiskObjByPerformanceLevel(type: string) {
        if (type?.includes('ESSD')) {
            var pLevel = type.split('_')[1] || '';
            const notSoldOutLevel = _.find(this.supportPerformanceLevelsList, ['value', pLevel]);

            if (notSoldOutLevel) {
                this.ebsDiskObj = {
                    value: 'ESSD',
                    performanceLevel: notSoldOutLevel.value,
                    productType: notSoldOutLevel.typeId,
                    title: this.ebsNameMap['ESSD'],
                    minValue: notSoldOutLevel.minValue,
                    maxValue: notSoldOutLevel.maxValue,
                    stepValue: notSoldOutLevel.stepValue,
                    isNotSupportEBS: false
                }
            }

            return notSoldOutLevel;
        }
    }

    // 当系统盘是ESSD类型时，获取系统盘的区间值
    _getESSDSyeMinAndMax(){
        const sysPerformace = _.find(this.systemPerformances,item => item.value === this.sysPerformanceLevel) || {}
        // this.systemDiskSize = sysPerformace.minValue
        this.systemDiskMin = this.imageSysDisk > sysPerformace.minValue ? this.imageSysDisk : sysPerformace.minValue
        this.systemDiskMax = sysPerformace.maxValue
        this.systemDiskStep = sysPerformace.stepValue
        if(this.systemDiskSize < sysPerformace.minValue){
            this.systemDiskSize = sysPerformace.minValue
        }
        if(this.systemDiskSize > sysPerformace.maxValue){
            this.systemDiskSize = sysPerformace.maxValue
        }
    }
    _setSyeDiskMax() {
        // 机型维度 查询可调系统盘大小的最大值
        if (!this.isShowSlider) {
            return;
        }
        const sysType =  _.get(this.sysDiskObj, 'value', '')
        if(sysType === 'ESSD'){
            this._getESSDSyeMinAndMax()
            return;
        }

        let propertyList = _.get(this.checkedRows, '[0].propertyList', []);
        let propCode = _.get(this.systemDiskMap, sysType, 'ssd_systemDisks');
        let systemDiskMax = _.get(_.filter(propertyList, ['propCode', propCode])[0], 'propValue[0].max', 500); //该机型可配置的大小
        if (this.systemDiskMin > systemDiskMax) {
            this.systemDiskMin = systemDiskMax;
        }
        if (systemDiskMax < this.systemDiskSize) {
            this.sourcePage = '';
            this.$nextTick(() => {
                this.imageType = 0;
                this.systemDiskMax = systemDiskMax;
            })
            return;
        } else {
            this.systemDiskMax = systemDiskMax;
        }
    }
    _setDisk() {
        let me = this;
        let kecObj = _.get(this.checkedRows, "[0]", "")
        if (!commonConst.isCommonModelType(this.kecType) || commonConst.is2dataDiskType(this.kecType)) {
            let diskTypes = this.diskTypes;
            let ssdType = _.filter(kecObj.packageInfo, ['propCode', 'ssd']),
                sataType = _.filter(kecObj.packageInfo, ['propCode', 'sata']);
            if (ssdType.length > 0) {
                diskTypes = [{
                    value: 'ssd',
                    title: this.$trans(`本地SSD`), //本地SSD盘
                    minValue: _.get(ssdType[0], 'propValue[0].min' || 0),
                    maxValue: _.get(ssdType[0], 'propValue[0].max' || 0),
                    stepValue: _.get(ssdType[0], 'propValue[0].step' || 0)
                }]
            }
            if (sataType.length > 0) {
                diskTypes = [{
                    value: 'sata',
                    title: this.$trans(`本地SATA`), //本地SATA盘
                    minValue: _.get(sataType[0], 'propValue[0].min' || 0),
                    maxValue: _.get(sataType[0], 'propValue[0].max' || 0),
                    stepValue: _.get(sataType[0], 'propValue[0].step' || 0)
                }]
            }
            this.diskTypes = diskTypes;
            this.diskObj = diskTypes[0] || [];

            if (this.sourcePage == 'modifyTemplate' || this.sourcePage == 'buyTemplate') {
                this.diskSize = _.get(this.startTempData, 'DataDiskGb');
                let LocalVolumeSnapshotId = _.get(this.startTempData, 'LocalVolumeSnapshotId');
                if (LocalVolumeSnapshotId) {
                    this.snapInfo = {
                        snapChoose: true,
                        showDelete: true,
                        snapId: LocalVolumeSnapshotId,
                        snapName: _.get(this.startTempData, 'LocalVolumeSnapshotName') || LocalVolumeSnapshotId,
                        snapCpacity: _.get(this.startTempData, 'DataDiskGb')
                    }
                }

                // console.log(this.diskSize, 'diskSize1111');
            } else if (this.sourcePage == 'createTheSameConfig') {
                this.diskSize = _.get(this.theSameConfigData, 'InstanceConfigure.DataDiskGb', 0);
            } else {
                this.diskSize = isNaN(this.diskSize) ? 0 : this.diskSize;
                this.diskSize = Math.min(_.get(this.diskObj, 'maxValue'), Math.max(_.get(this.diskObj, 'minValue'), this.diskSize));
            }

        }
        if (commonConst.isCommonModelType(this.kecType) || commonConst.is2dataDiskType(this.kecType)) {
            let propertyList = _.get(kecObj, 'propertyList', []);
            this.maxEbsNum = _.get(_.find(propertyList, ['propCode', 'ebs-no']), 'propValue[0].max', 0);
            let ebsPack = _.find(propertyList, ['propCode', 'ebs-package']);
            let ebsValue = _.get(ebsPack, 'propValue', []);
            let ebsSupport: any[] = [];

            // 从ebs-type 获取到价格体系配置的机型，然后到 ebs-package 中查找配置机型是否有权限，有相同则显示
            let ebsType = _.find(propertyList, ['propCode', 'ebs-type']);
            let ebsTypeIds = _.map(_.get(ebsType, 'propValue', []), 'value'); // 这里的value 就是productTypeId
            let ebsTypeIdsArr = _.cloneDeep(ebsTypeIds); //需要适配ESSD数据盘，这个盘有性能级别的概念
            let performanceLevels: any[] = [];
            console.log('ebsValue:::', ebsValue)
            _.each(ebsValue, (item: any) => {
                // 竞价实例810计费方式的ebs计费方式读取按小时配置实时付费87
                const billType = me.orderBill == 810 ? 87 : me.orderBill
                let ebsPack = _.filter(item.regionList, ['regionCode', me.regionKeyCheck]).length > 0 && _.filter(item.billTypeList, ['billTypeId', billType]).length > 0
                let productTypeCode = item.productTypeCode.split('_');
                let pTypeCode = productTypeCode[0];
                // if (!ebsPack && (pTypeCode === 'EHDD' || pTypeCode === 'SSD3.0' || pTypeCode === 'ESSD')) {
                //     // 兼容孟繁鸿 控制台云盘售罄提示优化 需求
                //     ebsPack = true
                //     item.isNotSupportEBS = true
                // }

                if (ebsPack || me.orderBill == 2017) {
                    //ebs-package的propValue判断到az
                    if (item.packageList && item.packageList.length > 0) {
                        let regionPackageList = _.filter(item.packageList, packageItem => {
                            let regionItem = _.find(packageItem.refRegionList, ['regionCode', me.regionKeyCheck]);
                            if (!regionItem && (pTypeCode !== 'EHDD' && pTypeCode !== 'SSD3.0' && pTypeCode !== 'ESSD')) {
                                return false;
                            }
                            if (me.azCode === 'all') {
                                return packageItem;
                            } else {
                                let az = regionItem && _.find(regionItem.azList, ['azCode', me.azCode]);
                                if (!az && (pTypeCode === 'EHDD' || pTypeCode === 'SSD3.0' || pTypeCode === 'ESSD')) {
                                    packageItem.isNotSupportEBS = true
                                    return true
                                }
                                packageItem.isNotSupportEBS = false
                                return az
                            }

                        })
                        if (_.every(regionPackageList, regionItem => regionItem.isNotSupportEBS)) {
                            item.isNotSupportEBS = true
                        } else {
                            item.isNotSupportEBS = false
                        }
                        if (!regionPackageList || !regionPackageList.length) {
                            return
                        }
                        // IO优化型I3机型 只支持SSD、SSD3.0、高效云盘EHDD
                        if (me.kecType * 1 === 110 && pTypeCode != 'SSD' && pTypeCode != 'SSD3.0' && pTypeCode != 'EHDD') {
                            return;
                        }

                        // 通用型N2 或 N3 或 标准型S3的机型 只支持SSD3.0、SATA3.0、高效云盘EHDD
                        if ((me.kecType * 1 === 137 || me.kecType * 1 === 151 || me.kecType * 1 === 152) && pTypeCode != 'SSD3.0' && pTypeCode != 'SATA3.0' && pTypeCode != 'EHDD') {
                            return;
                        }
                        //N1，I2机型创建时只支持 EBS3.0
                        // if ((me.kecType * 1 === 40 || me.kecType * 1 === 78) && pTypeCode != 'SSD3.0' && pTypeCode != 'SATA') {
                        //     return;
                        // }
                        // 20201218：去掉I2的EHHD限制（雄伟确认）
                        // 20200301: N1 取消限制
                        // if ((me.kecType * 1 === 40) && pTypeCode != 'SSD3.0' && pTypeCode != 'SATA') {
                        //     return;
                        // }

                        // 如果ebs-type 里面的包含有这个productTypeId那么就认为这个用户配置的这个机型的有权限，可以用来创建数据盘
                        if (_.indexOf(ebsTypeIdsArr, item.productTypeId.toString()) > -1) {
                            // if (_.indexOf(ebsTypeIds, item.productTypeId.toString()) > -1) {
                            // --------- 2019-10-24 ----------
                            // ebs多个套餐，取最大范围
                            // 运营双11活动需求
                            // 如果统一region有多个套餐，需要保证套餐范围连续性
                            let min: number | null = null;
                            let max: number | null = null;
                            let step: number | null = null;
                            // _.forEach(item.packageList, packageItem => {
                            _.forEach(regionPackageList, packageItem => {
                                let packageStep = _.get(packageItem, 'packageInfo[0].propValue[0].step');
                                let packageMin = _.get(packageItem, 'packageInfo[0].propValue[0].min');
                                let packageMax = _.get(packageItem, 'packageInfo[0].propValue[0].max');
                                if (min === null || min > packageMin) {
                                    min = packageMin;
                                }
                                if (max === null || max < packageMax) {
                                    max = packageMax;
                                }
                                if ((step == null || step > packageStep) && packageStep !== 0) {
                                    step = packageStep;
                                }
                            });
                            if (!step) {
                                step = 1;
                            }

                            // 极速云盘型X6E 只支持ESSD云硬盘
                            let pTypeLevel = '';
                            if (pTypeCode === 'ESSD') {
                                pTypeLevel = pTypeCode === 'ESSD' ? productTypeCode[1] : '';
                                //ESSD盘的类型code通常是ESSD_PL1、ESSD_PL2、ESSD_PL3....
                                // let essdIopsLimit = _.find(item.propertyList, ['propCode', 'ESSD-IOPS-LIMIT']);
                                // let iopsMax = _.get(essdIopsLimit, 'propValue[0].max', 0);
                                if (_.indexOf(ebsTypeIds, item.productTypeId.toString()) > -1) {

                                    const iopsSec = this._getIops(item.productTypeCode)
                                    const bytesSec = this._getByte(item.productTypeCode)

                                    let chooseDisabled = false
                                    let tips = ''
                                    if (this.performanceModel === 'enhance' && (pTypeLevel === 'PL0' || pTypeLevel === 'PL1' || pTypeLevel === 'PL2')) {
                                        chooseDisabled = true
                                        tips = this.$trans('若需挂载PL0、PL1、PL2级别ESSD，请选择性能模式为“标准型”')
                                    } else if (this.performanceModel === 'standard' && pTypeLevel === 'PL3') {
                                        chooseDisabled = true
                                        tips = this.$trans('若需挂载PL3级别ESSD，请选择性能模式为“增强型”')
                                    }
                                    performanceLevels.push({
                                        title: this.$trans(`{0}（单盘性能上限IOPS：{1}万 吞吐量：{2}MB/s）`, pTypeLevel, iopsSec.Max / 10000, bytesSec.Max),
                                        value: pTypeLevel,
                                        typeId: item.productTypeId.toString(),
                                        minValue: min,
                                        maxValue: max,
                                        stepValue: step,
                                        isSoldOut: false,
                                        chooseDisabled,
                                        tips
                                    });
                                }
                            } else {
                                ebsSupport.push({
                                    value: pTypeCode,
                                    performanceLevel: '',
                                    productType: item.productTypeId,
                                    title: me.ebsNameMap[pTypeCode],
                                    minValue: min, //_.get(item.packageList[0], 'packageInfo[0].propValue[0].min', 0),
                                    maxValue: max, //_.get(item.packageList[0], 'packageInfo[0].propValue[0].max', 0),
                                    stepValue: step, //_.get(item.packageList[0], 'packageInfo[0].propValue[0].step' || 0)
                                    // stepValue: 2//_.get(item.packageList[0], 'packageInfo[0].propValue[0].step' || 0)
                                    isNotSupportEBS: item.isNotSupportEBS
                                });
                            }

                        }
                    }
                }
            });


            // if (this.kecType == 628 || this.kecType == 687) { //极速云盘型X6E 
            if (this.isSupportESSD) {
                if (performanceLevels.length) {
                    //按照从大到小排序
                    performanceLevels = _.sortBy(performanceLevels, (item) => {
                        let levelValue = _.last(item.value.split(''));
                        return -Number(levelValue); //倒序排列
                    });
                    //表示ebs-package已经配置了ESSD，后面再赋值
                    // ebsSupport.push({
                    // value: 'ESSD_' + performanceLevels[0].value
                    // });
                }
            }
            //产品需求：SSD3.0排在最前面
            ebsSupport = _.sortBy(ebsSupport, (item) => {
                let ssdValue = _.last(item.value.split('.')[0].split(''));
                return -Number(ssdValue); //倒序排列
            });

            //产品需求：检查EBS列表是否有售罄，如果有售罄项目则过滤掉，如果全部售罄则置灰“增加一块”按钮
            let soldoutNum = 0;
            let soldoutIndex: any[] = [];

            let isAllSoldOutPerformance = false;
            // if (this.kecType == 628 || this.kecType == 687) { //极速云盘型X6E
            if (this.isSupportESSD) {
                _.forEach(performanceLevels, (item) => {
                    _.forEach(this.soldoutList, (subItem) => {
                        if(subItem.AvailabilityZone === this.azCode && subItem.VolumeTypeId == item.typeId){
                            if(subItem.SellOutStatus || _.find(subItem.VmSellOuts, vmItem => vmItem.VmTypeId == this.kecType)){
                                item.isSoldOut = true
                            }
                        }
                    });
                });
                this.notSoldOutPerformanceLevels = _.filter(performanceLevels, (item) => {
                    return !item.isSoldOut;
                }) || [];

                this.supportPerformanceLevelsList = _.filter(this.notSoldOutPerformanceLevels, (item) => {
                    return !item.chooseDisabled;
                }) || [];
                isAllSoldOutPerformance = this.notSoldOutPerformanceLevels.length ? false : true;
                if (this.notSoldOutPerformanceLevels.length) {
                    if (this.supportPerformanceLevelsList.length) {
                        let notSoldOutLevel = _.find(this.supportPerformanceLevelsList,item => item.value === 'PL1')
                        if(_.isEmpty(notSoldOutLevel)){
                            notSoldOutLevel = this.supportPerformanceLevelsList[0]
                        }
                        ebsSupport.unshift({
                            value: 'ESSD',
                            performanceLevel: notSoldOutLevel.value,
                            productType: notSoldOutLevel.typeId,
                            title: this.ebsNameMap['ESSD'],
                            minValue: notSoldOutLevel.minValue,
                            maxValue: notSoldOutLevel.maxValue,
                            stepValue: notSoldOutLevel.stepValue,
                            isNotSupportEBS: false
                        });
                    } else {
                        this.performanceModel = this.performanceModel === 'standard' ? 'enhance' : 'standard';
                    }
                }
            }
            if (!ebsSupport.length) {
                console.log('未配置ebs-package，请联系客服')
            }
            this.ebsSupportAll = _.clone(ebsSupport); //用于区分是全部售罄了还是没有配置

            _.forEach(this.ebsSupportAll, (item, index) => {
                if (item.isNotSupportEBS) {
                    soldoutNum++;
                    soldoutIndex.push(index);
                    return
                }

                _.forEach(this.soldoutList, (subItem) => {
                    if (subItem.AvailabilityZone == this.azCode && subItem.VolumeTypeId == item.productType) {
                        if(subItem.SellOutStatus || _.find(subItem.VmSellOuts, vmItem => vmItem.VmTypeId == this.kecType)){
                            soldoutNum++;
                            soldoutIndex.push(index);
                            if (item.value === 'EHDD' || item.value === 'SSD3.0' || isAllSoldOutPerformance) {
                                item.isSoldOut = true
                            }
                        }
                        
                    }
                });
            });

            _.pullAt(ebsSupport, soldoutIndex);
            // if (this.kecType == 628 || this.kecType == 687) { //极速云盘型X6E
            let isSoldOutEBS = (soldoutNum == this.ebsSupportAll.length) ? true : false;
            if (this.isSupportESSD) {
                isSoldOutEBS = isSoldOutEBS && isAllSoldOutPerformance ? true : false;
            }
            this.isSoldOutEBS = isSoldOutEBS

            this.performanceLevels = performanceLevels;
            this.ebsDiskSizeList = [];
            this.delWithInsList = [];
            this.hadEbsDisk = 0;
            this.ebsSupport = ebsSupport;
            this.ebsDiskTypes = this.ebsSupportAll;
            this.ebsDiskObjs = [];
            this.ebsDiskObj = _.find(this.ebsSupport, item => !item.isSoldOut);
            this.ebsSnapList = []
            // 可添加的云盘数据盘数量
            this.canAddEbsNum = this.isSoldOutEBS ? 0 : this.maxEbsNum

            if (this.sourcePage == 'modifyTemplate' || this.sourcePage == 'buyTemplate') {
                this.performanceModel = _.get(this.startTempData, 'DataDiskPerformanceMode', '');
                let dataDiskSet = _.get(this.startTempData, 'DataDiskSet', {});
                if (dataDiskSet.length) {
                    this.snapCreateDiskList(dataDiskSet);
                }
            }
            if (this.sourcePage == 'createTheSameConfig') {
                this.performanceModel = _.get(this.theSameConfigData, 'DataDiskPerformanceMode', '');
                let dataDisks = _.get(this.theSameConfigData, 'DataDisks', {});
                if (dataDisks.length) {
                    this.snapCreateDiskList(dataDisks);
                }
            }
        }
        this.calcuPrice();
    }

    _reduceEbsDisk(index: number) {
        var hadEbsNum = this.hadEbsDisk;
        var diskSize = this.ebsDiskSizeList;
        diskSize.splice(index, 1);
        this.delWithInsList.splice(index, 1);
        this.ebsDiskObjs.splice(index, 1);
        this.ebsSnapList.splice(index, 1);
        this.$set(this, 'hadEbsDisk', --hadEbsNum);
        this.calcuPrice();
    }
    _getIops(type: string){
        var plItem = _.get(this.describeEbsPerfQuotasObj, type, []);
        var iopsSec = {
            Min: 0,
            Max: 0,
            Step: 0
        };
        
        if (plItem.length) {
            iopsSec = _.find(plItem, (item:any) => {
                return item.QuotaTypeName == "ReadIopsSec";
            });
            if (_.isEmpty(iopsSec)) {
                iopsSec = _.find(plItem, (item:any) => {
                    return item.QuotaTypeName == "TotalIopsSec";
                });
            }
            
        }
        return iopsSec
    }
    _getByte(type: string){
        var plItem = _.get(this.describeEbsPerfQuotasObj, type, []);
        var bytesSec = {
            Min: 0,
            Max: 0,
            Step: 0
        };
        if (plItem.length) {
            bytesSec = _.find(plItem, (item:any) => {
                return item.QuotaTypeName == "ReadBytesSec";
            });
            if(_.isEmpty(bytesSec)){
                bytesSec = _.find(plItem, (item:any) => {
                    return item.QuotaTypeName == "TotalBytesSec";
                });
            }
        }
        return bytesSec;
    }
    showIOPS(size: any, performanceLevel: any) {
        //IOPS计算 Math.min(min + (size * step), max)
        if (size && this.describeEbsPerfQuotasObj && performanceLevel) {
            if(!performanceLevel.includes('ESSD_SYSTEM')){
                performanceLevel = 'ESSD_' + performanceLevel
            }
            const iopsSec = this._getIops(performanceLevel)
            return _.min([iopsSec.Min + iopsSec.Step * size, iopsSec.Max]);
        }
    }

    ebsDataDiskSelectDisabled(key: any) {
        return _.every(this.ebsDiskTypes, (item, idx) => {
            return this.ebsDataDiskOptionDisabled(item, key)
        })
    }

    ebsDataDiskOptionDisabled(optionItem: any, key: any) {
        let imageObj = this.imageObj;
        let kecType = this.kecType;
        let ebsSnapList = this.ebsSnapList;
        return (((imageObj ? imageObj.Type == "LocalImage" : true) || kecType == 498) && ebsSnapList[key].snapChoose) || optionItem.isNotSupportEBS || optionItem.isSoldOut || !!this.isDisableDataDiskType(optionItem.value, key);
    }

    showThroughput(size: any, performanceLevel: any) {
        //吞吐限速 Math.min(min + (size * step), max)
        if (size && this.describeEbsPerfQuotasObj && performanceLevel) {
            if(!performanceLevel.includes('ESSD_SYSTEM')){
                performanceLevel = 'ESSD_' + performanceLevel
            }

            const bytesSec = this._getByte(performanceLevel)
            return _.min([bytesSec.Min + bytesSec.Step * size, bytesSec.Max]);
        }
    }

    _addEbsDisk(MouseEvent: any, modelDiskSize: any, modelDeleteWithInstance: any, data?: any, notSoldOutLevel?: any) {
        if (this.isSoldOutEBS || this.isX6EWithEnhanceInAllAZ()) {
            return
        }

        var max = this.maxEbsNum;
        var hadEbsNum = this.hadEbsDisk;
        // var diskSize = this.ebsDiskSizeList;
        const ebsList = _.filter(this.ebsSupport, item => !item.isSoldOut)
        if (data) {
            if (!data.VolumeType) {
                if(data.Type?.includes('ESSD')){
                    data.VolumeType = data.Type
                } else {
                    const diskType = _.find(ebsList, item => item.value === data.DiskType)?.value
                    data.VolumeType = diskType || _.find(ebsList, item => item.value === 'SSD3.0')?.value
                }
                
            } else {
                const VolumeType = _.find(ebsList, item => data.VolumeType.includes(item.value))
                if(_.isEmpty(VolumeType)){
                    data.Type = data.SnapshotId ? 'data' : ebsList[0].value
                    data.VolumeType = ebsList[0].value
                }
            };
            if (!notSoldOutLevel) {
                if (!this.updateEbsDiskObjByPerformanceLevel(data.VolumeType)) {
                    this.ebsDiskObj = _.find(ebsList, item => {
                        return item.value === (data.VolumeType?.includes('ESSD') ? 'ESSD' : data.VolumeType);
                    }) || {};
                }
            }
        } else {
            this.ebsDiskObj = _.find(this.ebsSupport, item => !item.isSoldOut)
        }
        var ebsDiskObj = _.cloneDeep(this.ebsDiskObj);
        if (hadEbsNum < max) {
            // modelDiskSize ? this.delWithInsList.push(modelDeleteWithInstance) : this.delWithInsList.push(false);
            // modelDiskSize ? diskSize.push(modelDiskSize) : diskSize.push(10); //修改数据盘默认为10G
            if (modelDiskSize) {
                this.delWithInsList.push(modelDeleteWithInstance);
                this.ebsDiskSizeList.push(modelDiskSize);
                if (modelDiskSize > ebsDiskObj.minValue) {
                    ebsDiskObj.minValue = modelDiskSize;
                }
            } else {
                this.delWithInsList.push(false);
                // if (this.kecType == 628 || this.kecType == 687) { //极速云盘型X6E
                if (this.isSupportESSD) {
                    this.ebsDiskSizeList.push(ebsDiskObj.minValue); //X6E的盘最小值不同
                } else {
                    this.ebsDiskSizeList.push(10); //修改数据盘默认为10G
                }
            }


            // xxx: 如果notSoldOutLevel没传，前两部分逻辑没有从supportPerformanceLevelsList里取值
            // 而是没有值就传空。  先将这部分统一为没有notSoldOutLevel就从supportPerformanceLevelsList取值
            let performanceLevel = _.get(notSoldOutLevel, 'value', '');
            if (notSoldOutLevel === undefined) {
                if (ebsDiskObj) {
                    let item = _.find(this.supportPerformanceLevelsList, item => item.value === ebsDiskObj.performanceLevel && !item.chooseDisabled && !item.isSoldOut)
                    if(_.isEmpty(item)){
                        item = _.find(this.supportPerformanceLevelsList, item => !item.chooseDisabled && !item.isSoldOut)
                    }
                    performanceLevel = _.get(item, 'value', '')
                } else {
                    let item = _.find(this.supportPerformanceLevelsList, item => !item.chooseDisabled && !item.isSoldOut)
                    performanceLevel = _.get(item, 'value', '')
                }
            }

            if (data && data.DiskSize) {
                let ebsSnapItem: any = {
                    snapChoose: data.SnapshotId ? true : false,
                    snapName: data.name,
                    snapCpacity: data.DiskSize,
                    snapId: data.SnapshotId,
                    type: ebsDiskObj.value,
                    dataDiskType: ebsDiskObj.value,
                    // performanceLevel: _.get(notSoldOutLevel, 'value', ''),
                    performanceLevel,
                    isWholeMirror: data.isWholeMirror//整机镜像数据盘标示
                }
                // X6E 因为ESSD的特殊性，如果是多个数据盘且性能级别不同，直接获取this.ebsDiskTypes只能得到最后一条数据，所以每个数据盘中单独存储选中的ESSD类型
                // if(this.kecType == 628){
                //     ebsSnapItem.ebsDiskTypes = [ebsDiskObj]
                // }
                if (data.DiskSize > ebsDiskObj.minValue) {
                    ebsDiskObj.minValue = data.DiskSize;
                }
                this.ebsSnapList.push(ebsSnapItem)
            } else if (data && data.Size && (data.SnapshotId || data.VolumeImageId)) {
                const type = (data?.Type?.includes('ESSD') ? 'ESSD' : ebsDiskObj.value) || ''
                this.ebsSnapList.push({
                    snapChoose: data.SnapshotId || data.VolumeImageId ? true : false,
                    snapName: data.SnapshotName || data.VolumeImageName,
                    snapCpacity: data.Size,
                    snapId: data.SnapshotId || data.VolumeImageId,
                    type: data ? (data.Type || ebsDiskObj.value) : ebsDiskObj.value,
                    dataDiskType: data ? (type || ebsDiskObj.value) : ebsDiskObj.value,
                    // performanceLevel: _.get(notSoldOutLevel, 'value', ''),
                    performanceLevel,
                    isWholeMirror: data.isWholeMirror//整机镜像数据盘标示
                })
                ebsDiskObj.minValue = data.Size;
            } else {
                const type = (data?.Type?.includes('ESSD') ? 'ESSD' : ebsDiskObj.value) || ''
                let ebsSnapItem: any = {
                    snapChoose: false,
                    snapName: '',
                    snapCpacity: '',
                    snapId: '',
                    type: '',
                    dataDiskType: data ? (type || ebsDiskObj.value) : ebsDiskObj.value,
                    // performanceLevel: notSoldOutLevel ? _.get(notSoldOutLevel, 'value', '') : _.get(this.supportPerformanceLevelsList, '[0].value', ''),
                    performanceLevel,
                    isWholeMirror: data && data.isWholeMirror//整机镜像数据盘标示
                }
                // X6E 因为ESSD的特殊性，如果是多个数据盘且性能级别不同，直接获取this.ebsDiskTypes只能得到最后一条数据，所以每个数据盘中单独存储选中的ESSD类型
                // if(this.kecType == 628){
                //     ebsSnapItem.ebsDiskTypes = [ebsDiskObj]
                // }
                this.ebsSnapList.push(ebsSnapItem)
            }

            this.ebsDiskObjs.push(ebsDiskObj);

            // 设置整机镜像后，data盘的值没有自动更新，这里强制更新一下
            this.ebsDiskSizeList[this.ebsDiskObjs.length - 1] = _.get(ebsDiskObj, 'minValue')
            this.$set(this, 'hadEbsDisk', ++hadEbsNum);
            this.calcuPrice();
        }
    }

    _fixNum() {
        this.diskSize = +this.diskSize;
        var l = this.hadEbsDisk;
        var ebsDiskSizeList = _.cloneDeep(this.ebsDiskSizeList)
        if (l > 0) {
            for (var i = 0; i < l; i++) {
                var item = _.toNumber(ebsDiskSizeList[i]);
                ebsDiskSizeList[i] = item ? item : ebsDiskSizeList[i];
            }
            this.ebsDiskSizeList = _.cloneDeep(ebsDiskSizeList);
        }
        this.calcuPrice();
    }

    //改变disk end
    //购买时长

    @debounce(100)
    _hasSpecialDiscount() {
        if (!this.kecType) {
            return;
        }
        //用户专属折扣
        kecAPIs.QueryUserSpecialDiscounts({
            params: {
                Region: this.regionKeyCheck,
                ProductTypes: this.kecType.toString()
            }
        }).then((res: any) => {

            let disCountList: any[] = [];
            let tempMenu = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 24, 36]; //对应1，2，3，4，5，6，7，8，9，10，11月，1年，2年，3年
            let discount = 0;
            if (!_.isEmpty(res.data)) {
                let ruleList = _.get(res, 'data[0].discountDetail', []);
                _.forEach(tempMenu, (item) => {
                    _.forEach(ruleList, (subItem) => {
                        if (item == subItem.orderFullMonth) {
                            discount = subItem.orderDiscount * 10;
                        }
                    });
                    // 产品规则: 当没有配置当前月份折扣信息时，获取上一个月份的折扣信息，所以此处利用discount变量的缓存机制
                    disCountList.push(discount);
                });
            }
            if (disCountList.length) {
                let _disCountList = [];
                if (this.pageLanguage === 'zh') {
                    _disCountList = disCountList;
                } else {
                    // 如果是英文版 则需要把折扣转换为英文的表述
                    _.forEach(disCountList, (item) => {
                        _disCountList.push(100 - item * 10);
                    });
                }

                this.specialDiscountList = _disCountList;
                this.hasSpecialDiscount = true;
            } else {
                this.specialDiscountList = [];
                this.hasSpecialDiscount = false;
            }
        })
    }

    //购买时长end
    //计算价格
    _diskParam() {
        let me = this;
        let kvm: any = {}
        let disk = this.ebsDiskObj
        let ebsNumSize = this.ebsDiskSizeList
        let bindCloudServerDel = this.bindCloudServerDel;
        if (commonConst.isCommonModelType(this.kecType) || commonConst.is2dataDiskType(this.kecType)) {
            kvm.ebsList = [];
            // if (this.hadEbsDisk > 0) {
            if (this.hadEbsDisk > 0) {
                ebsNumSize.map(function (diskValue, idx) {
                    let ind = _.indexOf(bindCloudServerDel, 'bindCloudServerDel' + idx);
                    let isBindCloudServer = false;
                    if (ind >= 0) {
                        isBindCloudServer = true;
                    }
                    let ret = [
                        // {key: '云服务器名称', value: self.get('serverName')},
                        {
                            key: me.$trans(`数据中心`), //'数据中心',
                            // value: me.pcommon.regionMap(me.regionKeyCheck)
                            value: regionService.getRegionLocaleTitleByCode(me.regionKeyCheck)
                        },
                        {
                            key: me.$trans(`类型`), //'类型',
                            value: (me.ebsDiskObjs[idx] || {}).title
                        }
                    ];
                    if (diskValue > 0) {
                        let volumeType = null
                        try {
                            let types: any = {
                                3: 'SSD2.0',
                                4: 'SATA2.0',
                                132: 'SSD3.0',
                                133: 'SATA3.0',
                                197: 'EHDD',
                                501: 'ESSD_PL3',
                                564: 'ESSD_PL2',
                                565: 'ESSD_PL1',
                                566: 'ESSD_PL0'
                            };
                            // basic机房无法区分SSD2.0或SSD3.0，所以此处做转换，并兼容之后新增类型云硬盘， 比如：高效云盘（197: 'EHDD'）
                            volumeType = types[me.ebsDiskObjs[idx].productType] || me.ebsDiskObjs[idx].value;
                        } catch (e) {
                        }


                        let diskData: any = {
                            "billType": me.orderBill == 2017 ? 5 : me.orderBill == 810 ? 87 : me.orderBill,
                            //(1, "包年包月"), (2, "按小时先结"), (3, "按峰值后结"), (4, "按量先结"), (5, "按天先结")
                            "duration": me.orderBill == 2017 ? me.tryOrderDay : me.duration, //*时长
                            "durationUnit": me.orderBill == 1 ? '月' : '日', //单位：月
                            "size": +diskValue, //容量大小
                            "productType": me.ebsDiskObjs[idx].productType, // 3 : 高性能，ssd；  4， SATA
                            "display": JSON.stringify(ret),
                            "count": 1,
                            "productWhat": me.orderBill == 2017 ? 2 : 1,
                            "volumeType": volumeType, //N2
                            // "snapshotId": me.ebsSnapList[idx] ? me.ebsSnapList[idx].snapId : '',
                            "volumeId": me.ebsDiskObjs[idx].productType,
                            "isBindCloudServer": isBindCloudServer,
                            "deleteWithInstance": me.delWithInsList[idx] ? true : false,
                        };
                        let snapId = me.ebsSnapList[idx] ? me.ebsSnapList[idx].snapId : '';


                        let SnapshotSet = _.get(me.imageObj, 'SnapshotSet', []);
                        let dataDisks = [];
                        if (SnapshotSet && SnapshotSet.length) {
                            dataDisks = _.filter(SnapshotSet, (item) => {
                                return item.Type == "data";
                            });
                        }
                        if (!commonConst.isCommonModelType(me.kecType)) {
                            let noLocalSnapshot = _.filter(dataDisks, (item) => {
                                return item.DiskType !== "local_snapshot";
                            });
                            dataDisks = noLocalSnapshot;
                        }

                        // if ((me.ebsSnapList[idx] && me.ebsSnapList[idx].SnapshotType == 'local_snapshot') || (dataDisks.length && dataDisks[idx] && dataDisks[idx].DiskType == 'local_snapshot')) { //属于整机镜像的本地数据盘
                        if ((dataDisks.length && dataDisks[idx] && dataDisks[idx].DiskType == 'local_snapshot') || (me.ebsSnapList.length && me.ebsSnapList[idx] && me.ebsSnapList[idx].VolumeCategory === 'data' && me.ebsSnapList[idx].SnapshotType == 'local_snapshot')) { //属于整机镜像的本地数据盘
                            diskData.volumeImageId = snapId;
                            diskData.volumeImageName = me.ebsSnapList[idx] ? me.ebsSnapList[idx].snapName : '';
                        } else {
                            diskData.snapshotId = snapId;
                            diskData.snapshotName = me.ebsSnapList[idx] ? me.ebsSnapList[idx].snapName : '';
                        }
                        kvm.ebsList.push(diskData);
                    }
                })
                // console.log(111111111, 11111, is2dataDiskType(this.kecType), me.diskSize);
                if (commonConst.is2dataDiskType(this.kecType) && me.diskSize) {
                    kvm.ssd = +me.diskSize;
                }
            } else {
                kvm.ssd = +me.diskSize;
            }
            if (this.kecType == 430 || this.kecType == 641) {
                // kvm.hdd = +me.diskSize;
                kvm.hdd = +me.hdd;
                delete kvm.ssd;
            }
        }
        return kvm;
    }

    _setSnapEle(data: any) {
        // console.log(data, "_setSnapEle");
        if (!data.disable) {
            if (data.snaptype == "snapCreateEbsDisk") { //用快照创建云盘
                this.ebsSnapListClone[data.snapEbsIdx] = {};
                this.ebsSnapListClone[data.snapEbsIdx].snapId = data.LocalVolumeSnapshotId || data.SnapshotId;
                this.ebsSnapListClone[data.snapEbsIdx].snapName = data.LocalVolumeSnapshotName || data.SnapshotName;
                this.ebsSnapListClone[data.snapEbsIdx].snapCpacity = data.MinDisk || data.Size || 0;
                this.ebsSnapListClone[data.snapEbsIdx].snapChoose = true;
                // 不根据选中的快照类型重置数据盘类型
                // this.ebsSnapListClone[data.snapEbsIdx].dataDiskType = data.VolumeType || 'SSD3.0';
                this.ebsSnapListClone[data.snapEbsIdx].VolumeCategory = data.SourceLocalVolumeCategory || data.VolumeCategory;
                this.ebsSnapListClone[data.snapEbsIdx].SnapshotType = data.LocalVolumeSnapshotId ? 'local_snapshot' : 'clould_snapshot';

                if (data?.VolumeType?.includes('ESSD')) {
                    if (this.ebsSnapList[data.snapEbsIdx].dataDiskType.includes('ESSD')) {
                        let notSoldOutLevel = this.supportPerformanceLevelsList[this.supportPerformanceLevelsList.length - 1] || {};
                        this.ebsDiskObjs[data.snapEbsIdx].minValue = notSoldOutLevel.minValue;
                        this.ebsSnapListClone[data.snapEbsIdx].performanceLevel = notSoldOutLevel.value;
                    } else {
                        this.ebsSnapListClone[data.snapEbsIdx].performanceLevel = '';
                    }
                }

                // this.ebsSnapList[data.snapEbsIdx] = this.ebsSnapListClone[data.snapEbsIdx];
                // 选中的快照数据覆盖原有的数据盘数据
                Object.assign(this.ebsSnapList[data.snapEbsIdx], this.ebsSnapListClone[data.snapEbsIdx])
                this.ebsDiskSizeList[data.snapEbsIdx] = this.ebsSnapList[data.snapEbsIdx].snapCpacity;
                if (this.ebsDiskObjs[data.snapEbsIdx].minValue < this.ebsSnapList[data.snapEbsIdx].snapCpacity || this.ebsDiskObjs[data.snapEbsIdx].minValue > this.ebsDiskObjs[data.snapEbsIdx].maxValue) {
                    this.ebsDiskObjs[data.snapEbsIdx].minValue = this.ebsSnapList[data.snapEbsIdx].snapCpacity;
                }
                this.ebsDiskSizeList = _.cloneDeep(this.ebsDiskSizeList);

                setTimeout(() => {
                    let ele = $(this.$el).find(`[name="ebsDisk${data.snapEbsIdx}"]`)
                    ele && ele.length && ele.valid();
                }, 200);

                if (this.kecCount > this.limitNum) {
                    this.kecCount = this.limitNum;
                }
                this.calcuPrice();
            }
            if (data.snaptype == "snapCreateLocalDisk") { //用快照创建本地盘
                this.snapInfoClick.snapId = data.LocalVolumeSnapshotId;
                this.snapInfoClick.snapName = data.LocalVolumeSnapshotName;
                this.snapInfoClick.snapCpacity = data.MinDisk || 0;
                this.snapInfoClick.dataDiskType = 'SSD3.0';

                this.canSnapCreateDisk = false;
                this.snapInfo.snapId = this.snapInfoClick.snapId;
                this.snapInfo.snapName = this.snapInfoClick.snapName;
                this.snapInfo.snapCpacity = this.snapInfoClick.snapCpacity;
                this.snapInfo.dataDiskType = this.snapInfoClick.dataDiskType;
                this.snapInfo.snapChoose = true;
                this.snapInfo.showDelete = true;
                this.diskSize = this.snapInfo.snapCpacity;
                if (this.diskObj.minValue < this.diskSize || this.diskObj.minValue > this.diskObj.maxValue) {
                    this.diskObj.minValue = this.diskSize;
                }
                this.snapInfo = _.cloneDeep(this.snapInfo);
                if (this.kecCount > this.limitNum) {
                    this.kecCount = this.limitNum;
                }
            }

        }
    }

    _snapCreateEbs(key?: any) {
        let params = {
            'type': 'snapCreateEbsDisk',
            'key': key,
            'regionKey': this.regionKey,
            'ebsDiskObjs': this.ebsDiskObjs,
            'azCode': this.azCode,
            'kecType': this.kecType,
            // 'dataDiskType':(this.kecType == 628 || this.kecType == 687) ? 'ESSD' : this.ebsSnapList[key].dataDiskType,
            'dataDiskType': this.ebsSnapList[key].dataDiskType,
        };
        (this.$refs.snapCreateDia as any).handle(params);
    }

    _snapCancelEbs(key: any) {
        this.snapEbsPage.current = 1;
        this.snapEbsIdx = key;
        this.delWithInsList[key] = false;
        // 删除选中快照数据不重置数据盘类型，用户选择什么展示什么
        // this.$set(this.ebsSnapList, key, {
        //     snapId: '',
        //     snapName: '',
        //     snapCpacity: '',
        //     type: '',
        //     snapChoose: false,
        //     dataDiskType: 'SSD3.0'
        // });
        const resetObj = {
            SnapshotType: '',
            snapId: '',
            snapName: '',
            snapCpacity: '',
            type: '',
            snapChoose: false
        }
        Object.assign(this.ebsSnapList[key], resetObj)
        // if (this.kecType == 628 || this.kecType == 687) {
        if (this.ebsSnapList[key].dataDiskType.includes('ESSD')) {
            let level = this.ebsSnapList[key].performanceLevel;
            let levelData = _.find(this.performanceLevels, (item) => {
                return item.value == level;
            }) || {};
            this.ebsDiskSizeList[key] = levelData.minValue || 10;
            this.ebsDiskObjs[key].minValue = levelData.minValue || 10;
        } else {
            this.ebsDiskSizeList[key] = 10;
            this.ebsDiskObjs[key].minValue = 10;
        }
        this.calcuPrice();
    }

    async doCalcPrice(params: any) {
        if (!params) {
            return;
        }
        if (!params.regionKey) {
            return;
        }
        if (!params.mock) {
            return;
        }
        if (!_.get(params, 'kvm', '')) return;

        params = _.cloneDeep(params);

        try {
            let check = _.filter(params.kvm, (item) => {
                return item === ''
            })
            // console.log(check)
            if (check.length > 0) {
                return;
            }
        } catch (e) {
        }
        // console.log(params)

        if (params.mock.kecType == 430 || params.mock.kecType == 641) {
            // params.kvm.hdd = params.mock.diskNum * params.mock.diskSize;
            params.kvm.hdd = params.mock.hdd;
        } else {
            params.kvm.ssd = (commonConst.isCommonModelType(params.mock.kecType) && params.mock.kecType != 357 && params.mock.kecType != 430 && params.mock.kecType != 641 && params.mock.kecType != 668) ? 0 : (params.mock.diskNum * params.mock.diskSize);
        }

        //当切换region时候，需要重新获取最大购买数量
        params.hasQuota = true; //hasQuota参数为true，则是需要请求最大购买数量
        delete params.mock;
        if(this.systemDiskType?.includes('ESSD')){
            const obj = this.systemPerformances.filter(item => {
                return item.value === this.sysPerformanceLevel
            })[0] || {}
            let ret = [
                {
                    key: this.$trans(`数据中心`), //'数据中心',
                    value: regionService.getRegionLocaleTitleByCode(this.regionKeyCheck)
                },
                {
                    key: this.$trans(`类型`), //'类型',
                    value: 'ESSD云硬盘'
                }
            ];
            if(!params.ebsList){
                params.ebsList = []
            }
            params.ebsList.push({
                "billType": this.orderBill == 2017 ? 5 : this.orderBill == 810 ? 87 : this.orderBill,
                "duration": this.orderBill == 2017 ? this.tryOrderDay : this.duration, //*时长
                "durationUnit": this.orderBill == 1 ? '月' : '日', //单位：月
                "size": this.systemDiskSize, //容量大小
                "productType": obj.typeId, // 3 : 高性能，ssd；  4， SATA
                "display": JSON.stringify(ret),
                "count": 1,
                "productWhat": this.orderBill == 2017 ? 2 : 1,
                "volumeType": this.sysPerformanceLevel,
                "volumeId": obj.typeId,
            })
            
        }
        let req = kecAPIs.CalculateKVMPrice({
            params: {
                Region: params.regionKey
            },
            data: params,
        }, {
            noLoading: true
        })

        try {
            return await req;
        } catch (e) {

            //清除 不同套餐规格可购买地区查询弹窗 数据
            this.closeAzSearchData = null
        }

    }


    @debounce(calcPriceDebounceTimer)
    calcuPrice() {
        let reg = /^\d+$/;
        let me = this;
        let diskParam = this._diskParam()
        let param: any = {};
        let _rootDisk = 0;
        let _diskSize = this.diskSize;
        let _diskNum = 1;

        if (this.isShowSlider) {
            _rootDisk = this.systemDiskSize;
        } else {
            if (this.kecType == 357) { //IO优化型I4 固定为50
                _rootDisk = 50;
                _diskSize = 1788;
                // _diskNum = this.cpu / 16;
                _diskNum = this.deviceDiskNum
            } else {
                _rootDisk = this.systemDisk.value;
            }
        }
        let availabilityZone = ''
        if (this.azCode === 'all') {
            availabilityZone = this.checkedRows && this.checkedRows.length && this.checkedRows[0].azCode
        } else {
            availabilityZone = this.azCode
        }
        // if (this.kecType == 430) { //大数据型D4
        //     _diskSize = 7400;
        //     _diskNum = this.cpu / 8;
        // }
        // if (this.kecType == 641) { //大数据型D6
        //     _diskSize = 4*4*1024; //需求是4*4T
        //     _diskNum = this.cpu / 8;
        // }
        let systemDiskType = this.systemDiskType
        if(this.systemDiskType === 'ESSD') {
            systemDiskType = this.sysPerformanceLevel
        }
        let kvm: any = {
            availabilityZone,
            billType: this.orderBill == 2017 ? 5 : this.orderBill || '1',
            duration: this.orderBill == 2017 ? this.tryOrderDay : this.duration,
            durationUnit: this.orderBill == 1 ? '月' : '日',
            count: this.kecCount,
            cpu: this.cpu,
            mem: this.mem,
            opstype: this.isWindows ? 1 : 2,
            ops: this.imageId,
            productType: this.kecType,
            instanceType: _.get(this.checkedRows, "[0].packageCode", ""), //"I1.1A"
            sriovNetSupport: this.generation == 3 ? false : this.isEnhance, //20180419与燕军确认三代机写死传false
            rootDisk: _rootDisk, //系统盘大小
            systemDiskType: systemDiskType //系统盘类型
        };
        param.mock = {
            soldoutList: this.soldoutList, //随机可用区选择子网以后效验云盘是否售罄
            regionKey: this.regionKeyCheck,
            billType: this.orderBill || '1',
            orderBills: this.orderBills,
            kecType: this.kecType,
            kecTypeList: this.kecTypeList,
            hasAz: this.hasAz,
            isEnhance: this.generation == 3 ? false : this.isEnhance, //20180419与燕军确认三代机写死传false
            sysDiskObj: this.sysDiskObj,
            isWindows: this.isWindows,
            diskSize: _diskSize,
            diskNum: _diskNum,
            diskObj: this.diskObj,
            snapInfo: this.snapInfo,
            imageId: this.imageId,
            kecCount: this.kecCount,
            imageObj: this.imageObj,
            cpu: this.cpu,
            mem: this.mem,
            hdd: this.hdd,
            isWin2008: this.isWin2008,
            duration: this.orderBill == 2017 ? this.tryOrderDay : this.duration,
            isUbuntu: this.isUbuntu,
            productType: this.kecType,
            productName: this.kecName,
            tryMoney: this.tryMoney,
            imageType: this.imageType,
            rootDisk: _rootDisk, //系统盘大小
            systemDiskType: systemDiskType,
            startTempData: this.startTempData,
            sourcePage: this.sourcePage,
            theSameConfigData: this.theSameConfigData,
            iscloudMarket: this.iscloudMarket,
            DataDiskPerformanceMode: this.performanceModel
        };
        if (this.isCluster) {
            param.cluster = {
                subnet: this.subnet,
                secgroup: this.secgroup
            }
        }
        if (this.hasAz) {
            param.mock.azCode = availabilityZone;
        }
        if (this.azCode === 'all') {
            param.mock.azCode = '';
            // param.mock.azCodeList = this.imageObj.AvailabilityZone ? [this.imageObj.AvailabilityZone] : _.get(this.checkedRows, "[0].azCodeList", "");
            param.mock.azCodeList = this.imageObj?.AvailabilityZone ? [this.imageObj.AvailabilityZone] : _.get(this.checkedRows, "[0].azCodeList", []);
        }
        if (this.orderBill == 2017) {
            kvm.productWhat = 2;
            let tryOrderDay = this.tryOrderDay + '';
            if (!reg.test(tryOrderDay.trim())) {
                return;
            }
        }
        if (this.isGpu) {
            let _gpu = (this.kecType == 321 || this.kecType == 377) ? '0' : this.gpu; // VGPU默认传0
            kvm.gpu = _gpu;
            param.mock.gpu = _gpu;
            param.mock.isGpu = this.isGpu;
        }
        if (this.hadEbsDisk > 0 && (commonConst.isCommonModelType(this.kecType) || commonConst.is2dataDiskType(this.kecType))) {

            param.ebsList = diskParam.ebsList;
            param.mock.hadEbsDisk = this.hadEbsDisk;
            param.mock.ebsDiskObj = this.ebsDiskObj;
            param.mock.ebsDiskObjs = this.ebsDiskObjs;
            param.mock.ebsDiskSizeList = this.ebsDiskSizeList;
            if (commonConst.is2dataDiskType(this.kecType)) {
                kvm.ssd = diskParam.ssd;
            }
        } else if ((commonConst.isCommonModelType(this.kecType)) && this.hadEbsDisk == 0 && this.kecType != 357 && this.kecType != 668) {
            kvm.ssd = 0;
        } else {
            kvm.ssd = diskParam.ssd;
        }

        if (this.kecType == 430 || this.kecType == 641) {
            // kvm.hdd = _diskNum * _diskSize;
            kvm.hdd = param.mock.hdd;
            delete kvm.ssd;
        }

        // 价格计算器显示用
        param.regionKey = this.regionKeyCheck;
        param.kvm = kvm;
        console.log('param1212:::', param)
        let check = _.filter(kvm, (item, key) => {
            return item === ''
        })

        if (this.onlyCommonConfig) {
            this.$emit('change:param', param);
            this.$emit('change:param:kvm', param);
            this.doCalcPrice(param).then((data) => {
                if (data) {
                    param.priceData = data;
                }

                //清除 不同套餐规格可购买地区查询弹窗 数据
                this.closeAzSearchData = null

                this.$emit('input', param);
            });
        } else {
            // 弹性伸缩需要这些数据来展示右侧信息，即使存在空字段也要触发一个事件
            this.$emit('change:param', param);
            this.$emit('input', param);
        }
        this.kecinfo = param


    }

    // _setMaxReignSnap(regioncode: string) {
    //     var single_region_info = this.regionInfos[regioncode]
    //     this.MaxReignSnap = _.get(single_region_info, 'snapshot_vm_num', 30)
    // }

    $step1valid() {
        var self = this;
        if (this.sourcePage === 'createTheSameConfig') {

            //验证当前系统盘是否售罄
            if (_.get(self.sysDiskObj, 'isSoldOut')) {
                Message.error(this.$trans(`系统盘已售罄，请您选择其他类型`));
                return false
            }

            //未选择镜像时
            if (!_.get(self, 'systemDiskType', '')) {
                Message.error(this.$trans(`请先选择系统盘`));
                return false
            }

            if (this.tipLock) {
                let azCode = _.get(this.theSameConfigData, 'AvailabilityZone');
                let findAZ = _.findIndex(this.azSoldOutArr, (item) => {
                    return item.azCode == azCode;
                });
                if (findAZ != -1) {
                    this.tipLock = false;
                    Message.error(this.$trans(`该可用区下相关机型已售罄`)); //该可用区下相关机型已售罄
                    return false;
                }
            }

            if (this.cpuList.length && !this.searchCPU) {
                Message.error(this.$trans(`所选机型计费方式不存在，请重新选择`));
                return false
            }

            if (self.kecType && self.isSoldOutCheck(self.kecType)) {
                Message.error(this.$trans(`所选机型已售罄，请重新选择`));
                return false;
            }

            const imageId = _.get(this.theSameConfigData, 'ImageId')
            if (!imageId) {
                this.ischooseImage = true
                return false
            }
            //未选择镜像时
            if (this.imageType == 0 && !Object.keys(this.imageObj).length) {
                for (let i = 0, len = this.osImageList.length; i < len; i++) {
                    let obj = _.find(this.osImageList[i].images, (item) => {
                        return imageId === item.value
                    })
                    if (!obj) {
                        this.ischooseImage = true
                        return false
                    } else {
                        break
                    }

                }
            }
            if (this.imageType == 1 && !Object.keys(this.imageObj).length) {
                let obj = _.find(this.diyImgList, (item) => {
                    return imageId === item.value
                })
                if (!obj) {
                    this.ischooseImage = true
                    return false
                }
            }
            if (this.imageType == 3 && !Object.keys(this.imageObj).length) {
                let obj = _.find(this.shareImgList, (item) => {
                    return imageId === item.value
                })
                if (!obj) {
                    this.ischooseImage = true
                    return false
                }
            }
            // if((this.kecType == 628  || this.kecType == 687) && this.ebsSnapList.length){
            if (this.isSupportESSD && this.ebsSnapList.length) {
                if(this.ebsSnapList.some(item => {
                    return item.dataDiskType === 'ESSD' && !item.performanceLevel
                })){
                    Message.error(this.$trans(`该性能模式下的云盘类型已售罄`));
                    return false
                }
            }
            if (Object.keys(self.diskObj).length && !commonConst.isCommonModelType(self.kecType)) {
                return self.diskSize >= self.diskObj.minValue && self.diskSize <= self.diskObj.maxValue
            }

            //通用型选数据盘时

            if ((commonConst.isCommonModelType(self.kecType) || commonConst.is2dataDiskType(this.kecType)) && self.hadEbsDisk > 0) {
                return _.every(self.ebsDiskSizeList, (item, idx) => {
                    return item >= self.ebsDiskObjs[idx].minValue && self.ebsDiskObjs[idx].maxValue >= item
                }) && _.every(self.ebsDiskSizeList, (step) => {
                    return step % 1 == 0
                })
                // } else if(self.kecType != "40" && self.kecType != '137') {
            } else if (!commonConst.isCommonModelType(self.kecType) && !commonConst.is2dataDiskType(this.kecType)) {
                if ($("#disk-error").text().length > 0) {
                    return false;
                } else {
                    return true;
                }
            }
        } else {
            if (!this.hasAz) {
                Message.error('该数据中心机型全部售罄，请选择其他数据中心创建实例')
                return false
            }

            //随机可用区且机型都售罄
            if (this.azCode === 'all' && !this.checkedRows.length) {
                return false
            }
            
            //未选择镜像时
            if (!_.get(self, 'imageId', '')) {
                this.ischooseImage = true
                return false;
            }
            if (self.isSoldOutCheck(self.kecType) || self.kecType === 0) {
                if(self.isSoldOutCheck(self.kecType)){
                    Message.error(this.$trans(`所选套餐规格已售罄，请重新选择`));
                }
                if(self.kecType === 0){
                    Message.error(this.$trans(`请先选择套餐`));
                }
                return false;
            }

            if (!commonConst.isCommonModelType(self.kecType)) {
                return self.diskSize >= self.diskObj.minValue && self.diskSize <= self.diskObj.maxValue
            }
            //未选择镜像时
            if (!_.get(self, 'systemDiskType', '')) {
                Message.error(this.$trans(`请先选择系统盘`));
                return false
            }

            // if(this.kecType == 628 && this.ebsSnapList.length){
            if (this.isSupportESSD && this.ebsSnapList.length) {
                if(this.ebsSnapList.some(item => {
                    return item.dataDiskType === 'ESSD' && !item.performanceLevel
                })){
                    Message.error(this.$trans(`该性能模式下的云盘类型已售罄`));
                    return false
                }
            }
            //通用型选数据盘时

            if ((commonConst.isCommonModelType(self.kecType) || commonConst.is2dataDiskType(this.kecType)) && self.hadEbsDisk > 0) {
                $(".disk-input").valid();
                return _.every(self.ebsDiskSizeList, (item, idx) => {
                    return item >= self.ebsDiskObjs[idx].minValue && self.ebsDiskObjs[idx].maxValue >= item
                }) && _.every(self.ebsDiskSizeList, (step) => {
                    return step % 1 == 0
                })
                // } else if(self.kecType != "40" && self.kecType != '137') {
            } else if (!commonConst.isCommonModelType(self.kecType) && !commonConst.is2dataDiskType(this.kecType)) {
                if ($("#disk-error").text().length > 0) {
                    return false;
                } else {
                    return true;
                }
            }


        }
        if(!this.systemDiskType){
            Message.error(this.$trans('选择系统盘'))
            return false 
        }
        if(this.systemDiskType === 'ESSD' && !this.sysPerformanceLevel){
            Message.error(this.$trans('选择系统盘性能级别'))
            return false 
        }
        return true
    }

    isSoldOutCheck(productTypeId: number) {
        let az = this.azCode;
        let packageCode = _.get(this.checkedRows, "[0].packageCode", "");

        if (_.findIndex(this.soldoutList, item => {
            return item.AvailabilityZone == az && productTypeId == item.ProductType && _.includes(this.allSoldoutPackageMap.get(productTypeId), packageCode)
        }) != -1) {
            return true;
        }
        return false;
    }

    fetchVpcInfo() {
        this.$emit('fetchvpc', '')
    }

    _cloudMarket(regionKey: string) {
        (this.$refs.cloudmarketDia as any).handle("kec", this.kecinfo, regionKey, this.quotaMaxDisk, this.systemDiskMax, this.sysDiskObj);
    }

    isX6EWithEnhanceInAllAZ() {
        return this.kecType === 628 && this.performanceModel === 'enhance' && this.azCode === 'all';
    }

    _setimagesname(data: any) {
        data.title = data.name;
        data.value = data.imageId;
        this.imageObj = data;
        this.imageId = data.imageId;
        this.calcuPrice();
        this._setImageId();
    }

    templateGet(data: any, str: string) {
        return _.get(_.find(data, ["propCode", str]) || {}, 'propValue[0].value', "--")
    }

    _showGpuKe(data: any) {
        let gpu = _.get(_.find(data, ["propCode", "gpu"]) || {}, 'propValue[0].min') || 1;
        let spec = _.get(_.find(data, ["propCode", "spec"]) || {}, 'propValue[0].value');
        if (spec) {
            //G1机型和vGN5机型 gpu使用spec属性
            return spec
        }
        return gpu + "颗"
    }

    _showRemarks(data: any) {
        let cpu = _.get(data, 'cpu');
        let hdd = _.get(data, 'hdd', 0);
        const packageInfo = _.get(data, 'packageInfo', []);
        // let num = 0;
        let num = _.get(_.find(packageInfo, ["propCode", "device_disk_num"]) || {}, 'propValue[0].value') || 1;
        let show = '--';
        if (data.productTypeId == "357") { //IO优化型I4
            // num =  _.get(_.find(packageInfo, ["propCode", "device_disk_num"]) || {}, 'propValue[0].value') || 1;
            show = num + "*1788(NVMe SSD)";
        } else if (data.productTypeId == "430") { //大数据型D4
            // num = cpu / 8;
            // show = num + "*7400(SATA HDD)";
            // num = hdd / 7400;
            show = num + "*7400(SATA HDD)";
        } else if (data.productTypeId == "641") { //大数据型D6
            // num = cpu / 8;
            // show = num * 4 + "*4T(SATA HDD)";
            // num = hdd / (4 * 1024); //hdd除以4T
            show = num + "*4T(SATA HDD)";
        } else if (data.productTypeId == "668") { //IO优化型I6
            // num =  _.get(_.find(packageInfo, ["propCode", "device_disk_num"]) || {}, 'propValue[0].value') || 1;
            show = num + "*960(NVMe SSD)";
        }
        return show;
    }

    @debounce(100)
    _hasCommonDiscount() {
        if (!this.kecType) {
            return;
        }
        //获取通用宿主机套餐
        return kecAPIs.QueryCommonDiscount({
            params: {
                ProductTypeId: this.kecType, //产品类型id
                SceneLimit: 'BUY', //使用场景标识 （标识含义：BUY 购买,RENEW 续费, UPGRADE 更配,TRIAL_TO_BUY 转正）
                Region: this.regionKey,
                AzCodeLimit: this.azCode, //可用区标识 非必填
                PackageLimit: this.memCollect[this.mem] && this.memCollect[this.mem].id, //套餐code 非必填
            }
        }).then((res: any) => {
            let disCountList: any[] = [];
            let tempMenu = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 24, 36]; //对应1，2，3，4，5，6，7，8，9，10，11月，1年，2年，3年
            let discount = 0;
            if (!_.isEmpty(res.data)) {
                let ruleList = res.data[0].event_rule.ruleDetail;
                let discountType = res.data[0].event_rule.discount_type;
                if (discountType == 'SPECIAL_DISCOUNT') { //属于套餐折扣
                    this.hasPackageDiscount = true;
                } else {
                    this.hasPackageDiscount = false;
                }
                _.forEach(tempMenu, (item) => {
                    _.forEach(ruleList, (subItem) => {
                        if (item == subItem.order_full_month) {
                            discount = subItem.order_reduce_discount;
                        }
                    });
                    // 产品规则: 当没有配置当前月份折扣信息时，获取上一个月份的折扣信息，所以此处利用discount变量的缓存机制
                    disCountList.push(discount);
                });
            }
            if (disCountList.length) {
                let _disCountList = [];
                if (this.pageLanguage == 'zh') {
                    _disCountList = disCountList;
                } else {
                    // 如果是英文版 则需要把折扣转换为英文的表述
                    _.forEach(disCountList, (item) => {
                        if (item === 0) {
                            _disCountList.push('')
                        } else {
                            _disCountList.push(100 - item * 10);
                        }

                    });
                }

                this.commonDiscountList = _disCountList;
                this.hasCommonDiscount = true;
            } else {
                this.commonDiscountList = [];
                this.hasCommonDiscount = false;
            }

        }).catch((e: any) => {
            // console.log(e)
            commonAlert.send(e, 'kecDanger');
        });
    }

    calcuKecListPrice(kecList: any[]) {
        // 请求时计入一个时间戳
        let calcuKecListPriceTimestamp = this.calcuKecListPriceTimestamp = Date.now();
        let kvmParams: any[] = [];
        let me = this;
        const ops = this.osImageList?.[0]?.images?.[0]?.value || 'e00e5b9a-0914-4611-8730-3768bf08e035';
        let baseParam = {
            // 参考价格按照镜像不收费计算，由于必须传镜像，暂时写死
            availabilityZone: me.azCode === 'all' ? kecList[0].azCode : me.azCode,
            billType: me.orderBill == 2017 ? 5 : me.orderBill || '1',
            // duration: me.orderBill == 2017 ? me.tryOrderDay : me.duration,
            duration: '1', // 产品确认： 列表页只展示一个月的价格数据
            durationUnit: me.orderBill == 1 ? '月' : '日',
            count: 1,
            opstype: 2,
            ops,
        }
        _.forEach(kecList, (item, idx) => {
            let obj = {
                no: idx,
                availabilityZone: item.azCode,
                cpu: item.cpu,
                mem: item.mem,
                hdd: item.hdd,
                // ssd: item.ssd,
                productType: item.productTypeId,
                instanceType: item.packageCode,
                sriovNetSupport: item.productTypeName.indexOf("联网增强") != -1 ? true : false,
                // rootDisk: 20,
                // systemDiskType: "Local_SSD",
            }
            kvmParams.push(obj);
        })
        let params = {
            baseParam: baseParam,
            kvmParams: kvmParams
        }


        return kecAPIs.BatchCalculateKVMPrice({
            // params: params,
            params: {
                Region: me.regionKeyCheck
            },
            data: params
        }, {
            noLoading: true,
        }).then((res: any) => {
            // 本次请求的时间戳与全局时间戳不匹配，则忽略掉这次请求
            if (calcuKecListPriceTimestamp !== this.calcuKecListPriceTimestamp) {
                // console.log(res, 1111)
                return;
            }
            if (res.code == 200) {
                let _pageKecList = this.pageKecList;
                _.forEach(res.CalculatePriceSet, item => {
                    let obj = _pageKecList[item.no];
                    obj.price = item.message.price;
                    obj.originalPrice = _.get(item, 'message.totalPriceDetails.originalPrice', 0);
                    obj.kvmPrice = item.message.kvmPrice;
                    obj.kvmSpotPrice = item.message.kvmSpotPrice;
                    me.$set(me.pageKecList, item.no, obj);

                });
            }
        }).catch((e: any) => {
            console.log(e)
        })

    }
    @debounce(debounceTimer)
    feachAssembledImageMeta() {
        let SnapshotSet = _.get(this.imageObj, 'SnapshotSet', []);
        let dataDisks = [];
        let localSnapshot = [];
        let dataDiskSet = _.get(this.startTempData, 'DataDiskSet') || _.get(this.theSameConfigData, 'DataDisks') || {};
        const imageId = _.get(this.startTempData, 'ImageId', '') || _.get(this.theSameConfigData, 'ImageId', '');
        if (dataDiskSet.length && imageId == this.imageId) {
            dataDisks = dataDiskSet;
        } else {
            if (SnapshotSet && SnapshotSet.length) {
                dataDisks = _.filter(SnapshotSet, (item) => {
                    return item.Type == "data";
                });
            }
        }

        if (this.kecType && dataDisks.length && (this.imageType == 1 || this.imageType == 3)) { //暂时只开放自定义镜像、共享镜像 支持整机镜像
            if (!commonConst.isCommonModelType(this.kecType)) {
                localSnapshot = _.filter(dataDisks, (item) => {
                    return item.DiskType == "local_snapshot";
                });
                let noLocalSnapshot = _.filter(dataDisks, (item) => {
                    return item.DiskType != "local_snapshot";
                });

                dataDisks = noLocalSnapshot;
                if (localSnapshot && localSnapshot.length) {
                    this.diskSize = _.get(localSnapshot, '[0].DiskSize', 0);
                    this.canSnapCreateDisk = false;
                    this.snapInfo = {
                        snapChoose: true,
                        snapName: _.get(localSnapshot, '[0].SnapshotId'),
                        snapCpacity: _.get(localSnapshot, '[0].DiskSize'),
                        showDelete: false,
                        snapId: _.get(localSnapshot, '[0].SnapshotId'),
                    }
                } else {
                    this.canSnapCreateDisk = true;
                    this.snapInfo = {
                        snapChoose: false,
                        snapName: '',
                        snapCpacity: '',
                        showDelete: true,
                        snapId: ''
                    }
                }
            }
            this.assembledImageMetaNum = dataDisks.length;
            this.snapCreateDiskList(dataDisks, {
                isFromWhere: 'isAllImage',
                localSnapshot: localSnapshot.length ? localSnapshot : dataDisks
            });
        } else {
            // // this.diskSize = 0;
            this.canSnapCreateDisk = true;
            this.snapInfo = {
                snapChoose: false,
                snapName: '',
                snapCpacity: '',
                showDelete: true,
                snapId: ''
            }
            this.diskObj.minValue = 0
            this.assembledImageMetaNum = 0;
            // this.ebsDiskSizeList = [];
            // this.delWithInsList = [];
            // this.hadEbsDisk = 0;
            // this.ebsDiskObjs = [];
            // this.ebsSnapList = [];
            var hadEbsNum = this.hadEbsDisk
            let list = _.cloneDeep(this.ebsSnapList)

            let ebsDiskSizeList: any = []
            let delWithInsList: any  = []
            let ebsDiskObjs: any  = []
            let ebsSnapList: any  = []
            _.forEach(list, (item, index) => {
                if (!item.isWholeMirror) {
                    ebsDiskSizeList.push(this.ebsDiskSizeList[index])
                    delWithInsList.push(this.delWithInsList[index])
                    ebsDiskObjs.push(this.ebsDiskObjs[index])
                    ebsSnapList.push(this.ebsSnapList[index])
                } else {
                    hadEbsNum = hadEbsNum - 1 < 0 ? 0 : hadEbsNum - 1
                }

            })
            this.ebsDiskSizeList = ebsDiskSizeList
            this.delWithInsList = delWithInsList
            this.ebsDiskObjs = ebsDiskObjs
            this.ebsSnapList = ebsSnapList
            if(!dataDisks.length){
                this.__dataDisks = [] //解决挂载上一个镜像是整机镜像，在请求的数据没有返回之前切换到了普通镜像，回显上一个整机镜像数据盘的问题
            }
            this.$set(this, 'hadEbsDisk', hadEbsNum);
        }
    }

    moreOptions() {
        this.isMoreOptions = !this.isMoreOptions;
    }

    kecDisabled() {
        // 售罄及一些特殊情况禁用
        let me = this;
        if (this.azCode === 'all') {
            let list = JSON.parse(JSON.stringify(this.kecTypeList))
            _.forEach(me.soldoutArr, (soldoutItem, index) => {
                list.filter((item: any) => {
                    return item.azCode === soldoutItem.az
                }).forEach((item: any) => {
                    let allPackageSet: any[] = []
                    let soldoutkecPackageSet = soldoutItem.kecPackage
                    let newArray = Array.from(soldoutkecPackageSet);

                    _.forEach(newArray, (item) => {
                        allPackageSet = allPackageSet.concat(item);
                    });

                    // if (allPackageSet && allPackageSet.includes(item.packageCode)) {
                    if (
                        soldoutkecPackageSet.has(item.productTypeId)
                        && _.includes(soldoutkecPackageSet.get(item.productTypeId), item.packageCode)
                    ) {
                        item.disabled = true;
                    } else {
                        item.disabled = false;
                    }
                })
            })
            let arr: any[] = []
            _.forEach(list, item => {
                const obj = _.find(arr, o => o.kecKey === item.kecKey)
                const index = _.findIndex(arr, o => o.kecKey === item.kecKey)
                item.azCodeList = []
                item.soldoutAzCodeList = []

                if (obj) {
                    if (obj.disabled) {
                        item.azCodeList.push(item.azCode)
                        arr[index] = item
                    } else if (!item.disabled) {
                        arr[index].azCodeList.push(item.azCode)
                    }
                } else {
                    item.azCodeList.push(item.azCode)
                    arr.push(item)
                }
            })
            this.kecTypeList = arr
        } else {
            // let soldoutKecSet = _.get(_.find(me.soldoutArr, item => item.az == this.azCode) || {}, "kec", "")
            let soldoutkecPackageMap = _.get(_.find(me.soldoutArr, item => item.az == this.azCode) || {}, "kecPackage", new Map());
            // let allPackageSet: any[] = [];
            // let newArray = Array.from(soldoutkecPackageSet);
            // _.forEach(newArray, (item: any) => {
            //     allPackageSet = allPackageSet.concat(item[1]);
            // });

            this.allSoldoutPackageMap = soldoutkecPackageMap;

            // if (allPackageSet.length) {
            //     _.forEach(this.kecTypeList, item => {
            //         console.log('item:::', item)
            //         if (_.includes(allPackageSet, item.packageCode)) {
            //             item.disabled = true;
            //         } else {
            //             item.disabled = false;
            //         }
            //     })
            // }
            if (soldoutkecPackageMap.size){
                _.forEach(this.kecTypeList, item => {
                    if (
                        soldoutkecPackageMap.has(item.productTypeId) 
                        && _.includes(soldoutkecPackageMap.get(item.productTypeId), item.packageCode)
                    ) {
                        item.disabled = true;
                    } else {
                        item.disabled = false;
                    }
                })
            }
        }

    }

    // kecListBoxWidthFun() {
    //     this.kecListBoxWidth = $('.create-options').width() - 85 - 10;
    // },
    //售罄判断
    isSoldOut(soldoutlist: any[], nowitem: any, typeCode: string) {
        if (_.findIndex(soldoutlist, (item) => {
            return _.get(item, typeCode, '') == nowitem;
        }) != -1) {
            return true;
        }
        return false;
    }


    // rework
    billTypeChangeEventHandler(billType: any) {
        this.orderBill = billType
    }

    regionChangeHandler(regionCode: string) {
        this.regionKeyCheck = regionCode
        if(this.imageType === 4){ 
            // 解决在一个region选中市场镜像，但是切换了region之后，当前region没有市场镜像，但是原来的值还存在的bug
            // 直接清空镜像
            this.imageObj = {}
        }
    }

    azChangeHandler(azCode: string) {
        this.azCode = azCode;
    }

    tryDoChunkRework(arr: any[]) {
        let num = this.pageLanguage === 'zh' ? 9 : 6; //UI设计：中文版和英文版展示region数量有差异
        return _.chunk(arr || [], num)
    }


    get secNetCheck() {
        return _.filter(this.secNet, ['AvailabilityZoneName', this.azCode]);
    }


    get isSoldOutType() {
        //计算优化C1
        return this.kecType == 42;
    }

    get isKs3Region() {
        //KS3机房限制流量，新建批量最多一次4个（自定义镜像开机和快照开机）
        let hasEbsSnap = _.some(this.ebsSnapList, ['snapChoose', true]);
        return this.isKs3SnapLimit && (this.imageType == 1 || this.snapInfo.snapChoose || hasEbsSnap);
    }

    get isKs3SnapLimit() {
        //是否有机房限制信息
        return _.get(this.regionInfos[this.regionKeyCheck], 'snapshot_vm_num', false);
    }

    get systemDiskDisabeld() {
        return !commonConst.isCommonModelType(this.kecType) || this.systemDiskTypes.length === 1
    }

    get discountList() {
        //从接口获取通用列表数据
        return this.commonDiscountList;

    }
    
    // },
    // watch: {
    @Watch('ebsSnapList', {
        deep: true,
    })
    ebsSnapListWatcher(val: any) {
        // debugger
        let oldVal = this.oldEbsSnapList;

        if (oldVal && oldVal.length === val.length) {

            val.forEach((item: any, index: any) => {
                // if (this.kecType == 628 || this.kecType == 687) { //极速云盘型X6E 和 性能保障型X7

                let newIsEBS3or4 = item.dataDiskType == "SSD3.0" || item.dataDiskType == "EHDD" || item.dataDiskType?.includes("ESSD");
                let oldIsEBS3or4 = oldVal[index].dataDiskType == "SSD3.0" || oldVal[index].dataDiskType == "EHDD" || oldVal[index].dataDiskType?.includes("ESSD");
                let isWholeImageSnapDisk = index < this.assembledImageMetaNum;
                let isLocalImage = this.imageObj?.Type == "LocalImage"


                // 如果老的或新的不是ebs3.0, 或者不是整机镜像平铺的盘，或者当前是极速整机镜像，就正常处理
                let notKeepSnapSelection = !newIsEBS3or4 || !oldIsEBS3or4 || !isWholeImageSnapDisk || isLocalImage

                if (item.dataDiskType?.includes('ESSD')) {
                    const oldItem = oldVal[index];
                    const isChangeType = item.dataDiskType !== oldItem.dataDiskType;
                    if (item.performanceLevel !== oldItem.performanceLevel || isChangeType) {

                        if (!item.performanceLevel) {
                            let availableLevels = _.find(this.notSoldOutPerformanceLevels, ['chooseDisabled', false])
                            item.performanceLevel = _.get(availableLevels, 'value');
                        }

                        let levels = _.filter(this.notSoldOutPerformanceLevels, (j) => {
                            return j.value == item.performanceLevel
                        });


                        if (levels && levels.length) {
                            item.productType = levels[0].typeId;
                        }

                        let minValue = levels[0].minValue;
                        if (item.snapChoose) {
                            if (item.snapCpacity > minValue) {
                                minValue = item.snapCpacity
                            }
                        }

                        let ebsDiskTypes: any = {
                            value: 'ESSD',
                            performanceLevel: levels[0].value,
                            productType: levels[0].typeId,
                            title: this.ebsNameMap['ESSD'],
                            minValue: minValue,
                            maxValue: levels[0].maxValue,
                            stepValue: levels[0].stepValue,
                            isNotSupportEBS: false
                        };
                        if (!notKeepSnapSelection) {
                            ebsDiskTypes.snapChoose = oldVal[index].snapChoose
                            ebsDiskTypes.snapCpacity = oldVal[index].snapCpacity
                            ebsDiskTypes.snapName = oldVal[index].snapName
                            ebsDiskTypes.snapshotId = oldVal[index].snapshotId


                        }
                        const copy = _.cloneDeep(ebsDiskTypes)
                        this.$set(this.ebsDiskSizeList, index, minValue)
                        this.$set(this.ebsDiskObjs, index, copy)
                        if (isChangeType && notKeepSnapSelection) {
                            this._snapCancelEbs(index);
                        }
                        setTimeout(() => {
                            let ele = $(this.$el).find('[name="ebsDisk' + index + '"]');
                            ele && ele.length && ele.valid();
                        }, 200);
                    }

                } else {
                    // console.log(oldVal[index], 1111111)
                    if (item.dataDiskType !== oldVal[index].dataDiskType) {

                        // 如果老的或新的不是ebs3.0, 或者不是整机镜像平铺的盘，或者当前是极速整机镜像，就正常处理
                        if (notKeepSnapSelection) {

                            item.snapChoose = false
                            item.snapCpacity = ''
                            item.snapName = ''
                            item.snapshotId = ''
                            let obj = this.ebsDiskTypes.filter(i => {
                                return i.value === item.dataDiskType
                            })[0]
                            // console.log(obj, 234)
                            const copy = _.cloneDeep(obj)
                            this.$set(this.ebsDiskObjs, index, copy)
                            this._snapCancelEbs(index);
                        } else {

                            // 如果
                            let obj = this.ebsDiskTypes.filter(i => {
                                return i.value === item.dataDiskType
                            })[0]
                            // console.log(obj, 234)

                            const copy = _.cloneDeep(obj)
                            copy.snapChoose = item.snapChoose
                            copy.snapCpacity = item.snapCpacity
                            copy.snapName = item.snapName
                            copy.snapshotId = item.snapshotId || item.snapId
                            if (item.snapChoose && (!copy.minValue || item.snapCpacity > copy.minValue)) {
                                copy.minValue = item.snapCpacity;
                            }
                            this.$set(this.ebsDiskObjs, index, copy)



                            this.calcuPrice()
                        }
                        // if (item.dataDiskType == "SSD3.0" ||)

                        // console.log(this.imageObj, 1111)

                    }
                }
                setTimeout(() => {
                    let ele = $(this.$el).find('[name="ebsDisk' + index + '"]');
                    ele && ele.length && ele.valid();
                }, 200);
            })
        }
        this.oldEbsSnapList = _.cloneDeep(val)
    }

    @Watch('discountList')
    discountListWatcher() {
        if (this.sourcePage == 'modifyTemplate' || this.sourcePage == 'buyTemplate') {
            this.orderBill = _.get(this.startTempData, 'OrderInfo.BillType');
            if (this.orderBill == 1) {
                const duration = _.get(this.startTempData, 'PurchaseTime', '1').toString();
                this.changeBuyData({
                    duration
                })
            }
        } else {
            this.changeBuyData()
        }
    }

    @Watch('isAs')
    @Watch('showBuyVolume')
    @Watch('isKs3Region')
    onlyChangeBuyDataWatcher() {
        this.changeBuyData()
    }

    @Watch('computedPrice')
    computedPriceWatcher(val: any) {
        if (val.kvmSpotCpuMemOriginPrice && this.changeUserPrice) {
            this.changeUserPrice = false
            this.userPrice = val.kvmSpotCpuMemOriginPrice
        }
    }

    @Watch('orderBill')
    orderBillWatcher(val: any) {
        if (val == 810) {
            // this.kecCount = 1
            this.changeBuyData({kecCount: 1})
        } else {
            this.changeBuyData()
        }
        this._orderBillChange();
    }

    @Watch('regionKeyCheck')
    regionKeyCheckWatcher() {
        this.$emit('regionChange', this.regionKeyCheck)
        if (this.orderBills.length == 0) return;
        this._regioChange();
        if (!this.isCluster) {
            this._fetchOSImage(this.regionKeyCheck); //标准镜像
            this._fetchDiyImg(this.regionKeyCheck); //自定义镜像
            this._fetchShareImg(this.regionKeyCheck)
            this._snapCancel();
        }
    }

    @Watch('azCode')
    azCodeWatcher() {
        this._fetchCpuList();
    }

    @Watch('searchCPU')
    searchCPUWatcher() {
        // console.log(this, 11111)
        this._fetchMemList();
    }

    @Watch('searchMEM')
    searchMEMWatcher() {
        this._fetchIpv6List();
    }

    @Watch('searchIPV6')
    searchIPV6Watcher() {
        this._fetchArchList()
    }

    @Watch('architecture')
    architectureWatcher() {
        this._fetchSortsType();
    }

    @Watch('sort')
    sortWatcher() {
        if (this.azCode === 'all') {
            this.kecKey = ''
            this.checkedRows = []
        }
        this._fetchKecTypeList();
        this._setCanSnapCreate();
        this._snapCancel();
    }

    @Watch('kecType')
    kecTypeWatcher(val: any) {
        if (!this.isCluster && val) {
            this.generation = _.filter(this.kecTypeList, ['productTypeId', val])[0].generation; //设置当前机型对应的系列
            this._fetchImageTypeList();
        }

        this._setCanSnapCreate();
        this._snapCancel();
    }

    @Watch('isGpu')
    isGpuWatcher(val: any) {
        if (val) {
            this._snapCancel();
        }
    }

    @Watch('secgroupId')
    secgroupIdWatcher() {
        this.secgroup = _.find(this.secGroup, ['SecurityGroupId', this.secgroupId]);
    }

    @Watch('subnetId')
    subnetIdWatcher() {
        this.subnet = _.find(this.secNetCheck, ['SubnetId', this.subnetId])
    }

    @Watch('snapEbsPage')
    snapEbsPageWatcher(val: any, old: any) {
        val.current != old.current ? this._snapCreateEbs() : undefined;
        val.rowsPerPage != old.rowsPerPage ? (this.snapEbsPage.current = 1, this._snapCreateEbs()) : undefined;
    }

    @Watch('secgroup')
    secgroupWatcher() {
        this.calcuPrice();
    }


    @Watch('subnet')
    subnetWatcher() {
        this.calcuPrice();
    }

    @Watch('snapPage')
    snapPageWatcher(val: any, old: any) {
        val.current != old.current ? this._snapCreate() : undefined;
        val.rowsPerPage != old.rowsPerPage ? (this.snapPage.current = 1, this._snapCreate()) : undefined;
    }

    @Watch('tryOrderDay')
    tryOrderDayWatcher() {
        this.calcuPrice();
    }

    @Watch('imageType')
    imageTypeWatcher() {
        this.imageId = '';
        this.imageObj = {};
        // this.ks3ImgLimit();
        this._setImageId();
        this.calcuPrice();
    }

    @Watch('imageId')
    imageIdWatcher(val: any) {
        if (this.imageType == 0) {
            for (let i = 0, len = this.osImageList.length; i < len; i++) {
                let obj = _.find(this.osImageList[i].images, (item) => {
                    return val === item.value
                })
                this.imageObj = obj
                if (obj) {
                    return
                }

            }
        }
        if (this.imageType == 1) {
            let obj = _.find(this.diyImgList, (item) => {
                return val === item.value
            })
            this.imageObj = obj
            if (obj) {
                return
            }
        }
        if (this.imageType == 3) {
            let obj = _.find(this.shareImgList, (item) => {
                return val === item.value
            })
            this.imageObj = obj
            if (obj) {
                return
            }
        }
    }

    @Watch('imageObj')
    imageObjWatcher(val: any) {
        this.iscloudMarket = false;
        if (val && Object.keys(val).length) {
            this.ischooseImage = false
        }
        if (!_.isEmpty(val) && !this.isCluster) {
            if (this.imageType == 1 || this.imageType == 3) {
                if (_.get(val, 'IsCloudMarket', '')) {
                    this.iscloudMarket = true
                }
            }
            // if (this.sourcePage == 'imageView') {
            //     let imageViewData = JSON.parse(localStorage.getItem('imageViewData') || '');
            //     let imageId = _.get(val, 'ImageId', '');
            //     if (!imageViewData && imageId != this.diyImageId) {
            //         this.sourcePage = '';
            //     }
            // }
            if (this.sourcePage == 'imageView' || this.sourcePage == 'osImageView') {
                let imageViewData
                try {
                    imageViewData = this.sourcePage == 'imageView' ? JSON.parse(localStorage.getItem('imageViewData') || '') : JSON.parse(localStorage.getItem('osImageViewData') || '');
                } catch (e) {
                }
                const getImageId = this.sourcePage == 'imageView' ? this.diyImageId : this.osImageId
                let imageId = ''
                if (this.sourcePage == 'imageView') {
                    imageId = _.get(val, 'ImageId', '');
                } else {
                    imageId = _.get(val, 'imageId', '');
                }
                if (!imageViewData && imageId != getImageId) {
                    this.sourcePage = '';
                }
            }


            this.feachAssembledImageMeta();
            this._setImageId();

            // 本地镜像 只支持SSSD3.0
            if (this.systemDiskTypesCopy.length) {
                let systemDiskTypes = _.cloneDeep(this.systemDiskTypesCopy);
                //兼容 随机可用区需求
                let isSameAzCode = false
                if (this.azCode === 'all') {
                    isSameAzCode = this.checkedRows[0].azCodeList.includes(_.get(val, 'AvailabilityZone')) ? true : false
                } else if (_.get(val, 'AvailabilityZone') == this.azCode) {
                    isSameAzCode = true
                }

                if (_.get(val, 'Type') == 'LocalImage' && isSameAzCode && (this.imageType == 1 || this.imageType == 3)) {
                    let tempObj = _.filter(systemDiskTypes, (item) => {
                        return item.value == 'SSD3.0';
                    }) || {};
                    this.systemDiskTypes = tempObj;
                    this.sysDiskObj = tempObj[0];
                    this.systemDiskType = tempObj[0].value;
                } else {
                    this.systemDiskTypes = systemDiskTypes;
                    const sysDiskObj = _.filter(systemDiskTypes, item => {
                        return !item.isSoldOut && !item.isNotSupportEBS
                    })[0] || {}
                    this.sysDiskObj = sysDiskObj;
                    this.systemDiskType = sysDiskObj.value;
                }
            }
        }
        this.calcuPrice();
    }

    @Watch('kecCount')
    kecCountWatcher() {
        this.calcuPrice();
    }


    @Watch('diskSize')
    diskSizeWatcher() {
        if (!commonConst.isCommonModelType(this.kecType)) {
            this.$nextTick(() => {
                if ($(this.$el).find('[name="disk"]').valid()) {
                    this.calcuPrice();
                }
            });
        }
    }

    @Watch('ebsDiskObj')
    ebsDiskObjWatcher() {
        this.calcuPrice();
    }


    @Watch('ebsDiskObjs')
    ebsDiskObjsWatcher() {
        this.calcuPrice();
    }

    @Watch('ebsDiskSizeList')
    ebsDiskSizeListWatcher() {

        var l = this.hadEbsDisk;
        if (l > 0) {
            for (var i = 0; i < l; i++) {
                try {
                    var ele = $(this.$el).find('[name="ebsDisk' + i + '"]');
                    if (ele) {
                        ele && ele.length && ele.valid();
                    }
                } catch (e) {

                }

            }
        }
    }

    @Watch('delWithInsList')
    delWithInsListWatcher(val: any) {
        if (val) {
            this._diskParam();
            this.calcuPrice();
        }
    }

    @Watch('systemDiskSize')
    systemDiskSizeWatcher(val:any) {
        const sysType =  _.get(this.sysDiskObj, 'value', '')
        if (sysType !== 'ESSD' && this.systemDiskSize < this.systemDiskObj.minValue) {
            this.systemDiskSize = this.systemDiskObj.minValue
        }
        this.calcuPrice();
    }
    @Watch('bindCloudServerDel')
    bindCloudServerDelWatcher(val: any) {
        val ? this.bindCloudServerDel = val : '';
        this.calcuPrice();
    }

    @Watch('systemDiskType')
    systemDiskTypeWatcher(val: any) {
        this.sysDiskObj = this.systemDiskTypes.filter(item => {
            return item.value === val
        })[0]
    }

    @Watch('sysDiskObj')
    sysDiskObjWatcher(val: any) {
        // console.log(val, 1111)
        if (val) {
            this.systemDiskType = val.value;
        } else {
            return;
        }
        this.feachAssembledImageMeta();

        if (/local/i.test(val.value) && this.kecType == 357) {
            this.isShowSlider = false;
        } else {
            this._setIsShowSlider();
        }
        // 由于I4支持ebs，且local不支持可变，如果切换系统盘类型，需要判断一下镜像是否依然可用
        this._setImageId();
        this.calcuPrice();
    }

    @Watch('hadEbsDisk')
    hadEbsDiskWatcher(val: number) {
        // 可添加的云盘数据盘数量
        this.canAddEbsNum = (this.maxEbsNum - val)
    }

    @Watch('performanceModel')
    performanceModelWatcher(val: string){
        // if(this.kecType !== 628 && this.kecType !== 687){
        if (!this.isSupportESSD) {
            if (this.azCode === 'all') {
                this.ebsSnapList = [];
                this.ebsDiskSizeList = [];
                this.ebsDiskObjs = [];
                this.hadEbsDisk = 0;
                this.calcuPrice()
            }

            return
        }


        // X6E选了增强型，如果当前选中的是自定义镜像 或者 共享镜像 就强制选标准镜像第一个
        // && this.performanceModel === 'enhance' 
        // 无论怎么选都重置 (否则很难处理)
        if (this.kecType == 628 && (this.imageType == 1 || this.imageType == 3)) {
            this.imageType = 0
        }

        this.performanceLevels.forEach(item => {
            item.chooseDisabled = false
            item.tips = ''
            // if(val === 'enhance' && item.value === 'PL3'){
            //     item.isSoldOut = true
            // }
            if (val === 'enhance' && (item.value === 'PL0' || item.value === 'PL1' || item.value === 'PL2')) {
                item.chooseDisabled = true
                item.tips = this.$trans('若需挂载PL0、PL1、PL2级别ESSD，请选择性能模式为“标准型”')
            } else if (val === 'standard' && item.value === 'PL3') {
                item.chooseDisabled = true
                item.tips = this.$trans('若需挂载PL3级别ESSD，请选择性能模式为“增强型”')
            }
        })
        this.supportPerformanceLevelsList = _.filter(this.notSoldOutPerformanceLevels, (item) => {
            return !item.chooseDisabled;
        }) || [];
        let notSoldOutLevel = _.find(this.supportPerformanceLevelsList,item => item.value === 'PL1');
        if(_.isEmpty(notSoldOutLevel)) {
            notSoldOutLevel = this.supportPerformanceLevelsList[0]
        }
        this.ebsSnapList.forEach((item, index) => {
            item.performanceLevel = notSoldOutLevel?.value;
            // 切到增强型，由于增强型不支持混挂，需要将快照删除
            if (!item.dataDiskType.includes('ESSD')) {
                this._snapCancelEbs(index);
            }
            item.dataDiskType = 'ESSD';
        })

        this.ebsSupport = [{
            value: 'ESSD',
            performanceLevel: notSoldOutLevel?.value,
            productType: notSoldOutLevel?.typeId,
            title: this.ebsNameMap['ESSD'],
            minValue: notSoldOutLevel?.minValue,
            maxValue: notSoldOutLevel?.maxValue,
            stepValue: notSoldOutLevel?.stepValue,
            isNotSupportEBS: false
        }];
        if (val === 'enhance') {
            this.ebsDiskTypes = this.ebsSupport;
        } else {
            // 非增强型的x6e，要恢复ebsSupport
            this.ebsDiskTypes = this.ebsSupportAll;
            this.ebsSupport = this.ebsSupportAll;
        }
        this.ebsDiskObj = _.find(this.ebsSupport, item => !item.isSoldOut);

        this.calcuPrice()
    }

    @Watch('sysPerformanceLevel')
    sysPerformanceLevelWatcher(){
        this._getESSDSyeMinAndMax()
        this.calcuPrice()
    }
    @Watch('describeEbsPerfQuotasObj', {
        deep: true,
    })
    describeEbsPerfQuotasObjWatcher(val: any){
        if(this.systemPerformances.length){
            this.systemPerformances.forEach(item => {
                const iopsSec = this._getIops(item.value)
                const bytesSec = this._getByte(item.value)
                item.title =  this.$trans(`{0}（单盘性能上限IOPS：{1}万 吞吐量：{2}MB/s）`, item.value, iopsSec.Max/10000, bytesSec.Max)
            })
        }
        if(this.performanceLevels.length){
            this.performanceLevels.forEach(item => {
                const iopsSec = this._getIops(`ESSD_${item.value}`)
                const bytesSec = this._getByte(`ESSD_${item.value}`)
                item.title =  this.$trans(`{0}（单盘性能上限IOPS：{1}万 吞吐量：{2}MB/s）`, item.value, iopsSec.Max/10000, bytesSec.Max)
            })
        }
    }
}
